export const cz: { [key: string]: string } = {
  subscribe_with_click: 'Přihlásit se jedním kliknutím',
  subscribe: 'Přihlásit se jedním kliknutím',
  minimum_number_characters: 'minimálně 2 znaky',
  request_details: 'Podrobnosti požadavku',
  form_title: 'Brzy se vám ozveme',
  form_required: 'Pole označená * jsou povinná',
  form_name_placeholder: 'Jméno',
  form_email_placeholder: 'E-mail',
  form_phone_placeholder: 'Telefonní číslo',
  form_company_placeholder: 'Společnost',
  form_submit: 'Odeslat',
  form_1: 'Souhlasím se zpracováním osobních údajů v souladu se',
  form_2: 'Zásadami ochrany osobních údajů',
  validation_privacy_policy: 'Přijměte prosím Zásady ochrany osobních údajů',
  validation_phone: 'Telefonní číslo není platné',
  validation_email: 'Neplatný formát e-mailu',
  validation_required: 'Povinná pole nejsou vyplněna',
  submit_error: 'Při ukládání formuláře došlo k chybě',
  footer_1: 'Naši partneři:',
  footer_2: 'Metody',
  footer_3: 'Produkty',
  footer_4: 'Kontakty:',
  footer_5: 'Impressum',
  footer_6: 'Zásady ochrany osobních údajů',
  footer_7: 'Průzkum trhu',
  about_us_1: 'Společenská odpovědnost společnosti 4Service',
  about_us_2:
    'Vychází ze srdce a duše každého člena našeho týmu. Děláme vše pro to, aby v každém zaměstnanci zůstala jiskra laskavosti a aby byl svět kolem nás o něco lepší.',
  about_us_3: 'Společenská odpovědnost společnosti 4Service',
  about_us_4:
    'Vychází ze srdce a duše každého člena našeho týmu. Děláme vše pro to, aby v každém zaměstnanci zůstala jiskra laskavosti a aby byl svět kolem nás o něco lepší.',
  about_us_5: 'Obchodní hra Service Mania',
  about_us_6: 'Naše vzdělávací iniciativy pro děti a studenty',
  about_us_7: 'Charita / Dobrovolnictví',
  about_us_8:
    'Dětské domovy, domovy pro seniory a dobrovolnická pomoc ukrajinské armádě. Nejemotivnější část našich aktivit.',
  about_us_9: 'Péče o zvířata',
  about_us_10:
    'Kdokoli může přijít do naší kanceláře se svým domácím mazlíčkem. Pomáháme útulkům, organizujeme sbírky na krmivo a někdy také hledáme domov pro opuštěná zvířata.',
  about_us_11: 'Skupina 4Service',
  about_us_12:
    'Je mezinárodní výzkumná společnost zaměřená na řízení zákaznické zkušenosti.',
  about_us_13:
    'Realizujeme komplexní projekty zaměřené na zvýšení prodeje a rozvoj podnikání zákaznicky orientovaných společností.',
  about_us_14:
    'Je mezinárodní výzkumný holding se sídlem ve Vídni v Rakousku. Společnost byla založena v roce 2001 s cílem zlepšovat kvalitu života svých klientů i lidí, kteří komunikují s podniky, využívají jejich služby a spotřebovávají jejich produkty. Název „Forservice“ nebyl zvolen náhodou – představuje zákaznický servis a vysokou kvalitu.',
  about_us_15:
    'Tak začala historie společnosti 4Service v Kyjevě na Ukrajině jako předního poskytovatele služeb mystery shoppingu. Dnes úspěšně působí jako výzkumná společnost ve 52 zemích a nabízí nové možnosti komplexního přístupu k analýze a zlepšování celé cesty zákaznické zkušenosti.',
  about_us_16: 'zrozeno ve jménu služeb',
  about_us_17: 'první kancelář mimo Ukrajinu',
  about_us_18: 'přesun sídla do Vídně',
  about_us_19: 'elitní člen MSPA, agentura v TOP 10 v Evropě',
  about_us_20: 'založení kanceláří v 9 zemích',
  about_us_21: 'první digitální projekty, Voicer',
  about_us_22: 'partneři DesignThinkers Academy',
  about_us_23: 'první globální projekty CX',
  about_us_24: 'Mise',
  about_us_25:
    'Naším posláním je zlepšovat zákaznický servis po celém světě! Inspirují nás pozitivní změny, které vidíme u lidí a společností, se kterými spolupracujeme.',
  about_us_26: 'Více než 20 let zkušeností v oblasti Customer Experience',
  about_us_27: '95 zemí',
  about_us_28:
    'Shromažďujeme a sdílíme nejlepší zkušenosti z oboru z celého světa',
  about_us_29: 'Hlavní kancelář ve Vídni',
  about_us_30:
    'zemí. Shromažďujeme a sdílíme nejlepší zkušenosti z oboru z celého světa',
  about_us_31: 'hodnocení kvality služeb',
  about_us_32: 'patříme mezi TOP 10 evropských CX agentur',
  about_us_33: 'zastoupení / centrála v Rakousku',
  about_us_34: 'aktivní projekty',
  about_us_35: 'Vaše budoucí pracoviště',
  about_us_36: 'Naše kanceláře',
  about_us_37:
    'Společnost 4Service™ vytváří pohodlné pracovní prostředí pro své zaměstnance. Nabízíme práci na pracovišti, na dálku i v hybridním režimu podle toho, co nejlépe vyhovuje produktivitě a pohodlí každého zaměstnance. K dispozici jsou relaxační zóny, bezplatná psychologická podpora a přátelské prostředí. Jsme otevření lidem i jejich domácím mazlíčkům.',
  about_us_38: 'Tým, který inspiruje',
  about_us_39:
    'Náš mezinárodní tým se zaměřuje na naslouchání, přijímání zpětné vazby od zákazníků a společný růst. Cesta zákazníka s námi je pro naše podnikání stejně důležitá jako uvádění nových produktů nebo plnění finančních cílů. Naše aktivity mají pozitivní dopad na komunity kolem nás a přinášejí inovace a řešení zaměřená na lidi.',
  about_us_40: 'Vše',
  about_us_41: 'Vedení',
  about_us_42: 'Globální tým',
  about_us_43: 'Produktoví vlastníci',
  about_us_44: 'Naši partneři',
  about_us_45:
    'Realizujeme komplexní projekty zaměřené na zvýšení prodeje a rozvoj podnikání zákaznicky orientovaných společností',
  about_us_46:
    'je jedním z předních profesionálních vzdělávacích institutů založených na principu „design driven“, zastoupeným ve 25 zemích. Školí, rozvíjí a podporuje kreativní multidisciplinární týmy a komunity s cílem přinášet pozitivní změny. Design Thinking umožňuje vytvářet a realizovat inovativní nápady, změny a řešení složitých problémů.',
  about_us_47:
    'Jejich posláním je vytvářet prostor a čas, kde se týmy i jednotlivci mohou inspirovat a čelit novým výzvám, učit se praxí („learn-by-doing“), rozvíjet schopnosti kreativního řešení problémů a pomáhat organizacím budovat prostředí a myšlení potřebné pro odvážné inovace.',
  about_us_48:
    'je profesní obchodní asociace zastupující společnosti působící v oblasti Mystery Shoppingu. Asociace působí regionálně po celém světě prostřednictvím poboček v Americe, Evropě/Africe a Asii/Pacifiku. Členské společnosti spojují své síly za účelem rozvoje a posilování odvětví Mystery Shopping prostřednictvím společných aktivit.',
  about_us_49:
    'je nezisková členská organizace. Její členové tvoří komunitu přesvědčenou o tom, že analytika dat, výzkum a poznatky mohou pomoci zlepšit společnost, organizace i život každého člověka.',
  about_us_50:
    'ESOMAR sídlí v Amsterdamu v Nizozemsku. Prostřednictvím svých členů působí ve více než 130 zemích již od roku 1947.',
  about_us_51:
    '(UCCA) je profesní komunita soukromých odborníků a společností, které spojuje cíl rozvoje a spolupráce v oblasti kontaktních center a zákaznického servisu. Filozofií UCCA je zvyšování úrovně odvětví kontaktních center na základě moderních technologií a vysokých standardů.',
  about_us_52:
    'Ukrajinská asociace kontaktních center byla založena v roce 2010',
  about_us_53:
    'studuje nejlepší světové zkušenosti v oblasti vzdělávání, aby je mohla přizpůsobit a využít na ukrajinském trhu. Akademie DTEK proto spolupracuje s předními mezinárodními obchodními školami: INSEAD, IE Business School a Stanford University.',
  about_us_54:
    'Akademie DTEK se zaměřuje na rozvoj zákaznicky orientované a inovativní kultury prostřednictvím programů D.Client School, ID School, Executive Education: Energy of Innovation, Power of Communications, digitálního programu DX School, Effective Leader: Pre-MBA a Change Energy.',
  about_us_55: 'Sergey Pashkovsky',
  about_us_56: 'Viktoria Skorbota',
  about_us_57: 'Artem Fomin',
  about_us_58: 'Max Papka',
  about_us_59: 'Mezinárodní manažer prodeje',
  bht_1: 'Brand Health',
  bht_2: 'Tracking',
  bht_3: 'Značky jsou mimořádně silné',
  bht_4: 'Zjistěte, jak si vaše značka celkově vede',
  bht_5: 'O službě',
  bht_6: 'Co je Brand Health Tracking?',
  bht_7:
    'Jedná se o typ průzkumu trhu, který se provádí pravidelně (každé dva týdny, každý měsíc atd.), aby bylo možné získat informace o',
  bht_8:
    'postavení značky na trhu na základě ukazatelů, jako jsou známost, poptávka, image, charakteristiky jejích zákazníků, zdraví značky apod.',
  bht_9: 'Nejčastěji kupují značku',
  bht_10: 'Loajální',
  bht_11: 'Zakoupili značku během posledních 3 měsíců',
  bht_12: 'Pravidelní zákazníci',
  bht_13: 'Zakoupili značku během posledních 6 měsíců',
  bht_14: 'Krátkodobí zákazníci',
  bht_15: 'Zakoupili značku během posledního roku',
  bht_16: 'Dlouhodobí zákazníci',
  bht_17: 'Značku znají, ale nikdy ji nepoužili ani nekoupili',
  bht_18: 'Znají značku, ale nejsou zákazníky',
  bht_19: 'Neznají značku – nikdy o ní neslyšeli',
  bht_20: 'Neznalí',
  bht_21: 'Profil zákazníků značky',
  bht_22:
    'Hodnocení dlouhodobé konzistence aktivit zaměřených na budování značky',
  bht_23: 'Měření úrovně povědomí zákazníků o značce',
  bht_24: 'Ukazuje efektivitu reklamních a informačních kampaní',
  bht_25:
    'Určení vlivu období intenzivní reklamy na prodejní a marketingové aktivity konkurence',
  bht_26:
    'Poskytuje majiteli firmy průběžnou kontrolu v období neustálých změn na trhu',
  bht_27: 'Jaké úkoly lze pomocí BHT řešit:',
  bht_28: 'Objednat průzkum',
  bht_29: 'Úkol k řešení',
  bht_30: 'Například',
  bht_31:
    'pokud společnost potřebuje pouze jedno měření BHT za čtvrtletí pro sledování podílu na trhu, měl by být průzkum mezi respondenty prováděn častěji při měření znalosti značky z reklamy.',
  bht_32: 'CATI',
  bht_33: 'Face-to-Face',
  bht_53: 'Rozhovory',
  bht_34: 'CAWI',
  bht_35: 'Úkol k řešení',
  bht_36: 'Shromažďováním informací',
  bht_37:
    'pomocí různých metod se sledování značky obvykle dělí do tří etap podle cílové skupiny a obtížnosti jejího oslovení:',
  bht_38: 'Pro sběr dat využíváme tradiční i moderní metody:',
  bht_39:
    'Pracujeme se dvěma modely: první využívá jednoduchou sadu ukazatelů, druhý je určen pro složitější odvětví, jako je potravinářství a služby. Komplexnější model zahrnuje hloubkovou analýzu až s 10 hodnocenými indexy.',
  bht_40: 'Nabízíme',
  bht_41: 'kontrolu výchozích dat',
  bht_42: 'Pokrýváme',
  bht_43: 'celou zemi',
  bht_44: 'Poskytujeme řešení',
  bht_45:
    'pro nedynamické trhy / trhy s omezeným počtem hráčů (Brand Point Analyze)',
  bht_46: 'Proč právě my?',
  bht_47: 'Proč si vybrat nás?',
  bht_50: 'Slabý výsledek',
  bht_51: 'Dobrý výsledek',
  bht_52: 'Průměrný výsledek',
  cases_1:
    'Výzva: Jak zlepšit zákaznickou zkušenost při nákupu elektromobilů v showroomech Hyundai?',
  cases_2: 'Mapování Customer Journey',
  cases_3: 'Generování nápadů',
  cases_4: 'Kvalitativní výzkum',
  cases_5:
    'Výzva: Co je třeba změnit v prodejnách (v procesu obsluhy, interiéru i vnímání značky), aby zákazníci projevili větší zájem o značku Oppo?',
  cases_6: 'Online CJM',
  cases_7: 'Testování UI',
  cases_8: 'Rozhovory',
  cases_9:
    'Výzva: Co je třeba změnit v prodejnách, aby zákazníci projevili větší zájem o značku Oppo?',
  cases_10: 'Kvalitativní část',
  cases_11: 'Generování nápadů',
  cases_12: 'Kvantitativní část',
  cases_13: 'Mapa zákaznické cesty',
  cases_14: 'Případové studie',
  cases_15: 'Vše',
  cases_16: 'Vytvořme společně váš úspěšný příběh',
  csi_1: 'Index',
  csi_2: 'spokojenosti zákazníků',
  csi_3: 'Zjistěte příčiny',
  csi_4: 'spokojenosti a nespokojenosti zákazníků',
  csi_5: 'Průzkum spokojenosti zákazníků',
  csi_6:
    'je identifikace faktorů, příčin a motivů, které ovlivňují rozhodnutí zákazníka o nákupu i chování cílové skupiny.',
  csi_7: 'Průzkum spokojenosti zákazníků',
  csi_8:
    'ukazuje, jak je zákazník spokojený nebo nespokojený s konkrétním aspektem služby nebo s produktem jako celkem.',
  csi_9: 'Průzkum spokojenosti',
  csi_10:
    'je prováděn mezi stávajícími zákazníky společnosti a uživateli konkrétních produktů či služeb.',
  csi_11: 'Co je CSI?',
  csi_12:
    'Spokojenost zákazníků měří, do jaké míry byla naplněna jejich očekávání při nákupu produktu nebo služby poskytované vaší společností.',
  csi_13: 'Spokojený muž',
  csi_14: 'O projektu',
  csi_15: 'Odhalte skryté faktory',
  csi_16: 'které mohou ovlivnit spokojenost zákazníků',
  csi_17: 'Určete příčiny',
  csi_18: 'nárůstu nebo poklesu poptávky po zboží a službách',
  csi_19: 'Optimalizujte',
  csi_20: 'firemní procesy',
  csi_21: 'Přizpůsobte je',
  csi_22: 'potřebám moderních zákazníků',
  csi_23: 'Vytvořte efektivní reklamní sdělení',
  csi_24: 'a přizpůsobte produkt požadavkům zákazníků',
  csi_25: 'Řešené úkoly',
  csi_26: 'Jaké úkoly mohou průzkumy spokojenosti zákazníků vyřešit',
  csi_27: 'Muž s telefonem',
  csi_28: 'Vytváříme matematický model',
  csi_29:
    'faktorů, které mohou ovlivnit spokojenost a loajalitu zákazníků (regresní analýza)',
  csi_30: 'Optimalizujte',
  csi_31: 'firemní procesy',
  csi_32: 'Vypočítáme index spokojenosti zákazníků',
  csi_33: '(CSI) a porovnáme jej s deklarovaným indexem',
  csi_34: 'Provádíme průzkumy',
  csi_35: 'pro segmenty B2B i B2C.',
  csi_36: 'Naše dotazníky připravuje tým',
  csi_37: 'analytiků speciálně pro individuální projekty našich klientů',
  csi_38: 'Proč právě my',
  csi_39: 'Proč si vybrat právě nás?',
  csi_40: 'Metody sběru informací:',
  main_1:
    'našich zákazníků zlepšuje své finanční výsledky díky zkušenostem svých klientů',
  main_2: 'Výzkum a poradenství v oblasti CX: 360° pohled na vaše podnikání',
  main_3: 'Objevte naši nabídku řešení a nástrojů pro podporu vašeho podnikání',
  main_4: 'Produkty',
  main_5:
    'Kvalitativní výzkum je sběr a analýza nečíselných dat za účelem pochopení konceptů, názorů nebo zkušeností',
  main_6:
    'Kvantitativní výzkumné metody představují objektivní měření a číselnou analýzu dat získaných prostřednictvím anket, dotazníků a průzkumů',
  main_7:
    'Mystery Shopping je metoda marketingového výzkumu určená k měření a sledování interakcí mezi zákazníkem a společností nebo organizací podle předem definovaného scénáře',
  main_8:
    'Systém řízení zpětné vazby. Hlas vašeho zákazníka v jednom systému pro správu zákaznické zpětné vazby',
  main_9:
    'Platforma pro analýzu obsahu poháněná umělou inteligencí, která poskytuje poznatky o publiku',
  main_10:
    'Software pro řízení výkonu. Gamifikovaná aplikace pro zvýšení prodeje',
  main_11:
    'Monitoring cen je proces sběru, zpracování a analýzy cen konkurence',
  main_12:
    'je navrhování služeb a produktů orientovaných na zákazníka. Proces zahrnuje vyvážený přístup od potřeb a očekávání zákazníků až po způsob fungování služeb',
  main_13:
    'Náš analytický tým využívá nejmodernější i osvědčené přístupy, které se úspěšně osvědčily u mnoha klientů',
  main_14: 'Metodiky',
  main_15: 'Mapa zákaznické cesty',
  main_16:
    'Customer Journey Mapping (CJM) spočívá v definování cílové skupiny, pochopení jejích potřeb a prostředí a následném vytvoření plánu pro poskytování atraktivní zákaznické zkušenosti',
  main_17: 'CJM',
  main_18: 'Net Promoter Score',
  main_19:
    'Net Promoter Score (NPS) je zlatým standardem metrik zákaznické zkušenosti založeným na jediné otázce: Jak pravděpodobně byste doporučili organizaci, produkt nebo službu?',
  main_20: 'NPS',
  main_21: 'Brand Health Tracking',
  main_22:
    'Výzkum Brand Health Tracking (BHT) měří výkonnost vaší značky z hlediska povědomí, používání, pozice na trhu a celkové výkonnosti značky',
  main_23: 'BHT',
  main_24: 'Výzkum lidských zdrojů',
  main_25:
    'Výzkum lidských zdrojů slouží k hodnocení personálních postupů a výkonnosti a poskytuje podrobnou analýzu současného rozvoje a řízení',
  main_26: 'HR výzkum',
  main_27: 'Index spokojenosti zákazníků',
  main_28:
    'Customer Satisfaction Index (CSI) je ukazatel, který vyjadřuje, jak jsou vaši zákazníci spokojeni s produkty nebo službami společnosti.',
  main_29: 'CSI',
  main_30: 'UX testování',
  main_31:
    'Testování použitelnosti (UX) sleduje, jak skuteční lidé pracují s webovou stránkou, aplikací nebo jiným produktem, a pozoruje jejich chování a reakce',
  main_32: 'Proč právě my',
  main_33:
    'Naším posláním je pomáhat firmám poskytovat špičkovou zákaznickou zkušenost',
  main_34: 'Důraz na kvalitu',
  main_35: 'Dbáme na kontrolu kvality',
  main_36: 'výzkumných dat. Klientům zpřístupňujeme všechny datové soubory',
  main_37: 'Nákladová efektivita',
  main_38: 'Naše zkušenosti, zdroje a optimalizované',
  main_39: 'firemní procesy vám pomáhají šetřit čas i peníze',
  main_40: 'Chytrá řešení',
  main_41: 'Používáme širokou škálu metod',
  main_42: 'a nástrojů k řešení vašich konkrétních potřeb',
  main_43: 'Důraz na kvalitu',
  main_44: 'Dbáme na kontrolu kvality',
  main_45: 'výzkumných dat. Klientům zpřístupňujeme všechny datové soubory',
  main_46: 'Nákladová efektivita',
  main_47: 'Naše zkušenosti, zdroje a optimalizované',
  main_48: 'firemní procesy vám pomáhají šetřit čas i peníze',
  main_49: 'Chytrá řešení',
  main_50: 'Používáme širokou škálu metod',
  main_51: 'a nástrojů k řešení vašich konkrétních potřeb',
  main_52: 'Cash & Carry',
  main_53: 'Elektronika',
  main_54: 'Luxusní / Prémiové',
  main_55: 'Gastronomie a pohostinství',
  main_56: 'Maloobchod',
  main_57: 'Automobilový průmysl',
  main_58: 'Móda',
  main_59: 'Banky',
  main_60: 'Cestování a volný čas',
  main_61: 'Hodinky a šperky',
  main_62: 'Domácnost a spotřebiče',
  main_63: 'Blog',
  main_64: 'Přejděte na náš blog a přečtěte si další zajímavé články',
  main_65: 'Retail audit',
  main_66:
    'Shromážděte podrobná data o své prodejně nebo značce, analyzujte překážky růstu a vytvořte efektivní strategie k jejich překonání',
  main_73: 'Diary Study',
  main_74:
    'Diary Study je vhodná metoda pro zkoumání dlouhodobých zkušeností a opakujících se aktivit. Sledujte a získejte přehled o měnících se zkušenostech uživatelů a jejich životním stylu v přirozeném prostředí v průběhu času.',
  main_75: 'Employee Experience (EX)',
  main_76:
    'Metodologie Employee Experience (EX) představuje strategický přístup, který pomáhá organizacím navrhovat lepší procesy, firemní kulturu a pracovní prostředí v souladu s očekáváními zaměstnanců i obchodními cíli, čímž zvyšuje spokojenost zaměstnanců i výkonnost společnosti.',
  main_77: 'CATI',
  main_78: 'Telefonické dotazování s podporou počítače (CATI)',
  main_79:
    'CATI je flexibilní a efektivní výzkumná metodologie, která umožňuje sběr kvalitních dat přizpůsobených různým obchodním potřebám – od měření spokojenosti zákazníků a angažovanosti zaměstnanců až po tržní a sociologické výzkumy – a poskytuje přesné, aktuální a prakticky využitelné poznatky.',
  cjm_1: 'Zákaznická',
  cjm_2: 'cesta',
  cjm_3: 'Vstupte do světa zákazníků a sdílejte jejich zkušenosti',
  cjm_4: 'Co je Customer Journey Map?',
  cjm_5:
    'CJM poskytuje vizualizovaný přehled interakcí zákazníka s produktem, službou, společností nebo značkou prostřednictvím různých kanálů během určitého časového období.',
  cjm_6:
    'To umožňuje společnostem objektivně analyzovat zákaznickou zkušenost, odhalit a odstranit vznikající překážky a navrhnout doporučení pro zlepšení produktu.',
  cjm_7: 'Určení cílové skupiny a segmentace',
  cjm_8: 'Identifikace fází interakce se zákazníkem',
  cjm_9: 'Identifikace hlavních komunikačních kanálů se zákazníkem',
  cjm_10: 'Výzkum zákaznické zkušenosti',
  cjm_11: 'Analýza překážek a návrhy optimalizačních hypotéz',
  cjm_12: 'Realizace a testování hypotéz',
  cjm_13: 'Tvorba Customer Journey Map zahrnuje následující kroky:',
  cjm_14: 'Customer Journey Map ukáže:',
  cjm_15:
    'CJM poskytuje vizualizovaný přehled interakcí zákazníka s produktem, službou, společností nebo značkou prostřednictvím různých kanálů během určitého časového období.',
  cjm_16: 'Zajišťujeme spolupráci',
  cjm_17: 'mezi analytiky a designéry',
  cjm_18: 'Nabízíme individuální',
  cjm_19: 'přístup ke každému klientovi',
  cjm_20: 'Pomáháme zvýšit celkovou',
  cjm_21:
    'spokojenost zákazníků se službou nebo produktem a tím i jejich loajalitu ke společnosti',
  cjm_22: 'Garantujeme',
  cjm_23:
    'optimalizaci zákaznické cesty s ohledem na obchodní procesy společnosti',
  cjm_24: 'Našim klientům nabízíme',
  cjm_25:
    'možnost využití kombinovaných přístupů: CATI, CAWI, fokusní skupiny, hloubkové rozhovory, expertní rozhovory, etnografii atd.',
  cjm_26: 'Proč si vybrat právě nás?',
  methods_hr_1: 'Výzkum lidských zdrojů',
  methods_hr_2:
    'Získejte objektivní informace o svém týmu a zjistěte, jak zlepšit výkonnost HR',
  methods_hr_3: 'Některé důvody, proč můžete potřebovat HR výzkum',
  methods_hr_4: 'dotázaných zaměstnanců',
  methods_hr_5: 'realizovaných HR projektů',
  methods_hr_6: 'uskutečněných školení zaměstnanců',
  methods_hr_7:
    'Přední evropský holding v oblasti výzkumu zákaznické a zaměstnanecké zkušenosti',
  methods_hr_8: 'HR výzkumy společnosti 4Service v číslech',
  methods_hr_9:
    'Identifikace problémů a slabých míst v každé fázi životního cyklu zaměstnance: nábor, výběr, onboarding, kariérní rozvoj a rekvalifikace',
  methods_hr_10:
    'Zjistit, které příležitosti si zaslouží zvýšení mzdy a bonusy',
  methods_hr_11: 'Potřebujete předvídat nebo řešit nespokojenost zaměstnanců',
  methods_hr_12:
    'HR výzkum umožňuje hodnotit nové i stávající HR politiky, programy a postupy',
  methods_hr_13: 'Zlepšení duševního zdraví zaměstnanců společnosti',
  methods_hr_14: 'Pokud chcete zvýšit produktivitu pomocí cíleného přístupu',
  methods_hr_15:
    'Pokud máte mezinárodní a/nebo vzdálený tým, který potřebujete efektivně řídit',
  methods_hr_16:
    'Pochopit, jak atraktivní je vaše značka zaměstnavatele pro potenciální zaměstnance',
  methods_hr_17: 'Spokojenost zaměstnanců',
  methods_hr_18: 'Výzkum značky zaměstnavatele',
  methods_hr_19: 'Kulturní rozmanitost',
  methods_hr_20: 'Odměňování a mzdové plány',
  methods_hr_21: 'Zapojení a loajalita týmu',
  methods_hr_22: 'Chráněné skupiny zaměstnanců',
  methods_hr_23: 'Oblasti výzkumu',
  methods_hr_24: 'Řešení 1',
  methods_hr_25: 'eNPS, spokojenost zaměstnanců, loajalita zaměstnanců',
  methods_hr_26: 'Co měříme:',
  methods_hr_27: 'Loajalita:',
  methods_hr_28:
    'loajalitu zaměstnanců, predikci budoucího chování a určení významu faktorů ovlivňujících loajalitu',
  methods_hr_29: 'Zapojení:',
  methods_hr_30: 'zapojení zaměstnanců do práce, zájem o výsledky a úspěchy',
  methods_hr_31: 'Angažovanost:',
  methods_hr_32: 'identifikace hodnot zaměstnanců a hodnot společnosti',
  methods_hr_33: 'Trust 360:',
  methods_hr_34:
    'důvěra ve vedení, kolegy, podřízené a důvěra ve strategii a politiku zaměstnavatele',
  methods_hr_35: 'Spokojenost:',
  methods_hr_36:
    'určení jedinečných faktorů pro každou společnost, hodnocení spokojenosti podle jednotlivých klíčových faktorů ovlivňujících loajalitu',
  methods_hr_37: 'Řešení 2',
  methods_hr_38: 'Budování značky zaměstnavatele',
  methods_hr_39: 'Interní značka zaměstnavatele',
  methods_hr_40:
    'analýza značky (průzkum zaměstnanců, zainteresovaných stran, interních recruiterů a HR specialistů)',
  methods_hr_41: 'Externí analýza zaměstnavatele',
  methods_hr_42:
    '(analýza EVP konkurence, průzkum externích recruiterů, průzkum uchazečů o zaměstnání)',
  methods_hr_43: 'Povědomí o značce zaměstnavatele a její reputace',
  methods_hr_44: 'analýza',
  methods_hr_45: 'Přítomnost zaměstnavatele',
  methods_hr_47: 'Reference zaměstnavatele',
  methods_hr_48: 'sběr',
  methods_hr_49: 'Benchmarking konkurence',
  methods_hr_50: 'podle klíčových faktorů, jako jsou',
  methods_hr_51: 'Mzda,',
  methods_hr_52: 'pracovní prostředí, atmosféra, charakter práce',
  methods_hr_53: 'Analýza potřeb a očekávání',
  methods_hr_54: 'uchazečů o zaměstnání',
  methods_hr_55: 'Používají se hloubkové rozhovory,',
  methods_hr_56: 'desk research a kvantitativní výzkum',
  methods_hr_57: 'Řešení 3',
  methods_hr_58: 'Employee Journey Map / Mystery Employee',
  methods_hr_59: 'mapování cesty uchazeče o zaměstnání s identifikací',
  methods_hr_60:
    'hlavních fází hledání práce, komunikačních kanálů, kritérií výběru a hodnocení uchazečů',
  methods_hr_61: 'monitorování všech fází',
  methods_hr_62:
    'a komunikačních kanálů s mystery uchazeči (sjednání pohovoru, pracovní pohovor, stáž ve společnosti)',
  methods_hr_63: 'Identifikace',
  methods_hr_64: 'slabých míst v procesech náboru a onboardingu',
  methods_hr_65: 'Doporučení ke zlepšení,',
  methods_hr_66: 'benchmarking s lídry v oboru',
  mystery_shopping_1: 'Mystery',
  mystery_shopping_2: 'Shopping',
  mystery_shopping_3:
    'Vyhodnoťte své služby prostřednictvím skutečných zákazníků',
  mystery_shopping_4:
    'Ověřte dodržování standardů, vyhodnoťte svůj personál a přibližte se svým zákazníkům',
  mystery_shopping_5:
    'Jsme elitním členem přední profesní asociace poskytovatelů Mystery Shopping MSPA Europe',
  mystery_shopping_6: 'let zkušeností',
  mystery_shopping_7: 'návštěv měsíčně',
  mystery_shopping_8: 'mystery shopperů po celém světě',
  mystery_shopping_9: 'Aktivních projektů',
  mystery_shopping_10: 'poboček, centrála v Rakousku',
  mystery_shopping_11: 'Evropští poskytovatelé Mystery Shopping',
  mystery_shopping_12: 'hodnocení kvality služeb',
  mystery_shopping_13: 'Dotazník',
  mystery_shopping_14: 'Software',
  mystery_shopping_15: 'Profil mystery shoppera',
  mystery_shopping_16: 'Validace a řešení námitek',
  mystery_shopping_17: 'Analytika',
  mystery_shopping_18:
    'Pomocí těchto 5 kroků společnost 4Service garantuje kvalitu služby Mystery Shopping',
  mystery_shopping_19: 'Program',
  mystery_shopping_20:
    '5 prvků programu Mystery Shopping od společnosti 4Service',
  mystery_shopping_21: 'Dotazník:',
  mystery_shopping_22: 'základ vašeho programu',
  mystery_shopping_23:
    'Tato část programu je dostupná všem zainteresovaným stranám',
  mystery_shopping_24: 'Pro vrcholový management.',
  mystery_shopping_25: 'Zobrazuje všechny důležité kroky a detaily procesu',
  mystery_shopping_26: 'Pro zaměstnance.',
  mystery_shopping_27: 'Odrážejí to, co zaměstnavatelé od nich očekávají',
  mystery_shopping_28: 'Pro mystery shoppery.',
  mystery_shopping_29:
    'Jasně a strukturovaně, aby se předešlo zmatkům a zkreslení',
  mystery_shopping_30: 'Software Shopmetrics:',
  mystery_shopping_31: 'Uživatelsky přívětivý a inovativní',
  mystery_shopping_32: 'Výhody:',
  mystery_shopping_33: 'Integruje se',
  mystery_shopping_34: 's vašimi obchodními procesy a softwarem',
  mystery_shopping_35: 'V souladu s GDPR',
  mystery_shopping_36: 'Nástroje pro správu ochrany osobních údajů',
  mystery_shopping_37: 'Podrobný',
  mystery_shopping_38: 'balíček pro zajištění právního souladu',
  mystery_shopping_39: 'Tvůrce',
  mystery_shopping_40: 'reportů',
  mystery_shopping_41: 'Správa',
  mystery_shopping_42: 'úrovní přístupu',
  mystery_shopping_43: 'Většina dotazníků',
  mystery_shopping_44: 'je vyplněna během jedné hodiny',
  mystery_shopping_45: 'Profil mystery shopperů:',
  mystery_shopping_46: 'Více než 200 000 mystery shopperů po celém světě',
  mystery_shopping_47:
    'Hlavní kritéria: maximální shoda s vaší cílovou skupinou, včetně předchozích zkušeností s vaší společností nebo konkurencí',
  mystery_shopping_48: 'Školení mystery shopperů:',
  mystery_shopping_49: 'Úvodní test školení',
  mystery_shopping_50: 'Hovor přes Skype / telefon',
  mystery_shopping_51: 'Hodnoticí test (volitelný)',
  mystery_shopping_52: 'Validace a námitky',
  mystery_shopping_53: 'Validační',
  mystery_shopping_54: 'systém',
  mystery_shopping_55: '100 % reportů',
  mystery_shopping_56: 'je kontrolováno validačním týmem',
  mystery_shopping_57: 'Dodatečné hovory',
  mystery_shopping_58: 'pro upřesnění informací',
  mystery_shopping_59: 'Zvukové záznamy',
  mystery_shopping_60: 'po návštěvě pro zaznamenání nejdůležitějších poznatků',
  mystery_shopping_61: 'Systém prevence',
  mystery_shopping_62: 'podvodů zaměstnanců',
  mystery_shopping_63: 'Systém',
  mystery_shopping_64: 'námitek',
  mystery_shopping_65: 'Jakékoli hodnocení mystery shoppera',
  mystery_shopping_66: 'může zaměstnanec přímo na webu napadnout',
  mystery_shopping_67: 'Každá námitka',
  mystery_shopping_68: 'je posouzena a zodpovězena místním validačním týmem',
  mystery_shopping_69: 'Můžete zobrazit statistiky',
  mystery_shopping_70: 'podaných námitek',
  mystery_shopping_71: 'Analytika.',
  mystery_shopping_72: 'Report je prezentován osobně a obsahuje:',
  mystery_shopping_73: 'Slabá místa',
  mystery_shopping_74: 'a hlavní problémy společnosti',
  mystery_shopping_75: 'Dynamiku',
  mystery_shopping_76: 'podle divizí a oddělení',
  mystery_shopping_77: 'Korelaci',
  mystery_shopping_78: 'mezi dodržováním standardů a spokojeností zákazníků',
  mystery_shopping_79: 'Benchmarking',
  mystery_shopping_80: 've srovnání s konkurencí',
  mystery_shopping_81: 'Praktická',
  mystery_shopping_82: 'doporučení ke zlepšení služeb',
  mystery_shopping_83: 'Čím se lišíme?',
  mystery_shopping_84: 'Pořádáme ideační workshopy',
  mystery_shopping_85:
    'Nejen doporučujeme, co dělat, ale společně s vámi hledáme praktická řešení problémů se službami.',
  mystery_shopping_86:
    'Ideační workshopy jsou účinným nástrojem, který nám pomáhá:',
  mystery_shopping_87: 'Rozvíjet směry pro zlepšení produktů nebo služeb',
  mystery_shopping_88:
    'Objevovat nové příležitosti pro příjmy a obchodní strategie',
  mystery_shopping_89:
    'Nacházet řešení složitých výzev zaměřených na zákazníka',
  mystery_shopping_90:
    'Proměňovat problematické body zákaznické zkušenosti v pozitivní zážitky',
  mystery_shopping_91: 'Provádíme video rozhovory',
  mystery_shopping_92:
    'Neshromažďujeme pouze dotazníky – získáváme také živé komentáře od mystery shopperů',
  mystery_shopping_93: 'Děláme to proto, abychom:',
  mystery_shopping_94:
    'Naši facilitátoři vedou hloubkové rozhovory a poskytují efektivní zpětnou vazbu',
  mystery_shopping_95: 'Viděli zkušenost z pohledu zákazníka',
  mystery_shopping_96: 'Posílili vaši strategii content marketingu',
  mystery_shopping_97: 'Předvídat chování zákazníků',
  mystery_shopping_98: 'Navrhujeme Customer Journey Map',
  mystery_shopping_99:
    'Mapování zákaznické cesty nám pomáhá vžít se do role zákazníků a pochopit jejich potřeby i výzvy.',
  mystery_shopping_100: 'Vytvoření zákaznické cesty je nejlepší způsob, jak:',
  mystery_shopping_101: 'Vidět zkušenost z pohledu zákazníka',
  mystery_shopping_102: 'Posílit vaši strategii content marketingu',
  mystery_shopping_103: 'Předvídat chování zákazníků',
  mystery_shopping_104: 'Odhalit mezery ve službách nebo komunikaci',
  mystery_shopping_105: 'Nabízíme různé typy Mystery Shoppingu',
  mystery_shopping_106: 'Typy Mystery Shoppingu',
  mystery_shopping_107: 'Mystery Caller',
  mystery_shopping_108:
    'Volá vašim manažerům a/nebo call centru za účelem vyhodnocení kvality telefonického zákaznického servisu',
  mystery_shopping_109: 'Luxury Mystery Shopping',
  mystery_shopping_110:
    'Kontrola kvality služeb v luxusních provozovnách prostřednictvím speciálně vybrané kategorie mystery shopperů',
  mystery_shopping_111: 'Konkurenční návštěvy',
  mystery_shopping_112:
    'Nejjednodušší způsob, jak pochopit fungování vaší konkurence',
  mystery_shopping_113: 'Mystery Employee',
  mystery_shopping_114:
    'Pomůže vám pochopit celou cestu zaměstnance (nábor, adaptace, interní procesy atd.)',
  mystery_shopping_115: 'Motivační návštěvy',
  mystery_shopping_116:
    'Užitečný nástroj pro podporu nabídky doplňkových služeb a/nebo produktů a prodej konkrétních produktů',
  mystery_shopping_117: 'Mystery Shopper Online',
  mystery_shopping_118:
    'Simuluje a měří zákaznickou zkušenost ve vašem e-shopu, na webových stránkách nebo v aplikaci',
  mystery_shopping_119: 'Kontrola prodeje a promoakcí',
  mystery_shopping_120:
    'Pomáhá zjistit, jak jsou promoakce prezentovány na všech pobočkách a jak efektivně fungují',
  mystery_shopping_121: 'Návštěvy nákupu a vrácení zboží',
  mystery_shopping_122:
    'Pomáhá zmapovat celý proces od nákupu po vrácení zboží za účelem zlepšení zákaznické zkušenosti',
  mystery_shopping_123: '> 20 let',
  nps_1: 'Net Promoter',
  nps_2: 'Score',
  nps_3: 'Měřte, sledujte a zlepšujte loajalitu zákazníků',
  nps_4: 'Odpovídají hodnocením od 0 do 6.',
  nps_5:
    'Pravděpodobně měli špatnou zkušenost, znovu u vás nenakoupí a mohou od nákupu odrazovat i ostatní.',
  nps_6: 'Jsou to respondenti, kteří udělili hodnocení 7 nebo 8.',
  nps_7:
    'Jsou se službou spokojeni, ale ne natolik, aby byli považováni za promotéry.',
  nps_8:
    'Jsou to respondenti, kteří vaši společnost hodnotí známkou 9 nebo 10.',
  nps_9:
    'To znamená, že by vás doporučili přátelům nebo kolegům, a tím vás aktivně podporují.',
  nps_10: 'Co je NPS?',
  nps_11: 'Měří vnímání zákazníků na základě jediné jednoduché otázky:',
  nps_12:
    'Jak pravděpodobné je, že byste doporučil(a) [organizaci/produkt/službu] příteli nebo kolegovi?',
  nps_13: 'Potřebuje moje společnost NPS?',
  nps_14: 'NPS je základem vašeho udržitelného růstu',
  nps_15: 'Pochopte dynamiku loajality zákazníků',
  nps_16: 'Motivujte své zaměstnance',
  nps_17: 'Pochopte vztah zákazníků k různým produktům',
  nps_18: 'Porovnejte, jak zákazníci vnímají vás a vaše konkurenty',
  nps_19: 'Co mohu s NPS dělat?',
  nps_20: 'Pro jaké typy podnikání je NPS vhodné?',
  nps_21: 'Metody sběru dat:',
  nps_22: 'Naše doporučení pro práci s NPS',
  nps_23: 'Vypracujeme doporučení, která pomohou proměnit kritiky v promotéry',
  nps_24: 'Pracujeme metodou „closed loop“',
  nps_25:
    'NPS je trackingový výzkum, při kterém sledujeme změny v loajalitě zákazníků',
  nps_26: 'Sledujeme dynamiku',
  nps_27:
    'Doporučujeme vždy hodnotit také konkurenci ve vašem segmentu pro hlubší analýzu',
  nps_28: 'Hodnocení konkurence',
  price_monitoring_1: 'Monitoring cen',
  price_monitoring_2: 'Retail Monitoring',
  price_monitoring_3:
    'Zvyšte prodejní potenciál a optimalizujte cenovou politiku díky monitoringu cen konkurence',
  price_monitoring_4:
    'Společnost 4Service poskytuje služby monitoringu cen po celém světě již více než 20 let',
  price_monitoring_5:
    'Ceny jsou monitorovány v krátkých intervalech naším týmem kvalifikovaných interních auditorů, což nám umožňuje rychle reagovat na změny cen konkurence',
  price_monitoring_6:
    'Výzvy, které vám naše společnost pomůže vyřešit pomocí monitoringu cen',
  price_monitoring_7: 'Hodnocení cenové politiky konkurence',
  price_monitoring_8: 'a produktové politiky',
  price_monitoring_9: 'Monitoring promoakcí',
  price_monitoring_10: 'a speciálních nabídek',
  price_monitoring_11: 'Monitoring tržních podmínek',
  price_monitoring_12: 'a tržního prostředí',
  price_monitoring_13: 'Kontrola a audit prodejních míst',
  price_monitoring_14: 'z hlediska speciálního vybavení a merchandisingu',
  price_monitoring_15: 'Řízení pohybu',
  price_monitoring_16: 'produktů v obchodní síti',
  price_monitoring_17: 'Optimalizace podmínek',
  price_monitoring_18: 'pro lepší spolupráci s dodavateli a dealery',
  price_monitoring_19: 'Měření regálového prostoru,',
  price_monitoring_20: 'hodnocení umístění produktů a dostupnosti zásob',
  price_monitoring_21: 'Klíčové ukazatele a kritéria monitoringu',
  price_monitoring_22:
    'Veškerá data jsou soustředěna v jednom rozhraní, včetně:',
  price_monitoring_23: 'názvu',
  price_monitoring_24: 'produktu a kategorie značky',
  price_monitoring_25: 'dostupnosti',
  price_monitoring_26: 'propagačních materiálů',
  price_monitoring_27: 'ceny',
  price_monitoring_28: 'a dostupnosti všech propagačních nabídek',
  price_monitoring_29: 'regálové',
  price_monitoring_30: 'plochy',
  price_monitoring_31: 'vystavení',
  price_monitoring_32: 'produktu',
  price_monitoring_33: 'SKU',
  price_monitoring_34: 'počet vystavených kusů (facing)',
  price_monitoring_35: 'typ',
  price_monitoring_36: 'obalu',
  price_monitoring_37: 'další',
  price_monitoring_38: 'obecné informace',
  price_monitoring_39: 'Předprojektová analýza:',
  price_monitoring_40: 'Analyzujeme',
  price_monitoring_41:
    'cenovou a produktovou politiku vaší společnosti, obchodní postupy a specifika odvětví',
  price_monitoring_42: 'Poskytujeme',
  price_monitoring_43: 'rychlé školení, testování a certifikaci auditorů',
  price_monitoring_44: 'Přizpůsobujeme',
  price_monitoring_45: 'a nastavujeme software',
  price_monitoring_46: 'Terénní práce:',
  price_monitoring_47: 'Návštěvy maloobchodních',
  price_monitoring_48: 'prodejen',
  price_monitoring_49: 'Reporting:',
  price_monitoring_50: 'Náš analytický tým',
  price_monitoring_51:
    'připravuje online reporty v osobních účtech společnosti',
  price_monitoring_52: 'Poskytujeme',
  price_monitoring_53:
    'kompletní fotoreport, PPT report a Excel report podle typu lokality, názvu řetězce a adresy prodejny',
  price_monitoring_54: 'Jak to',
  price_monitoring_55: 'funguje',
  price_monitoring_56: 'výše jednotlivých slev',
  price_monitoring_57: 'výpočet nákladů',
  price_monitoring_58: 'výše jednotlivých bonusů',
  price_monitoring_59: 'věrnostní programy',
  price_monitoring_60: 'atd.',
  price_monitoring_61: 'Používáme specializovaný software:',
  price_monitoring_62:
    'PRADATA, Shopmetrics a nabízíme komplexní technickou podporu',
  price_monitoring_63: 'Rychlé nasazení',
  price_monitoring_64: 'a škálování (od prvního dne)',
  price_monitoring_65: 'Všechna data jsou potvrzena',
  price_monitoring_66: 'fotografiemi a GPS označením',
  price_monitoring_67: 'Máme potřebný počet',
  price_monitoring_68: 'terénních pracovníků v jakékoli zemi',
  price_monitoring_69: 'Dokážeme pracovat s velkými',
  price_monitoring_70: 'objemy dat',
  price_monitoring_71: 'Monitoring individuálních cen',
  price_monitoring_72:
    'Pokud máte složité produkty, pomůžeme vám definovat cenovou strategii',
  price_monitoring_73:
    'Můžeme sledovat individuální ceny konkurence, například:',
  price_monitoring_74: 'Nízké',
  price_monitoring_75: 'náklady',
  price_monitoring_76: 'Vysoká',
  price_monitoring_77: 'efektivita',
  price_monitoring_78: 'Excel report',
  price_monitoring_79: 'PPT report',
  price_monitoring_80: 'BI report',
  price_monitoring_81:
    'Údaje o cenách konkurence vám pomohou přijímat nejlepší cenová rozhodnutí',
  price_monitoring_82:
    'Poskytujeme kompletní fotoreport, PPT report a Excel report podle typu lokality',
  qualitative_research_1: 'Kvalitativní',
  qualitative_research_2: 'výzkumy',
  qualitative_research_3:
    'Shromažďujte, analyzujte a interpretujte data prostřednictvím pozorování jednání a slov vašich zákazníků',
  qualitative_research_4: 'Hodnoty',
  qualitative_research_5: 'Chování',
  qualitative_research_6: 'Zázemí',
  qualitative_research_7: 'Očekávání',
  qualitative_research_8: 'Prostředí',
  qualitative_research_9: 'Obavy/Překážky',
  qualitative_research_10: 'Jaký je účel volby zákazníka?',
  qualitative_research_11: 'Muž s telefonem',
  qualitative_research_12: 'značka',
  qualitative_research_13: 'kategorie',
  qualitative_research_14: 'reklama',
  qualitative_research_15: 'produkt',
  qualitative_research_16:
    'Jedinečnost kvalitativních metod spočívá v tom, že nám umožňují pochopit příčiny a motivaci spotřebitelského chování',
  qualitative_research_17: 'Analýza postoje spotřebitele ke konkrétnímu jevu',
  qualitative_research_18: 'Individuální pohledy a zkušenosti',
  qualitative_research_19: 'Témata, která nelze zkoumat pomocí dotazníků',
  qualitative_research_20: 'Citlivá témata',
  qualitative_research_21: 'Obtížně dosažitelná cílová skupina',
  qualitative_research_22: 'Složitá geografie',
  qualitative_research_23: 'Hloubkové rozhovory jsou užitečné pro:',
  qualitative_research_24: 'Hloubkové rozhovory',
  qualitative_research_25:
    'Hloubkový rozhovor je technika kvalitativního výzkumu, která spočívá v individuálních rozhovorech s respondenty za účelem zkoumání jejich pohledů na konkrétní myšlenku, program nebo situaci. Hloubkový rozhovor podrobně zkoumá individuální zkušenosti, vnímání a praktiky.',
  qualitative_research_26: 'Cíle:',
  qualitative_research_27: 'Charakterizace sociálních a kulturních norem',
  qualitative_research_28: 'Obtížně dosažitelná cílová skupina',
  qualitative_research_29:
    'Sdílení a porovnávání (Morgan), které nelze zkoumat pomocí dotazníků',
  qualitative_research_30: 'Témata, která nelze zkoumat pomocí dotazníků',
  qualitative_research_31: 'Hloubkové fokusní skupiny jsou užitečné pro:',
  qualitative_research_32: 'Fokusní skupiny',
  qualitative_research_33:
    'Hloubkové zkoumání individuálních setkání, vznikajících diskusí a interakcí pod vedením moderátora skupiny.',
  qualitative_research_34:
    'Získávání poznatků o sdílených zkušenostech a sociálních normách prostřednictvím skupinové diskuse a narativních dat v řízené diskusi.',
  qualitative_research_36: 'Výhody:',
  qualitative_research_37:
    'Studium životního stylu a chování spotřebitele v různých reálných podmínkách (doma, na prodejním místě, v práci atd.)',
  qualitative_research_38:
    'Hledání insightů pro vývoj nových produktů, obalů, zlepšení služeb apod.',
  qualitative_research_39: 'Hloubkový etnografický výzkum je užitečný pro:',
  qualitative_research_40: 'Etnografický výzkum',
  qualitative_research_41:
    'Etnografie je typ kvalitativního výzkumu, který spočívá v ponoření se do konkrétní komunity nebo organizace za účelem přímého pozorování jejího chování a interakcí.',
  qualitative_research_42:
    'Etnografie je flexibilní výzkumná metoda, která umožňuje hluboce porozumět sdílené kultuře, zvyklostem a sociální dynamice skupiny. Zároveň však přináší určité praktické a etické výzvy.',
  qualitative_research_43: 'Metody:',
  qualitative_research_44:
    'Etnografie je studium spotřebitele v reálných podmínkách a jeho interakce s produktem/službou',
  qualitative_research_45: 'Výhody spolupráce s námi',
  qualitative_research_46:
    'Dokážeme najít respondenty z jakékoli cílové skupiny. A kontrolujeme kvalitu náboru.',
  qualitative_research_47: 'Nábor jakékoli úrovně složitosti',
  qualitative_research_48:
    'Naši moderátoři jsou vícejazyční a mají facilitační dovednosti',
  qualitative_research_49: 'Zkušení moderátoři',
  qualitative_research_50: 'Práce online/offline',
  qualitative_research_51: 'Poskytujeme audio/video',
  qualitative_research_52: 'záznamy',
  qualitative_research_53:
    'Můžeme provádět kvalitativní výzkum v jakékoli lokalitě',
  quantitative_research_1: 'Studium spokojenosti zákazníků',
  quantitative_research_2: 's konkrétním produktem nebo službou (SCI, NPS)',
  quantitative_research_3: 'Provádění segmentačních',
  quantitative_research_4: 'výzkumů různých trhů',
  quantitative_research_5: 'Průzkum trhu',
  quantitative_research_6: 'Řízení NPS',
  quantitative_research_7: 'Analýza konkurence',
  quantitative_research_8: 'Kvantitativní',
  quantitative_research_9: 'výzkumy',
  quantitative_research_10:
    'Výzkumná metodologie, která využívá objektivní, číselná a statistická data k ověřování teorií o postojích a chování lidí',
  quantitative_research_11: 'let',
  quantitative_research_12: 'zkušeností s CX po celém světě',
  quantitative_research_13: 'panel',
  quantitative_research_14: 'respondentů',
  quantitative_research_15: 'zemí',
  quantitative_research_16: 'realizujeme projekty po celém světě',
  quantitative_research_17: 'Kdo jsme',
  quantitative_research_18:
    '4Service je globální holding zaměřený na marketingový výzkum a CX. Nabízíme odborné služby sběru dat pro širokou škálu podniků',
  quantitative_research_19: '4Service v číslech',
  quantitative_research_20: 'Počítačem podporované',
  quantitative_research_21: 'webové dotazování',
  quantitative_research_22:
    'Technika dotazování prostřednictvím internetu. Respondent vyplňuje elektronický dotazník bez pomoci tazatele. Dotazník může být zaslán elektronicky nebo zveřejněn na webových stránkách.',
  quantitative_research_23: 'Počítačem podporované webové dotazování',
  quantitative_research_24: 'Ve většině případů',
  quantitative_research_25:
    'je tato metoda nejefektivnější z hlediska nákladů i času',
  quantitative_research_26: 'Tento průzkum poskytuje',
  quantitative_research_27:
    'možnost oslovit obtížně dosažitelnou cílovou skupinu',
  quantitative_research_28: 'Nabízí široké možnosti',
  quantitative_research_29: 'pro prezentaci videí, audia i obrázků',
  quantitative_research_30: 'Respondenti mohou být',
  quantitative_research_31: 'kdekoli na světě',
  quantitative_research_32: 'Umožňuje zkoumat',
  quantitative_research_33:
    'specifické chování internetové populace. Klient má přístup k hlavním výsledkům v reálném čase prostřednictvím webového rozhraní',
  quantitative_research_34: 'Vhodné pro jakékoli důvěrné,',
  quantitative_research_35:
    'citlivé či osobní téma nebo problém, na který by respondenti mohli váhat odpovědět při rozhovoru s tazatelem',
  quantitative_research_36: 'Panel s více než 150 000 respondenty',
  quantitative_research_37: 'Máme vlastní panel respondentů po celém světě',
  quantitative_research_38: 'Pracujeme i s náročnými zadáními',
  quantitative_research_39:
    'Pomocí doplňkových nástrojů (sociální sítě, reklama) dokážeme najít specifickou cílovou skupinu i respondenty se specifickým profilem',
  quantitative_research_40: 'Motivujeme naše respondenty',
  quantitative_research_41:
    'Navrhli jsme systém motivace pro dokončení dlouhých dotazníků prostřednictvím materiálních odměn',
  quantitative_research_42: 'Osobní rozhovory',
  quantitative_research_43: 'prováděné pomocí tabletu',
  quantitative_research_44:
    'Jedná se o jednu z hlavních metod sběru kvantitativních dat, při níž tazatel komunikuje přímo s respondentem podle přesně strukturovaného dotazníku.',
  quantitative_research_45:
    'Osobní rozhovory mohou probíhat na pracovišti nebo v místě bydliště respondentů, na ulici či na určených prodejních místech s využitím tabletu',
  quantitative_research_46: 'Osobní rozhovory prováděné pomocí tabletu',
  quantitative_research_47: 'Určení úrovně',
  quantitative_research_48: 'známosti a povědomí o značce',
  quantitative_research_49: 'Segmentace spotřebitelů',
  quantitative_research_50: 'na základě jejich nákupního chování',
  quantitative_research_51: 'Analýza efektivity',
  quantitative_research_52: 'reklamní kampaně',
  quantitative_research_53: 'Měření',
  quantitative_research_54: 'spokojenosti zákazníků',
  quantitative_research_55: 'Stanovení nejlepší ceny',
  quantitative_research_56: 'pro produkt nebo službu',
  quantitative_research_57: 'Analýza',
  quantitative_research_58: 'spotřebitelských preferencí',
  quantitative_research_59: 'Studium',
  quantitative_research_60: 'způsobu, jakým spotřebitelé nakupují',
  quantitative_research_61: 'Posouzení',
  quantitative_research_62: 'kapacity trhu',
  quantitative_research_63: 'Software DigSee',
  quantitative_research_64:
    'Používáme specializovaný software se zvukovým záznamem a GPS',
  quantitative_research_65: 'Tazatelé a supervizoři',
  quantitative_research_66:
    'můžeme provádět rozhovory v jakémkoli jazyce a překládat je do preferovaného jazyka klienta',
  quantitative_research_67: 'Výběr vzorku',
  quantitative_research_68:
    'Analytické oddělení vytváří systém náboru respondentů pro dosažení co nejlepších výsledků',
  quantitative_research_69: 'Počítačem podporované',
  quantitative_research_70: 'telefonické dotazování',
  quantitative_research_71:
    'Metodologie sběru kvantitativních informací prostřednictvím telefonických rozhovorů s využitím jasně strukturovaného dotazníku.',
  quantitative_research_72: 'Počítačem podporované telefonické dotazování',
  quantitative_research_73: 'Máme vlastní call centra',
  quantitative_research_74:
    'Používáme specializovaný software se zvukovým záznamem a GPS',
  quantitative_research_75: 'Kvalifikovaní operátoři',
  quantitative_research_76:
    'Naši operátoři hovoří různými jazyky, jsou vyškoleni, důkladně prověřeni a neustále rozvíjejí své dovednosti',
  quantitative_research_77: 'Databáze',
  quantitative_research_78:
    'Pracujeme s vlastními databázemi i s databázemi vašich zákazníků',
  quantitative_research_79: 'SLA',
  quantitative_research_80:
    'Garantujeme kvalitu a uzavíráme SLA (Service Level Agreement)',
  quantitative_research_81: 'Stanovení cílů',
  quantitative_research_82: 'Určení metodologie',
  quantitative_research_83: 'Segmentace a výběr vzorku',
  quantitative_research_84: 'Definování kanálů sběru dat',
  quantitative_research_85:
    'Vytvoření dotazníku, který je pro respondenta logický',
  quantitative_research_86: 'Proces sběru dat',
  quantitative_research_87: 'Zajištění kvality',
  quantitative_research_88: 'Analytické techniky',
  quantitative_research_89: 'Zpracování dat',
  quantitative_research_90: 'Návrh dotazníku',
  quantitative_research_91: 'GPS sledování polohy tazatelů',
  quantitative_research_92: 'Ověření dat',
  quantitative_research_93: 'Programování a testování dotazníků',
  quantitative_research_94: 'Validace dat',
  quantitative_research_95: 'Zvukové záznamy při dodržení požadavků GDPR',
  quantitative_research_96:
    'Školení a odborná způsobilost výzkumných pracovníků',
  quantitative_research_97: 'Zajištění kvality',
  quantitative_research_98: 'Faktorová analýza',
  quantitative_research_99: 'Segmentace',
  quantitative_research_100: 'Percepční mapování',
  quantitative_research_101: 'Korelace',
  quantitative_research_102: 'Konverzní model',
  quantitative_research_103: 'Jaccard',
  quantitative_research_104: 'Shluková analýza',
  quantitative_research_105: 'atd.',
  quantitative_research_106: 'Analytické reporty',
  quantitative_research_107:
    'Používáme SPSS® a další nástroje pro tvorbu analytických reportů s využitím různých metodologií',
  quantitative_research_108: 'Jaké obchodní výzvy lze řešit:',
  quantitative_research_109: 'Jaké obchodní výzvy lze řešit:',
  social_responsibility_1: 'Společenská odpovědnost společnosti 4Service',
  social_responsibility_2:
    'Ze srdce a duše každého člena našeho týmu. Snažíme se udržovat jiskru laskavosti v každém z našich zaměstnanců a dělat svět kolem nás o něco lepším',
  social_responsibility_3: 'Vzdělávací aktivity / Podpora mládeže',
  social_responsibility_4: 'Naše vzdělávací iniciativy pro děti a studenty',
  social_responsibility_5: 'Obchodní hra Service Mania',
  social_responsibility_6:
    'Důležitou součástí našich vzdělávacích aktivit je obchodní hra Service Mania.',
  social_responsibility_7:
    'Service Mania vás vyzývá ke strategickému přemýšlení o tom, jak řešit neobvyklé situace.',
  social_responsibility_8: 'Prezentace výzkumu / Diiya. Business',
  social_responsibility_9:
    'Obchodní pohled a pohled zákazníků na situaci v oblasti služeb: prezentace výsledků výzkumu společnosti 4Service od Viktorie Skorboty, ředitelky rozvoje společnosti 4Service Ukrajina',
  social_responsibility_10: 'Workshopy Service Design',
  social_responsibility_11:
    'Metodologie Service Design je důležitou součástí společnosti 4Service. Před několika lety jsme se stali partnerem DesignThinkers Academy a nejenže využíváme osvědčené postupy ve své práci, ale také aktivně školíme přední společnosti.',
  social_responsibility_12: 'Charita / Dobrovolnictví',
  social_responsibility_13:
    'Dětské domovy, domovy pro seniory a dobrovolnictví pro ukrajinskou armádu. Nejdojemnější část našich aktivit',
  social_responsibility_14: '#HelpEasyWith4ServiceGroup',
  social_responsibility_15:
    'Spolupracujeme s charitativním fondem Blagomai a snažíme se přinášet radost i pomoc těm, kteří ji nejvíce potřebují',
  social_responsibility_16: 'Sbírky pro dětské domovy a domovy pro seniory',
  social_responsibility_17:
    'Ve společnosti 4Service jsme iniciovali několik sbírek pro domovy seniorů a dětské domovy na nákup základních potřeb',
  social_responsibility_18: '#SaveUkraine',
  social_responsibility_19:
    'Válka zasáhla mnoho našich zaměstnanců i blízkých přátel. Každý z nás pomáhá, jak jen může',
  social_responsibility_20: 'Ochrana zvířat',
  social_responsibility_21:
    'Kdokoli může přijít do naší kanceláře se svým domácím mazlíčkem. Pomáháme útulkům, organizujeme sbírky na krmivo a někdy také hledáme domovy pro opuštěná zvířata',
  social_responsibility_22: 'Podpora útulků pro zvířata',
  social_responsibility_23:
    'Opuštěná zvířata potřebují pomoc stejně jako ostatní zranitelní členové naší společnosti.',
  social_responsibility_24:
    'Naše společnost převzala patronát nad útulkem pro opuštěná zvířata Sirius (Kyjevská oblast, Ukrajina).',
  social_responsibility_25: 'Kreativní iniciativy na pomoc opuštěným zvířatům',
  social_responsibility_26:
    'Jak můžeme upozornit naše zákazníky a partnery na naléhavý problém zvířecích útulků?',
  social_responsibility_27: 'Pet friendly kancelář',
  social_responsibility_28:
    'Mnoho členů našeho týmu má domácí mazlíčky. Vytvořili jsme příjemné prostředí, kde může každý přijít do kanceláře se svým mazlíčkem a cítit se pohodlně',
  ux_testing_1: 'UX testování',
  ux_testing_1_1: 'UX testování',
  ux_testing_2:
    'Přístup založený na lidech a umělé inteligenci pro testování a zlepšování vašich webových stránek a aplikací',
  ux_testing_3: 'Co je UX testování',
  ux_testing_4:
    'UX testování vám pomáhá pochopit, jak lidé interagují s vaším produktem, aplikací nebo webovou stránkou',
  ux_testing_5: 'Navigace není příliš přehledná',
  ux_testing_6: 'Nemám ponětí, jak vytvořit objednávku',
  ux_testing_7: 'V katalogu není dostatek fotografií',
  ux_testing_8: 'Získáte:',
  ux_testing_9: 'Objevíte příležitosti ke zlepšení',
  ux_testing_10: 'Identifikujete problémy v designu a interakci zákazníka',
  ux_testing_11:
    'Zjistíte, s jakými obtížemi se uživatel při používání webu setkává',
  ux_testing_12: 'Budete sledovat cestu zákazníka',
  ux_testing_13: 'Zjistíte, kdy a proč vaše cílová skupina opouští web',
  ux_testing_14:
    'Určíte, které části vzbuzují nejmenší a největší zájem a emoce',
  ux_testing_15: 'UX testování s uživateli',
  ux_testing_16:
    '4Service vám poskytuje skutečné poznatky od uživatelů potřebné k vytváření webů a aplikací orientovaných na zákazníka pomocí kvalitativních i kvantitativních metod',
  ux_testing_17: 'Nechápu, jak web používat. Kde je skryté menu?',
  ux_testing_18:
    'Myslím, že mezi písmeny je příliš mnoho prostoru, text je nečitelný',
  ux_testing_19: 'Obrázky se překrývají. Má to tak být?',
  ux_testing_20:
    'UX testování vám pomáhá pochopit, jak lidé interagují s vaším produktem, aplikací nebo webovou stránkou',
  ux_testing_21: 'Návrh výzkumu UX testování s uživateli:',
  ux_testing_22: 'Objevte příležitosti ke zlepšení',
  ux_testing_23: 'Určení typu a metody testování (kvalitativní/kvantitativní)',
  ux_testing_24: 'Příprava hypotéz a uživatelských scénářů',
  ux_testing_25: 'Analýza a reporting výsledků testování',
  ux_testing_26: 'Dvě řešení',
  ux_testing_27: 'Nabízíme dva přístupy k úspěšnému UX testování',
  ux_testing_28: 'UX testování s uživateli',
  ux_testing_29: 'UX testování založené na AI + lidech',
  ux_testing_30: 'Naše silné stránky:',
  ux_testing_31: 'Dokážeme analyzovat konkurenční prostředí',
  ux_testing_32:
    'Můžeme zapojit úzce specializované odborníky pro vedení rozhovorů i účast v nich',
  ux_testing_33:
    'Rozhovory můžeme vést v různých jazycích a překládat je do požadovaného jazyka',
  ux_testing_34: 'se stávajícími metrikami použitelnosti',
  ux_testing_35: 'nebo standardy',
  ux_testing_36: 'vaše výsledky',
  ux_testing_37: 've srovnání s konkurencí',
  ux_testing_38: 'verze',
  ux_testing_39: 'stejného produktu',
  ux_testing_40: 'Hodnocení spokojenosti',
  ux_testing_41: 'NPS',
  ux_testing_42: 'Míra úspěšnosti',
  ux_testing_43: 'Míra chyb',
  ux_testing_44: 'Doba dokončení úkolu',
  ux_testing_45: 'UX testování s uživateli',
  ux_testing_46: 'Kvantitativní metoda',
  ux_testing_47: 'V této fázi UX testování využíváme nejméně 100 účastníků',
  ux_testing_48:
    'Relevantní, pokud potřebujete porovnat svůj web nebo aplikaci:',
  ux_testing_49: 'Kvantitativní metoda měří:',
  ux_testing_50: 'Pozorování',
  ux_testing_51:
    'Trávení času s uživatelem nebo skupinou uživatelů a pozorování jejich chování při každodenním používání produktu',
  ux_testing_52: 'Hloubkový rozhovor',
  ux_testing_53:
    'Umožňuje poznat postoje, přesvědčení, přání a zkušenosti uživatelů, kteří navštěvují váš web. Doporučujeme provést 15–20 rozhovorů',
  ux_testing_54: 'Etnografický výzkum',
  ux_testing_55:
    'Provádí se v prostředí respondentů, kde budou produkt používat. Díky pozorování lépe porozumíte psychologii uživatele i emocionálním výzvám, kterým čelí.',
  ux_testing_56: 'UX testování s uživateli',
  ux_testing_57: 'Kvalitativní metoda',
  ux_testing_58:
    'Tato metoda pomáhá pochopit motivace a logiku chování uživatelů',
  ux_testing_59: 'Používáme:',
  ux_testing_60:
    'Vytváříme mapu cesty zákazníka, která ilustruje výsledky našeho výzkumu',
  ux_testing_61: '30 účastníků (muži/ženy)',
  ux_testing_62:
    'Provádíme předvýběr respondentů a zveme je k účasti ve výzkumu',
  ux_testing_63: 'Vzdálené online rozhovory na platformě Wantent',
  ux_testing_64: 'AI + lidé',
  ux_testing_65: 'UX testování založené na AI + lidech',
  ux_testing_66:
    'Kombinace jedinečné technologie umělé inteligence Wantent a skutečných uživatelů',
  ux_testing_67: 'Velké písmo v nadpisu upoutalo pozornost',
  ux_testing_68:
    'Uživatelé se dívají na „výrazná“ čísla, ale nečtou informace vedle nich',
  ux_testing_69:
    'UX testování vám pomáhá pochopit, jak lidé interagují s vaším produktem, aplikací nebo webovou stránkou',
  ux_testing_70: 'Návrh výzkumu AI + human-based testování',
  ux_testing_71: 'Jak to funguje',
  ux_testing_72:
    'Wantent je řešení content-market fit založené na umělé inteligenci.',
  ux_testing_73:
    'Wantent hodnotí efektivitu webových stránek a aplikací pomocí technologií strojového učení (ML) pro analýzu emocí a zapojení publika.',
  ux_testing_74:
    'Pro interpretaci výsledků využíváme techniky storytellingu, diverzitu a empatii, abychom podpořili výkonnost a růst.',
  ux_testing_75:
    'Pozornost a emoce uživatele během přechodů mezi jednotlivými sekcemi',
  ux_testing_76:
    'Statistiky podle skupin účastníků (pozornost a soustředění během celé relace)',
  ux_testing_77: 'Analýza konverzí stránek',
  ux_testing_78: 'Pozornost a emoce při plnění úkolů',
  ux_testing_79: 'Závěry o vnímání',
  ux_testing_80: 'webových stránek různými skupinami účastníků',
  ux_testing_81: 'Analýza snadnosti',
  ux_testing_82:
    'navigace mezi stránkami a snadnosti nalezení důležitých prvků',
  ux_testing_83: 'Analýza vnímání',
  ux_testing_84: 'informací prezentovaných na webových stránkách',
  ux_testing_85: 'Určení oblastí',
  ux_testing_86:
    'ke zlepšení na jednotlivých stránkách (navigace, informační bloky atd.)',
  ux_testing_87: 'Podrobně analyzujeme',
  ux_testing_88: 'Klíčové výsledky výzkumu',
  ux_testing_89:
    'Doporučení pro zlepšení struktury webových stránek a jednotlivých stránek',
  ux_testing_90:
    'Pečlivě vybíráme cílovou skupinu pro testování použitelnosti.',
  ux_testing_91:
    'Provádíme výzkumy v různých zemích, různých jazycích a mezi různými skupinami uživatelů',
  ux_testing_92: 'Můžeme testovat v aplikacích',
  ux_testing_93:
    'a na webových stránkách konkurence a poskytovat srovnávací analýzu',
  ux_testing_94: 'Kombinujeme různé výzkumné metody.',
  ux_testing_95:
    'Naši kvalifikovaní facilitátoři provázejí účastníky celým procesem testování.',
  ux_testing_96: 'Provádíme testování',
  ux_testing_97: 'na různých zařízeních a verzích softwaru',
  ux_testing_98: 'Proč si vybrat právě nás?',
  wantent_1: '4Service x',
  wantent_2: 'Wantent',
  wantent_3:
    'Jedinečný partnerský projekt společností 4Service a Wantent © Kombinace umělé inteligence a přístupu založeného na práci s lidmi pro analýzu obsahu',
  wantent_4: 'měření úspěšnosti ještě před zveřejněním obsahu',
  wantent_5: 'minimalizace rizik souvisejících s otázkami diverzity',
  wantent_6: 'hluboké poznatky a doporučení pro zlepšení obsahu',
  wantent_7: 'objektivní rozhodování o obsahu a marketingové strategii',
  wantent_8:
    'Wantent je řešení content-market fit založené na umělé inteligenci.',
  wantent_9:
    'Wantent je řešení založené na umělé inteligenci pro sladění obsahu s trhem. Hodnotí efektivitu videoobsahu pomocí technologií strojového učení (ML), které analyzují emocionální reakce a zapojení publika.',
  wantent_10:
    'Wantent pomáhá určit content-market fit a maximalizovat efektivitu obsahu prostřednictvím:',
  wantent_11: 'Nastavení scénáře a nábor účastníků',
  wantent_12:
    'personalizovaného návrhu projektu a zapojení publika po celém světě',
  wantent_13: 'Shromažďování reakcí diváků',
  wantent_14: 'podrobné a srozumitelné zpětné vazby od publika',
  wantent_15: 'Analýzy vnímání obsahu',
  wantent_16: 'analýzy chování a emocionálních reakcí pomocí AI',
  wantent_17: 'Poskytnutí poznatků pro závěrečné vyhodnocení',
  wantent_18: 'doporučení pro zlepšení',
  wantent_19: 'Wantent maximalizuje efektivitu vašeho obsahu',
  wantent_20: 'Předběžné testování reklamních konceptů',
  wantent_21: 'Testování kreativních konceptů',
  wantent_22:
    'Ověření souladu budoucí kreativy s vytvořenou strategií a pochopení reakcí cílové skupiny pro případné úpravy kreativních konceptů či sdělení',
  wantent_23: 'Testování viditelnosti prvků značky (postprodukce)',
  wantent_24: 'Potvrzení efektivity investic do reklamy a sponzoringu',
  wantent_25: 'Testování reklamy',
  wantent_26: 'A/B testování',
  wantent_27:
    'Porovnání efektivity kreativ a zvýšení zapojení i pozornosti během produkční fáze',
  wantent_28: 'Testování spuštěné reklamy',
  wantent_29:
    'Vyhodnocení účinnosti sdělení a tvorba doporučení pro zlepšení zvuku i vizuální stránky',
  wantent_30: 'Řešení pro televizi',
  wantent_31:
    'Testování pilotních dílů, upoutávek, nových formátů a televizních moderátorů',
  wantent_32:
    'Provádění srovnávací analýzy za účelem identifikace nejzajímavější varianty a jejího posílení',
  wantent_33: 'Testování televizních pořadů a celovečerních filmů',
  wantent_34:
    'Analýza zapojení diváků, úrovně pozornosti a emocionálních reakcí při sledování dlouhého obsahu v přirozených podmínkách. Automaticky identifikujeme okamžiky poklesu zájmu publika a momenty rozptýlení, abychom mohli vyhodnotit a zlepšit střih videa.',
  wantent_35: 'UI/UX testování',
  wantent_36: 'Testování prototypů webových stránek a mobilních aplikací',
  wantent_37: 'Analýza reakcí a emocí uživatelů pomocí technologie Wantent:',
  wantent_38: 'úroveň pozornosti',
  wantent_39: 'emocionální reakce',
  wantent_40: 'teplotní mapy směru pohledu účastníků',
  wantent_41:
    'Analýza použitelnosti webových stránek a aplikací na základě zpětné vazby účastníků:',
  wantent_42: 'System Usability Scale (SUS)',
  wantent_43: 'Client Effort Score (snadnost interakce)',
  wantent_44: 'Net Promoter Score (NPS)',
  wantent_45: 'Soulad s GDPR a ochrana soukromí uživatelů',
  wantent_46:
    'Wantent je plně v souladu s požadavky GDPR a CCPA a splňuje zásady shromažďování, ukládání, zpracování a ochrany osobních údajů účastníků.',
  wantent_47: 'Nikita Lobyntsev',
  wantent_48: 'CDO, Reface (Media & Entertainment)',
  wantent_49:
    'Každý den experimentujeme s množstvím nových nápadů na obsah pomocí technologií strojového učení. Wantent nám pomáhá pochopit a vyhodnotit rizika i výhody, objevit zpětnou vazbu uživatelů, jejich chování a vnímání a odhalit příčinné souvislosti různých aspektů našich řešení.',
  wantent_50: 'Alexander Smirnov',
  wantent_51: 'spolumajitel TABASCO (reklama)',
  wantent_52:
    'Wantent poskytuje skutečně jedinečnou službu, která nám umožňuje poznat i ty nejjemnější detaily toho, co se spotřebitelům líbí a nelíbí. Není možné podvádět ani lhát – Wantent vždy zná pravdu. Díky tomu získáváme jako marketingoví odborníci neocenitelná (haha – přesně víme, kolik stojí, a je cenově dostupná) doporučení, jak zlepšit naši komunikaci.',
  wantent_53: 'Reference',
  terms_1: 'Obchodní podmínky',
  terms_2: 'Podmínky používání',
  terms_3:
    'Před používáním těchto webových stránek si prosím pečlivě přečtěte tyto Podmínky používání („podmínky používání“, „smlouva“).',
  terms_4:
    '("webové stránky") provozované společností 4Service Holdings GmbH („4Service“, „my“, „nás“, „naše“).',
  terms_5:
    'Podmínky používání. Používáním těchto webových stránek potvrzujete, že jste si tuto smlouvu přečetli, porozuměli jí a souhlasíte s jejím dodržováním. Pokud nechcete být těmito podmínkami vázáni, doporučujeme webové stránky opustit. Společnost 4Service poskytuje přístup ke svým webovým stránkám, produktům a službám pouze těm uživatelům, kteří tyto podmínky přijali.',
  terms_6: 'Zásady ochrany osobních údajů',
  terms_7:
    'Než budete pokračovat v používání našich webových stránek, doporučujeme vám seznámit se s našimi Zásadami ochrany osobních údajů týkajícími se shromažďování údajů o uživatelích. Pomohou vám lépe porozumět našim postupům.',
  terms_8: 'Věkové omezení',
  terms_9:
    'Pro používání těchto webových stránek musíte být starší 16 (šestnácti) let. Používáním těchto webových stránek potvrzujete, že jste dosáhli věku alespoň 16 let a že můžete tuto smlouvu právně uzavřít. Společnost 4Service nenese odpovědnost za jakékoli závazky související s nepravdivým uvedením věku.',
  terms_10: 'Duševní vlastnictví',
  terms_11:
    'Souhlasíte s tím, že všechny materiály, produkty a služby poskytované na těchto webových stránkách jsou vlastnictvím společnosti 4Service, jejích přidružených společností, ředitelů, vedoucích pracovníků, zaměstnanců, zástupců, dodavatelů nebo poskytovatelů licencí, včetně všech autorských práv, obchodních tajemství, ochranných známek, patentů a dalších práv duševního vlastnictví. Souhlasíte také s tím, že nebudete žádným způsobem reprodukovat ani šířit duševní vlastnictví společnosti 4Service, a to ani elektronicky, digitálně či prostřednictvím nových registrací ochranných známek.',
  terms_12: 'Přístup k našim webovým stránkám',
  terms_13:
    'Přístup na naše webové stránky je poskytován dočasně a vyhrazujeme si právo kdykoli bez předchozího upozornění změnit nebo ukončit poskytované služby. Nenese odpovědnost, pokud budou naše stránky z jakéhokoli důvodu kdykoli nebo po určitou dobu nedostupné. Čas od času můžeme omezit přístup k některým částem našich stránek nebo k celému webu pouze registrovaným uživatelům. Odpovídáte za zajištění všech prostředků potřebných pro přístup na naše stránky, včetně používání zařízení kompatibilního s našimi stránkami. Odpovídáte také za to, že všechny osoby přistupující na naše stránky prostřednictvím vašeho internetového připojení budou seznámeny s těmito podmínkami a budou je dodržovat.',
  terms_14: 'Rozhodné právo',
  terms_15:
    'Používáním těchto webových stránek souhlasíte s tím, že se tyto podmínky a jakékoli spory mezi vámi a společností 4Service budou řídit právem Rakouské republiky bez ohledu na kolizní normy.',
  terms_16: 'Spory',
  terms_17:
    'Jakýkoli spor související s vaší návštěvou těchto webových stránek bude řešen u Obchodního soudu ve Vídni.',
  terms_18: 'Odškodnění',
  terms_19:
    'Souhlasíte s tím, že odškodníte společnost 4Service a její přidružené společnosti a ochráníte je před právními nároky a požadavky, které mohou vzniknout v důsledku používání nebo zneužití našich webových stránek. Vyhrazujeme si právo zvolit si vlastního právního zástupce.',
  terms_20: 'Doba uchovávání',
  terms_21:
    'S ohledem na účely zpracování je doba uchovávání osobních údajů Uživatelů (doba uchovávání) 24 měsíců ode dne, kdy od Vás řádně získáme souhlas se zpracováním údajů.',
  terms_22: 'Omezení odpovědnosti',
  terms_23:
    'Společnost 4Service nenese odpovědnost za žádné škody, které Vám mohou vzniknout v důsledku nesprávného používání našich webových stránek. Společnost 4Service si vyhrazuje právo kdykoli bez předchozího upozornění upravit, změnit nebo aktualizovat tuto Smlouvu zveřejněním nové verze. Vaše další používání webových stránek po zveřejnění těchto změn znamená jejich přijetí. Pokud bude některé ustanovení této Smlouvy prohlášeno za nezákonné, neplatné nebo nevymahatelné, bude považováno za oddělitelné a nebude mít vliv na platnost a vymahatelnost ostatních ustanovení. Případné důkazy o používání webových stránek k nezákonným účelům budou předány příslušným orgánům činným v trestním řízení. Tato Smlouva představuje dohodu mezi společností 4Service a uživatelem.',
  terms_24:
    'Veškeré dotazy a připomínky týkající se ochrany soukromí nebo používání směřujte na následující adresu:',
  terms_25: '4Service Holdings GmbH',
  terms_26: 'Tegetthoffstrasse 7',
  terms_27: '1010 Vídeň',
  terms_28: 'Rakousko',
  terms_29: 'Kontrola',
  terms_30:
    'Pokud osobní údaje, které jste nám poskytli, nejsou přesné, máte právo požádat nás o jejich opravu (článek 16 GDPR).',
  thank_you_1: 'Děkujeme!',
  thank_you_2: 'Ozveme se Vám do 24 hodin',
  thank_you_3:
    'P.S. Naši manažeři již posuzují Vaši žádost, aby pro Vás připravili co nejlepší nabídku.',
  thank_you_4: 'Menu',
  thank_you_5: 'Žena píšící na klávesnici',
  privacy_policy_1:
    'Oznámení o ochraně osobních údajů pro subjekty údajů (uživatele webových stránek)',
  privacy_policy_2:
    'Toto Oznámení o ochraně osobních údajů (Oznámení) je určeno fyzickým osobám (subjektům údajů), jejichž osobní údaje shromažďuje společnost 4Service Holdings GmbH v souladu s požadavky GDPR při návštěvě webových stránek.',
  privacy_policy_3:
    '(dále jen Webové stránky a Uživatelé webových stránek/Uživatelé).',
  privacy_policy_4:
    'Toto Oznámení o ochraně osobních údajů pro subjekty údajů (uživatele webových stránek) společnosti 4Service Holdings GmbH se vztahuje na všechny společnosti skupiny 4Service, které podléhají právní pravomoci, dohledu nebo kontrole společnosti 4Service Holdings GmbH.',
  privacy_policy_5: 'Kontakty',
  privacy_policy_6: '4Service Holdings GmbH',
  privacy_policy_7: '(Společnost/my/nás),',
  privacy_policy_8: 'Adresa:',
  privacy_policy_9: 'Tegetthoffstraße 7, 1010 Vídeň, Rakousko.',
  privacy_policy_10: 'E-mail:',
  privacy_policy_12: 'Kdo jsme?',
  privacy_policy_13:
    'Fyzická osoba (Vy), která navštíví Webové stránky za jakýmkoli účelem. Pro účely tohoto dokumentu jste dále označováni také jako Uživatel.',
  privacy_policy_14: 'Osobní údaje, které od Vás shromažďujeme',
  privacy_policy_15:
    'Při vstupu na naše Webové stránky Vám zobrazíme Oznámení o ochraně osobních údajů, ve kterém Vás žádáme o souhlas se zpracováním následujících údajů:',
  privacy_policy_16:
    'IP adresa, jméno, příjmení, adresa, telefonní číslo (pevná linka nebo mobilní telefon), e-mailová adresa, název společnosti, země, jméno, příjmení, telefonní číslo, provincie, stát a PSČ, údaje o používání, údaje o interakci s externími sociálními sítěmi nebo platformami, informace o registraci a autentizaci na webových stránkách',
  privacy_policy_17: 'geografická poloha.',
  privacy_policy_18:
    'Pokud vyjádříte svou vůli a udělíte nám tento souhlas, začneme tyto údaje zpracovávat.',
  privacy_policy_19: 'Zákonnost (souhlas)',
  privacy_policy_20:
    'Při vstupu na naše Webové stránky Vám zobrazíme Oznámení o ochraně osobních údajů, ve kterém Vás žádáme o souhlas se zpracováním následujících údajů:',
  privacy_policy_21:
    'Právním základem pro zpracování osobních údajů je souhlas, který od Vás získáme prostřednictvím vyplnění formuláře souhlasu na následujícím odkazu:',
  privacy_policy_22:
    'Vyplněním formuláře souhlasu potvrzujete, že rozumíte všem podmínkám uvedeným v tomto Oznámení o ochraně osobních údajů a souhlasíte s nimi.',
  privacy_policy_23: 'Odvolání souhlasu',
  privacy_policy_24:
    'Máte právo kdykoli odvolat souhlas, který jste nám dříve poskytli. Odvolání souhlasu nemá vliv na zákonnost zpracování založeného na souhlasu před jeho odvoláním. Souhlas můžete odvolat zasláním příslušné žádosti na e-mailovou adresu withdraw@4service-group.com. Formulář žádosti je k dispozici na následujícím odkazu:',
  privacy_policy_25: 'Formulář pro odvolání souhlasu uživatele',
  privacy_policy_26: 'Účely zpracování',
  privacy_policy_27: 'Vaše osobní údaje zpracováváme pro následující účely:',
  privacy_policy_28:
    '– zlepšení služeb pro klienty (umožňuje efektivněji reagovat na požadavky klientů); – personalizace uživatelské zkušenosti (umožňuje určit, kdo má o služby největší zájem); – zlepšení Webových stránek (umožňuje zvyšovat kvalitu produktů a služeb, pohodlí jejich používání, vyvíjet nové služby a zdokonalovat naše produkty a služby); – komunikace s Uživatelem prostřednictvím newsletterů, marketingových či propagačních materiálů a dalších informací obsahujících naše novinky, aktualizace a informace o službách spolu s pokyny, jak odmítnout další e-maily; – provádění statistických a jiných výzkumů a analýz na základě anonymizovaných údajů; – poskytování personalizovaných služeb Uživateli a plnění smluv a dohod; – zapojení Uživatele do různých projektů realizovaných prostřednictvím Webových stránek, odpovídání na dotazy zaslané prostřednictvím Webových stránek, výzkum, vedení záznamů a propagace služeb.',
  privacy_policy_29: 'Subjekty, kterým mohou být osobní údaje předány',
  privacy_policy_30:
    'Při zpracování Vašich osobních údajů je předáváme subjektům, které vystupují jako zpracovatelé Společnosti. Tito zpracovatelé jednají výhradně na základě pokynů Společnosti. Podrobnosti o jejich činnostech a seznam zpracovatelů naleznete v Zásadách ochrany soukromí a osobních údajů na následujícím odkazu: Zásady ochrany soukromí a osobních údajů.',
  privacy_policy_31: 'Země, do kterých mohou být osobní údaje předávány',
  privacy_policy_32:
    'Společnost předává Vaše osobní údaje na základě rozhodnutí o odpovídající ochraně podle GDPR a Evropské komise. Další informace o předávání osobních údajů do USA naleznete v Zásadách ochrany soukromí a osobních údajů na následujícím odkazu: Zásady ochrany soukromí a osobních údajů.',
  privacy_policy_33: 'Doba uchovávání',
  privacy_policy_34:
    'S ohledem na účely zpracování je doba uchovávání osobních údajů Uživatelů (doba uchovávání) 24 měsíců ode dne, kdy od Vás řádně získáme souhlas se zpracováním údajů.',
  privacy_policy_35: 'Právo na přístup',
  privacy_policy_36:
    'Máte právo vědět, zda jsou Vaše osobní údaje zpracovávány, a pokud ano, získat k nim přístup spolu s dalšími právy uvedenými v článku 15 GDPR.',
  privacy_policy_37: 'Právo na opravu',
  privacy_policy_38:
    'Pokud osobní údaje, které jste nám poskytli, nejsou přesné, máte právo požádat nás o jejich opravu (článek 16 GDPR).',
  privacy_policy_39: 'Právo na výmaz (právo být zapomenut)',
  privacy_policy_40:
    'Máte právo požadovat, abychom bez zbytečného odkladu vymazali Vaše osobní údaje, a my jsme povinni tak učinit, pokud jsou splněny podmínky uvedené v článku 17 GDPR.',
  privacy_policy_41: 'Právo na omezení zpracování',
  privacy_policy_42:
    'Máte právo za určitých podmínek stanovených zejména v článku 18 GDPR požadovat omezení zpracování Vašich osobních údajů.',
  privacy_policy_43:
    'Jsme povinni Vás informovat o tom, jaké údaje shromažďujeme, jak je používáme, jak dlouho je uchováváme a zda budou sdíleny s třetími stranami. Tyto informace musí být sděleny stručně a srozumitelným jazykem.',
  privacy_policy_44: 'Právo na přenositelnost údajů',
  privacy_policy_45:
    'Máte právo získat své osobní údaje a znovu je použít pro své vlastní účely napříč různými službami.',
  privacy_policy_46: 'Právo vznést námitku',
  privacy_policy_47:
    'Máte právo vznést námitku proti zpracování osobních údajů prováděnému Společností. Musíme zpracování ukončit, pokud neprokážeme závažné oprávněné důvody, které převažují nad zájmy, právy a svobodami jednotlivce, nebo pokud není zpracování nezbytné pro určení, výkon nebo obhajobu právních nároků.',
  privacy_policy_48:
    'Právo nebýt předmětem rozhodnutí založeného výhradně na automatizovaném zpracování',
  privacy_policy_49:
    'Máte právo vznést námitku proti jakémukoli automatizovanému profilování prováděnému bez souhlasu. Zároveň máte právo, aby Vaše osobní údaje byly zpracovávány za účasti člověka.',
  privacy_policy_50: 'Stížnosti',
  privacy_policy_51:
    'Pokud si přejete podat stížnost na způsob, jakým Společnost (nebo výše uvedení zpracovatelé) zpracovává Vaše osobní údaje, nebo na způsob vyřízení Vaší stížnosti, máte právo podat stížnost přímo dozorovému úřadu i Společnosti.',
  privacy_policy_52: 'Kontaktní údaje jsou následující:',
  privacy_policy_53: 'Dozorový úřad:',
  privacy_policy_54: 'Rakouský úřad pro ochranu osobních údajů',
  privacy_policy_55: 'Österreichische Datenschutzbehörde',
  privacy_policy_56: 'Wickenburggasse 8',
  privacy_policy_57: '1080 Vídeň',
  privacy_policy_58: 'Rakousko / Evropa',
  privacy_policy_59: 'Společnost:',
  privacy_policy_60: '4Service Holdings GmbH (Společnost/my/nás),',
  privacy_policy_61: 'Adresa: Tegetthoffstraße 7, 1010 Vídeň, Rakousko.',
  privacy_policy_62: 'E-mail:',
  privacy_policy_63: 'Zásady ochrany soukromí a osobních údajů',
  privacy_policy_64:
    'Více informací o tom, jak a proč používáme Vaše údaje, naleznete zde: Zásady ochrany soukromí a osobních údajů.',
  privacy_policy_65: 'Schválení',
  privacy_policy_66:
    'Společnost vypracovala všechny interní dokumenty, které vymezují role zaměstnanců při zpracování osobních údajů. Za schválení a pravidelnou kontrolu oprávněnosti tohoto dokumentu odpovídá zejména výkonný ředitel.',
  contacts_1: 'Pro klienty',
  contacts_2:
    'Pro všechny typy podniků, agentury pro průzkum trhu, velké společnosti, obchodní partnery a média.',
  contacts_3: 'Tegetthoffstrasse 7, Vídeň, Rakousko',
  contacts_4: 'Pro Mystery Shoppery',
  contacts_5:
    'Místní i cestovatelé, řidiči i studenti, profesionální mystery shoppeři i lidé pracující z domova.',
  contacts_6: 'Kontaktujte nás ze své země:',
  contacts_7: 'Itálie',
  contacts_8: 'USA',
  contacts_9: 'Spojené království',
  contacts_10: 'Švýcarsko',
  contacts_11: 'Nizozemsko',
  contacts_12: 'Slovensko',
  contacts_13: 'Slovinsko',
  contacts_14: 'Rumunsko',
  contacts_15: 'Ázerbájdžán',
  contacts_16: 'Ukrajina',
  contacts_17: 'Kazachstán',
  contacts_18: 'Zbytek světa',
  menu_1: 'CJM',
  menu_2: 'NPS',
  menu_3: 'CSI',
  menu_4: 'BHT',
  menu_5: 'UX testování',
  menu_6: 'HR výzkum',
  menu_7: 'Kvalitativní výzkum',
  menu_8: 'Kvantitativní výzkum',
  menu_9: 'Mystery shopping',
  menu_10: 'Voicer',
  menu_11: 'Play4Sales',
  menu_12: 'Wantent',
  menu_13: 'Monitoring cen',
  menu_14: 'O nás',
  menu_15: 'Kontakty',
  menu_16: 'Blog',
  menu_17: 'Metody',
  menu_18: 'Produkty',
  menu_19: 'Platforma\n pro mystery shoppery',
  menu_20: 'CSR',
  menu_21: 'Analýza cen v automobilovém průmyslu',
  menu_22: 'Audit Facility Check',
  menu_23: 'Service Design',
  menu_24: 'CX',
  nps_passives: 'Pasivní',
  nps_detractors: 'Kritici',
  nps_promoters: 'Propagátoři',
  nps_a_score: 'skóre',
  area: 'Oblast',
  products_tabs_1:
    'Pro dosažení maximální efektivity realizujeme také komplexní řešení:',
  products_tabs_2: 'Produkty',
  products_tabs_3:
    'Kvalitativní výzkum spočívá ve sběru a analýze nečíselných dat za účelem pochopení konceptů, názorů nebo zkušeností',
  products_tabs_4:
    'Metody kvantitativního výzkumu představují objektivní měření a číselnou analýzu dat získaných prostřednictvím anket, dotazníků a průzkumů',
  our_clients_1: 'Naši klienti',
  preview_cases_section_1: 'Případové studie',
  preview_cases_section_2:
    'Přejděte do sekce případových studií a přečtěte si další zajímavé příspěvky',
  blog_1: 'Blog s inspirativním obsahem',
  blog_2: 'Pro váš požadavek nejsou k dispozici žádné příspěvky',
  about: 'O nás',
  why_us: 'Proč právě my',
  about_us: 'O nás',
  key_features: 'Klíčové vlastnosti',
  solutions: 'Řešení',
  monitoring: 'Monitoring',
  how: 'Jak',
  how_it_works: 'Jak to funguje',
  when_to_use: 'Kdy použít',
  mystery_shopping: 'Mystery shopping',
  voicer: 'Hlas zákazníka',
  wantent: 'Testování videoobsahu',
  play4sales: 'Play4Sales',
  price_monitoring: 'Monitoring cen',
  service_design: 'Service Design',
  qualitative_research: 'Kvalitativní výzkum',
  quantitative_research: 'Kvantitativní výzkum',
  cawi: 'CAWI',
  f2f: 'F2F',
  cati: 'CATI',
  hashtag_automotive: '#Automotive',
  hashtag_retayl: '#Retail',
  hashtag_all_posts: '#Všechny_příspěvky',
  hashtag_feedback: '#zpětná_vazba',
  hashtag_4Service_csr: '#4Service_CSR',
  hashtag_cases: '#Případové_studie',
  hashtag_market_research: '#průzkum_trhu',
  more: 'Více',
  speak_to_an_expert: 'Promluvte si s odborníkem',
  book_consultancy: 'Objednat konzultaci',
  read_all: 'Zobrazit vše',
  find_out_more: 'Zjistit více',
  address: 'Adresa',
  mon_fri: 'Po–Pá',
  phone_number: 'Telefonní číslo',
  flag: 'vlajka',
  scroll_to_left: 'posunout doleva',
  online: 'online',
  tel: 'Tel.',
  email: 'E-mail',
  light_it_up: 'Rozsviťte to',
  about_us_60: 'Alina Andreieva',
  about_us_61: 'Ředitelka rozvoje obchodu',
  about_us_62: 'Julia Kravchenko',
  about_us_63: 'Senior projektová manažerka',
  about_us_64: 'Olga Aksonova',
  about_us_65: 'Manažerka rozvoje obchodu',
  about_us_66: 'Zhelevskiy Dmitriy',
  about_us_67: 'Provozní ředitel',
  about_us_roles_1: 'Management',
  about_us_roles_2: 'Globální tým',
  about_us_roles_3: 'Vlastníci produktů',
  ad_testing_1: 'Testování reklam',
  ad_testing_2:
    'Reklamní kampaň představuje významnou investici. Ujistěte se, že vaše reklamy jsou účinné a přinášejí maximální návratnost investic (ROI)',
  ad_testing_3: 'zámek',
  ad_testing_4: 'Odvětví, kterým poskytujeme služby',
  ad_testing_5:
    '4Service je globální holding zaměřený na výzkum zákaznické zkušenosti',
  ad_testing_6:
    '4Service je globální holding zaměřený na marketingový výzkum a CX. Nabízíme profesionální služby sběru dat pro širokou škálu podniků',
  ad_testing_7: 'Cash & Carry',
  ad_testing_8: 'Maloobchod',
  ad_testing_9: 'Elektronika',
  ad_testing_10: 'Luxusní/Premium',
  ad_testing_11: 'Gastronomie a pohostinství',
  ad_testing_12: 'Automobilový průmysl',
  ad_testing_13: 'Cestování a volný čas',
  ad_testing_14: 'Móda',
  ad_testing_15: 'Banky',
  ad_testing_16: 'Hodinky a šperky',
  ad_testing_17: 'Domácnost a spotřebiče',
  ad_testing_18: 'Člen ESOMAR',
  ad_testing_19:
    'Realizovali jsme výzkumy testování reklamy pro různé podniky v různých odvětvích',
  ad_testing_20: 'Testování reklamy potřebujete, pokud',
  ad_testing_21: 'Propagujete nový produkt nebo službu',
  ad_testing_22: 'Dotýkáte se citlivého tématu',
  ad_testing_23: 'Snažíte se oslovit novou cílovou skupinu nebo trh',
  ad_testing_24: 'Porovnáváte několik různých variant designu',
  ad_testing_25:
    'Potřebujete důkaz konceptu pro vedení společnosti nebo investory',
  ad_testing_26: 'Získáte odpovědi na otázky',
  ad_testing_27: 'Které reklamní kanály jsou pro tyto reklamy nejvhodnější?',
  ad_testing_28: 'Používáme správné vizuály pro efektivní předání sdělení?',
  ad_testing_29: 'Rezonují vaše reklamní texty a sdělení s publikem?',
  ad_testing_30: 'Které reklamní kanály jsou pro tyto reklamy nejvhodnější?',
  ad_testing_31: 'Co upoutá jejich pozornost jako první?',
  ad_testing_32: 'Je umístění a rozvržení reklamy snadno pochopitelné?',
  ad_testing_33: 'Hodnotíme',
  ad_testing_34: 'Branding',
  ad_testing_35:
    'jak je vaše značka propojena s reklamou a jak dobře si ji lidé zapamatují',
  ad_testing_36: 'Klíčové metriky',
  ad_testing_37: 'Integrace',
  ad_testing_38: 'Rozpoznatelnost',
  ad_testing_39: 'Soulad',
  ad_testing_40: 'Kreativita',
  ad_testing_41: 'Jak vaše reklama vyniká a přitahuje pozornost lidí',
  ad_testing_42: 'Klíčové metriky',
  ad_testing_43: 'ROZPOZNATELNOST',
  ad_testing_44: 'OBLÍBENOST',
  ad_testing_45: 'MTO',
  ad_testing_46: 'MOTIVACE',
  ad_testing_47: 'Zákaznická zkušenost, emocionální zapojení',
  ad_testing_48:
    'Pomocí technologie umělé inteligence a odborných analytiků analyzujeme skutečné emoce lidí a získáváme poznatky o jejich vnímání reklamy',
  ad_testing_49: 'Hodnocení',
  ad_testing_50: 'Muži',
  ad_testing_51: 'Ženy',
  ad_testing_52: 'Vysoké zapojení',
  ad_testing_53: 'Pozornost',
  ad_testing_54: 'Co se publiku líbilo a co si zapamatovalo?',
  ad_testing_55: 'Herečka',
  ad_testing_56: 'Rovnost',
  ad_testing_57: 'Hudební doprovod',
  ad_testing_58: 'Pozitivní emoce',
  ad_testing_59: 'Lidé různých ras a vzhledu',
  ad_testing_60: 'Exteriérové záběry',
  ad_testing_61: 'Co se publiku NELÍBILO a co si nezapamatovalo?',
  ad_testing_62: 'Hlas mluvčího neodpovídal tomu, co se dělo na obrazovce',
  ad_testing_63: 'Nízká pozornost věnovaná produktu',
  ad_testing_64: 'Příliš dynamické',
  ad_testing_65: 'Obtížně pochopitelné',
  ad_testing_66: 'TRP',
  ad_testing_67: 'Zobrazení',
  ad_testing_68: 'Odvysílání',
  ad_testing_69: 'Konverze',
  ad_testing_70: 'Média',
  ad_testing_71:
    'Měříme efektivitu reklamní kampaně ve spojení s mediální aktivitou a vypočítáváme dopad investic do různých mediálních kanálů na sledované výsledky.',
  ad_testing_72:
    'Provádíme výzkum reklamy v jakémkoli formátu, na jakékoli platformě nebo kanálu',
  ad_testing_73: 'videoobsah',
  ad_testing_74: 'venkovní reklama',
  ad_testing_75: 'TV reklamy',
  ad_testing_76: 'tisk',
  ad_testing_77: 'digitální média',
  ad_testing_78: 'reklamní kampaně',
  ad_testing_79: 'POS materiály a reklama',
  ad_testing_80: 'animatiky',
  ad_testing_81: 'S naší pomocí můžete otestovat svou reklamu v jakékoli fázi',
  ad_testing_82: 'Koncept',
  ad_testing_83: 'které nápady mají největší potenciál?',
  ad_testing_84: 'Počáteční fáze produkce',
  ad_testing_85: 'které animatiky přejdou do produkce?',
  ad_testing_86: 'Produkce',
  ad_testing_87: 'jak upravit video, aby si udrželo pozornost?',
  ad_testing_88: 'Před mediálním nasazením',
  ad_testing_89:
    'které komunikační kanály budou fungovat a jaký výsledek lze očekávat?',
  ad_testing_90: 'Post-testování reklamy',
  ad_testing_91: 'Produkce',
  ad_testing_92:
    'je moje reklama poutavá? Snižuje se účinnost kreativy v průběhu času?',
  ad_testing_93: 'Před mediálním nasazením',
  ad_testing_94:
    'jak účinná je moje reklama v číslech? Jak si vede ve srovnání s konkurencí?',
  ad_testing_95: 'Pre-testování reklamy',
  ad_testing_96: 'Pro zajištění vysoce kvalitních dat používáme',
  ad_testing_97: 'Metodologii kvantitativního výzkumu',
  ad_testing_98: 'CAWI',
  ad_testing_99: 'Metodologii kvalitativního výzkumu',
  ad_testing_100: 'Fokusní skupiny',
  ad_testing_101: 'AI',
  ad_testing_102: 'Wantent',
  ad_testing_103: 'Analytické reporty, které obdržíte',
  ad_testing_104:
    'Náš tým analytiků, mediálních expertů a marketérů pro vás připraví a představí report na míru s podrobnými doporučeními',
  ad_testing_age: 'věk',
  ad_testing_ad: 'Reklama',
  automotive_industry_price_analysis_1: 'Analýza cen v automobilovém průmyslu',
  automotive_industry_price_analysis_2:
    'Analýza konkurenčních cen pomáhá předcházet ztrátám zisku, zvyšovat podíl na trhu a sledovat vaši tržní pozici. Pomůžeme vám vybrat úspěšnou konkurenční strategii!',
  automotive_industry_price_analysis_3: 'Vyžádat cenovou nabídku',
  automotive_industry_price_analysis_4: 'Naše metodologie',
  automotive_industry_price_analysis_5: 'Stylově elegantní lidé v autosalonu',
  automotive_industry_price_analysis_6:
    'Metoda Mystery Shopping je jediným přístupem, který přesně odráží skutečnou zkušenost zákazníka a poskytuje důvěryhodný přehled.',
  automotive_industry_price_analysis_7:
    'Nabízíme přesná čísla a spolehlivá vícestranná data',
  automotive_industry_price_analysis_8:
    'Máme globální pokrytí zahrnující všechny země světa',
  automotive_industry_price_analysis_9:
    'Naše interní zdroje zahrnují mystery shoppery a auditory',
  automotive_industry_price_analysis_10: 'Ověřujeme kvalitu našich dat',
  automotive_industry_price_analysis_11: 'Naše výhody:',
  automotive_industry_price_analysis_12:
    'Monitoring cen konkrétních konkurenčních modelů (B2B a B2C)',
  automotive_industry_price_analysis_13: 'Monitoring úrovně slev',
  automotive_industry_price_analysis_14:
    'Monitoring skladových zásob prodejců pro vaši značku i konkurenci',
  automotive_industry_price_analysis_15:
    'Monitoring cen automobilů v e-commerce',
  automotive_industry_price_analysis_16: 'Analýza cenové komunikace',
  automotive_industry_price_analysis_17:
    'Sledování nákladů na dopravu účtovaných prodejci',
  automotive_industry_price_analysis_18: 'Monitoring akcí a slev u prodejců',
  automotive_industry_price_analysis_19: 'Stanovení výše měsíčních splátek',
  automotive_industry_price_analysis_20: 'Výpočet leasingových splátek',
  automotive_industry_price_analysis_21:
    'Analýza specifických cenových aspektů elektromobilů (EV)',
  automotive_industry_price_analysis_22:
    'Porovnání cen přímého prodeje zákazníkům s cenami u prodejců',
  automotive_industry_price_analysis_23: 'Vývoj modelů předplatného',
  automotive_industry_price_analysis_24:
    '4Service je globální holding zaměřený na zákaznickou zkušenost (CX) s více než 20 lety zkušeností',
  automotive_industry_price_analysis_25:
    'Využijete data o ochotě zákazníků zaplatit za různé vlastnosti k optimalizaci své nabídky a identifikaci nejdůležitějších funkcí pro vaši cílovou skupinu.',
  automotive_industry_price_analysis_26:
    'Analýza cen v automobilovém průmyslu od společnosti 4Service zahrnuje:',
  automotive_industry_price_analysis_27:
    'Nejnižší ceny nejsou vždy klíčem ke konkurenceschopnosti automobilových značek. Pomůžeme vám vytvořit dlouhodobou cenovou strategii',
  automotive_industry_price_analysis_28:
    'zákazníků chápe, že ceny rostou u všech značek',
  automotive_industry_price_analysis_29: '29',
  automotive_industry_price_analysis_30:
    'zákazníků uvedlo, že by si stále koupili vůz, který se jim líbí, i kdyby je značka informovala o plánovaném zvýšení ceny,',
  automotive_industry_price_analysis_31: '31',
  automotive_industry_price_analysis_32:
    'lidí považuje leasing a měsíční splátky za nejpreferovanější způsob pořízení automobilu',
  automotive_industry_price_analysis_33: '48',
  automotive_industry_price_analysis_34:
    'prodejců zmínilo možnost zvýšení cen během komunikace/prodejního procesu',
  automotive_industry_price_analysis_35: '47.6',
  automotive_industry_price_analysis_36: 'Klíčové ukazatele',
  automotive_industry_price_analysis_37:
    'Zjistíte, jak nastavit cenu svého produktu ve srovnání s ostatními vozidly v nabídce.',
  automotive_industry_price_analysis_38:
    'Využijete data o ochotě zákazníků zaplatit za různé vlastnosti k optimalizaci své nabídky a identifikaci nejdůležitějších funkcí pro vaši cílovou skupinu.',
  automotive_industry_price_analysis_39:
    'zákazníků uvedlo, že by si stále koupili vůz, který se jim líbí, i kdyby je značka informovala o plánovaném zvýšení ceny',
  automotive_industry_price_analysis_40:
    'Budete schopni určit vhodnou výši měsíčních splátek a leasingových sazeb.',
  automotive_industry_price_analysis_41:
    'Jaké výhody získá vaše značka nebo prodejce:',
  automotive_industry_price_analysis_42: 'Odešlete žádost',
  automotive_industry_price_analysis_43:
    'Náš manažer vás kontaktuje a společně stanovíte hlavní cíle',
  automotive_industry_price_analysis_44: 'Provedeme marketingový výzkum',
  automotive_industry_price_analysis_45:
    'Pravidelně vám poskytujeme reporty a doporučení v online formátu',
  automotive_industry_price_analysis_46: 'Automobil se štítkem slevy',
  automotive_industry_price_analysis_47: 'Projekt spouštíme během 1 dne!',
  automotive_industry_price_analysis_48:
    'Nabízíme komplexní sadu reportů včetně fotoreportů, PPT prezentací a Excel reportů, rozdělených podle typu lokality',
  retail_audit_1: 'AUDIT TERÉNNÍHO MARKETINGU / retail audit',
  retail_audit_2:
    'Shromažďujte podrobná data o své prodejně nebo značce, analyzujte překážky růstu a vytvářejte efektivní strategie k jejich překonání',
  retail_audit_3: 'Vyžádat cenovou nabídku',
  retail_audit_4:
    '4Service provádí audity prodejen přímo na místě jménem značek za účelem posouzení efektivity jejich propagačních strategií, terénních týmů a marketingových aktivit při oslovování cílové skupiny.',
  retail_audit_5:
    'Pečlivě sledujeme realizaci propagačních kampaní a zajišťujeme dodržování propagačních pravidel.',
  retail_audit_6: 'Top 10',
  retail_audit_7: 'CX agentur v Evropě',
  retail_audit_8: 'let zkušeností',
  retail_audit_9: 'zemí pokrytí',
  retail_audit_10: '1,6 milionu',
  retail_audit_11: 'hodnocení ročně',
  retail_audit_12: 'Co sledujeme?',
  retail_audit_13: 'Přítomnost POS materiálů',
  retail_audit_14:
    'Přítomnost a aktivitu brand ambasadorů a dodržování plánovaného harmonogramu',
  retail_audit_15: 'Hodnocení zapojení brand ambasadorů do advokačních kampaní',
  retail_audit_16:
    'Hodnocení interakce se zákazníky a dodržování propagačních pravidel a komunikace značky',
  retail_audit_17: 'Opatření proti podvodům',
  retail_audit_18:
    'Vaše firma může výsledky auditu terénního marketingu využít k:',
  retail_audit_19: 'Posouzení souladu s rozpočtem a procesy',
  retail_audit_20: 'Porovnání skutečných výsledků s plánovanými cíli',
  retail_audit_21: 'Zvýšení efektivity marketingových kampaní',
  retail_audit_22: 'Strategickému plánování do budoucna',
  retail_audit_23: 'Identifikaci příležitostí ke snížení nákladů',
  retail_audit_24: 'Zlepšení prodejů a konverzních poměrů',
  retail_audit_25: 'Optimalizaci návratnosti investic (ROI)',
  retail_audit_26: 'VYBRALI SI 4SERVICE JAKO PARTNERA PRO TRADE INVESTICE',
  retail_audit_27:
    'Přední mezinárodní výrobce tabákových výrobků spolupracoval se společností 4Service za účelem posílení svých značek a zlepšení výkonnosti v prodejnách. Naše týmy zajišťovaly audity terénního marketingu a online reporting zákaznické zkušenosti.',
  retail_audit_28: 'zvýšení přesnosti plánování terénní marketingové agentury',
  retail_audit_29: 'zvýšení efektivity komunikace značky',
  retail_audit_30: 'zvýšení zapojení BA (aktivace zákazníků)',
  retail_audit_31: 'zvýšení přesnosti sběru dat a souladu s GDPR',
  retail_audit_32: 'Jaké cenné poznatky nejčastěji získáváme:',
  retail_audit_33:
    'Nedostatek konzistence nebo dokonce rozpor mezi podmínkami SLA vede k významným neschváleným nákladům účtovaným klientovi',
  retail_audit_34:
    'Nesprávné účtování poplatků kvůli záměně typů poskytovaných služeb',
  retail_audit_35:
    'Terénní služby nebyly provedeny, včetně nepřidělení personálu na plánované místo | POS',
  retail_audit_36:
    'Účtování na základě odhadu místo skutečných údajů bez následného vyrovnání',
  retail_audit_37:
    'Nesprávné uplatnění propagačních pravidel vedoucí k poskytování podvodných údajů',
  retail_audit_38: 'Jak pracujeme?',
  retail_audit_39:
    'Náš auditor navštěvuje určená prodejní místa (POS) podle aktivačního plánu agentury.',
  retail_audit_40:
    'Hodnotí klíčové ukazatele výkonnosti (KPI) definované v zadání, jako je přítomnost POS materiálů, zapojení brand ambasadorů, dodržování propagačních pravidel a opatření proti podvodům.',
  retail_audit_41: 'Validace:',
  retail_audit_42: 'Shromažďujeme a konsolidujeme získaná data.',
  retail_audit_43: 'Připravujeme komplexní zprávu.',
  retail_audit_44:
    'Náš validační tým důkladně kontroluje všechny dotazníky z hlediska správnosti, souladu se zadáním projektu i případných doplňujících komentářů.',
  retail_audit_45: 'Online systém reportingu:',
  retail_audit_46:
    'Vyplněné a ověřené dotazníky jsou nahrány do našeho online portálu do 36 hodin.',
  retail_audit_47:
    'Klienti mají přístup do osobního portálu, kde mohou kdykoli sledovat průběh projektu.',
  retail_audit_48:
    'Je poskytnuta závěrečná zpráva obsahující výsledky a doporučení.',
  retail_audit_49: 'Promluvte si s odborníkem',
  retail_audit_50: 'Naše silné stránky:',
  facility_check_audit_1: 'Facility',
  facility_check_audit_2: 'Check Audit',
  facility_check_audit_3: 'Pozvedněte zážitek ze značky v každém detailu',
  facility_check_audit_4: 'Prozkoumejte náš přístup',
  facility_check_audit_5: 'O nás',
  facility_check_audit_6: 'Kdo jsme',
  facility_check_audit_7:
    'Jako globální holding zaměřený na zákaznickou zkušenost poskytuje 4Service komplexní portfolio služeb, které pomáhá značkám vytvářet a poskytovat výjimečné zážitky jejich zákazníkům.',
  facility_check_audit_8: 'Naše služba Facility Check Audit',
  facility_check_audit_9:
    'je navržena tak, aby vám pomohla zajistit, že vaše provozovny a prezentace značky v maloobchodních prodejnách odpovídají standardům vaší značky a vytvářejí pozitivní dojem na zákazníky.',
  facility_check_audit_10: 'Řešení 1',
  facility_check_audit_11: 'Facility Check Audit',
  facility_check_audit_12:
    'je důkladné hodnocení, které ověřuje, zda vaše maloobchodní prodejny nebo prodejní místa odpovídají standardům vaší značky. Neověřujeme pouze fyzické atributy, ale také hodnotíme, jak tyto prvky ovlivňují vnímání vaší značky vašimi zákazníky.',
  facility_check_audit_13: 'Dvě řešení',
  facility_check_audit_14: 'Dva způsoby realizace',
  facility_check_audit_15: 'Metoda',
  facility_check_audit_16: 'Facility Check Audit prováděný odbornými auditory',
  facility_check_audit_17: 'Validace Facility Check',
  facility_check_audit_18: 'Reporty',
  facility_check_audit_19:
    'Obdržíte reporty včetně vizuálních důkazů a statistik, dostupné do 48 hodin',
  facility_check_audit_20:
    'Kvalitně provedený Facility Check Audit může vaší značce přinést řadu výhod, včetně:',
  facility_check_audit_21: 'Vyšší konverze zákazníků:',
  facility_check_audit_22:
    'Pozitivní zákaznická zkušenost může vést k vyšším prodejům a opakovaným nákupům. Naše audity vám pomohou odhalit a odstranit oblasti, které mohou negativně ovlivňovat spokojenost zákazníků.',
  facility_check_audit_23: 'Posílení image značky:',
  facility_check_audit_24:
    'Vaše fyzické provozovny představují klíčový kontaktní bod se zákazníky a významně ovlivňují vnímání vaší značky. Naše audity vám pomohou zajistit, aby byly v souladu s hodnotami vaší značky a vytvářely pozitivní dojem.',
  facility_check_audit_25: 'Proč právě my?',
  facility_check_audit_26: 'Proč je Facility Check Audit důležitý?',
  facility_check_audit_27:
    'Kvalitně provedený Facility Check Audit může vaší značce přinést řadu výhod, včetně:',
  facility_check_audit_28: 'Posílení image značky:',
  facility_check_audit_29:
    'Vaše fyzické provozovny představují klíčový kontaktní bod se zákazníky a významně ovlivňují vnímání vaší značky. Naše audity vám pomohou zajistit, aby byly v souladu s hodnotami vaší značky a vytvářely pozitivní dojem.',
  facility_check_audit_30: 'Vyšší konverze zákazníků:',
  facility_check_audit_31:
    'Pozitivní zákaznická zkušenost může vést k vyšším prodejům a opakovaným nákupům. Naše audity vám pomohou odhalit a odstranit oblasti, které mohou negativně ovlivňovat spokojenost zákazníků.',
  facility_check_audit_32: 'Kdo potřebuje',
  facility_check_audit_33: 'Kdo potřebuje Facility Check Audit?',
  facility_check_audit_34:
    'Facility Check Audit je cennou službou pro každou značku s fyzickými provozovnami a fyzickou přítomností. Je obzvláště důležitý pro značky, které chtějí:',
  facility_check_audit_35: 'Zajistit dodržování standardů značky:',
  facility_check_audit_36:
    'Naše audity vám pomohou odhalit oblasti, kde se vaše provozovny mohou odchylovat od standardů vaší značky.',
  facility_check_audit_37: 'Zlepšit zákaznickou zkušenost:',
  facility_check_audit_38:
    'Naše audity vám pomohou identifikovat příležitosti ke zlepšení zákaznické zkušenosti ve vašich provozovnách.',
  facility_check_audit_39: 'Vybudovat silnější značku:',
  facility_check_audit_40:
    'Naše audity vám pomohou zajistit, aby vaše fyzické provozovny vytvářely na zákazníky pozitivní dojem.',
  facility_check_audit_41:
    'Váš zaměstnanec nebo mystery shopper pořídí fotografii provozovny.',
  facility_check_audit_42: 'Poté vyplní dotazník a přiloží fotografii.',
  facility_check_audit_43:
    'Validátor obdrží fotografii a zkontroluje její soulad se standardy.',
  facility_check_audit_44: 'Facility Check Audit prováděný odbornými auditory',
  facility_check_audit_45: 'Přípravná fáze:',
  facility_check_audit_46: 'Společné schválení harmonogramu auditu',
  facility_check_audit_47:
    'Prodejci jsou předem připraveni a informováni o nadcházejícím auditu',
  facility_check_audit_48: 'Školení auditorů:',
  facility_check_audit_49:
    'Naši zkušení školitelé 4Service seznamují auditory se standardy značky',
  facility_check_audit_50: 'Fáze Facility Auditu:',
  facility_check_audit_51:
    'Auditoři vybavení zvláštními pověřovacími dopisy navštěvují jednotlivé provozovny',
  facility_check_audit_52:
    'Důkladná kontrola každého bodu v souladu se stanovenými pravidly',
  facility_check_audit_53:
    'Fotodokumentace spolu s hodnocením podle požadavků centrály',
  facility_check_audit_54: 'Závěrečná PPT zpráva',
  facility_check_audit_55:
    'Komplexní prezentace v PowerPointu s podrobným přehledem výsledků',
  facility_check_audit_56:
    'Interaktivní online/offline prezentace výsledků auditu',
  facility_check_audit_57: 'Validace Facility Check',
  facility_check_audit_58: 'Kroky:',
  facility_check_audit_59: 'Fáze Facility Auditu:',
  facility_check_audit_60:
    'Zástupci značky využívají aplikaci 4Service k pořizování fotografií přímo na místě',
  facility_check_audit_61:
    'Dodržování přísných vizuálních a popisných kritérií',
  facility_check_audit_62: 'Fáze validace:',
  facility_check_audit_63:
    'Pečliví validátoři důkladně kontrolují každý report',
  facility_check_audit_64: 'Komplexní porovnání fotografií se standardy značky',
  facility_check_audit_65:
    'Poznámky a doporučení jsou pro větší přehlednost zahrnuty do reportu',
  facility_check_audit_66:
    'V případě potřeby přímá komunikace s prodejci za účelem upřesnění',
  facility_check_audit_67: 'Fáze reportingu:',
  facility_check_audit_68:
    'Reporty včetně vizuálních důkazů a statistik jsou dostupné do dvou dnů',
  facility_check_audit_69: 'Kontaktujte nás ještě dnes',
  cx_solution_1: 'Nenacházíme jen cenné poznatky,',
  cx_solution_2: 'Posouváme vaše podnikání na novou úroveň',
  cx_solution_3:
    'Naši odborníci s více než 20 lety zkušeností v oblasti zákaznické zkušenosti nacházejí komplexní řešení a poskytují vám konkrétní akční plán podporující váš růst',
  cx_solution_4:
    'Objevte jedinečný soubor služeb v jednom řešení připraveném na budoucnost',
  cx_solution_5: 'Komplexní CX řešení',
  cx_solution_6: 'Testování reklamy',
  cx_solution_7: 'AI a neuromarketing',
  cx_solution_8: 'Hlas zákazníka',
  cx_solution_9: 'Desk research',
  cx_solution_10: 'CJM',
  cx_solution_11: 'Mystery shopping',
  cx_solution_12: 'CX poradenství',
  cx_solution_13: 'Monitoring sociálních sítí',
  cx_solution_14: 'Kvantitativní a kvalitativní výzkum',
  cx_solution_15: 'Service Design',
  cx_solution_16: 'Marketingová strategie',
  cx_solution_17: 'UX/UI testování',
  cx_solution_18: 'Poznatky o cílové skupině',
  cx_solution_19: 'Je nám ctí přispívat k vašemu úspěchu',
  cx_solution_20:
    'Přizpůsobujeme a kombinujeme nástroje a služby podle cílů a potřeb vašeho podnikání, abychom vám poskytli řešení na míru',
  cx_solution_21: 'Komplexní výzkum',
  cx_solution_22:
    'Podpořte své rozhodování a získejte konkurenční výhodu na trhu založeném na datech.',
  cx_solution_23:
    'Kvalitativní výzkum spočívá ve sběru a analýze nečíselných dat za účelem porozumění konceptům, názorům a zkušenostem',
  cx_solution_24:
    'Kvantitativní výzkum představuje objektivní měření a numerickou analýzu dat získaných prostřednictvím anket, dotazníků a průzkumů',
  cx_solution_25:
    'Používáme jedinečnou sadu nástrojů podle vašich konkrétních požadavků',
  cx_solution_26: 'Nástroje',
  cx_solution_27: 'CAWI',
  cx_solution_28:
    'Computer-Assisted Web Interviewing je klíčovým nástrojem našeho portfolia, který nám umožňuje provádět průzkumy a sbírat data prostřednictvím online platforem za pomoci specializovaného softwaru, což zajišťuje efektivní a přesný sběr dat pro potřeby marketingového výzkumu našich klientů',
  cx_solution_29: 'CATI',
  cx_solution_30:
    'Computer-Assisted Telephone Interviewing je metoda, kterou využíváme k provádění telefonických průzkumů a získávání cenných dat s využitím specializovaného softwaru, který zefektivňuje celý proces a zajišťuje přesnost marketingového výzkumu',
  cx_solution_31: 'F2F',
  cx_solution_32:
    'Face-to-Face je nedílnou součástí našeho přístupu, protože umožňuje přímou interakci a osobní kontakt s klienty a zákazníky, čímž podporuje důvěru, porozumění a efektivní komunikaci, které jsou nezbytné pro budování dlouhodobých vztahů a obchodního úspěchu.',
  cx_solution_33: 'Desk research',
  cx_solution_34:
    'Desk research zahrnuje komplexní sběr a analýzu dat a slouží jako základní krok našeho výzkumného procesu pro získávání poznatků a podporu strategického rozhodování našich klientů.',
  cx_solution_35: 'SWOT analýza',
  cx_solution_36:
    'SWOT analýza je strategický nástroj hodnocení, který pomáhá našim klientům identifikovat interní silné a slabé stránky i externí příležitosti a hrozby a poskytuje cenné poznatky pro rozhodování a tvorbu efektivních obchodních strategií.',
  cx_solution_37: 'Etnografický výzkum',
  cx_solution_38:
    'Studium lidí a kultur prostřednictvím ponoření se do jejich přirozeného prostředí a pozorování, které často přináší hluboké poznatky o chování, přesvědčeních a sociálních vztazích.',
  cx_solution_39: 'Hloubkové rozhovory',
  cx_solution_40:
    'Hloubkové rozhovory jsou kvalitativní výzkumnou metodou, kterou používáme. Zahrnují podrobné individuální rozhovory s účastníky za účelem hlubšího pochopení jejich názorů, zkušeností a postojů a poskytují cenné poznatky pro výzkumné cíle a rozhodovací procesy našich klientů.',
  cx_solution_41: 'Ideační workshopy',
  cx_solution_42:
    'Ideační workshopy jsou společná brainstormingová setkání, která organizujeme za účelem propojení různých pohledů a odborností pro vytváření kreativních nápadů a řešení výzev či příležitostí našich klientů. Podporují inovace a posouvají strategické iniciativy vpřed.',
  cx_solution_43: 'Persony zákazníků',
  cx_solution_44:
    'Persony zákazníků jsou podrobné profily, které vytváříme na základě výzkumu a analýzy dat. Pomáhají lépe porozumět potřebám, preferencím a chování cílových zákazníků našich klientů a přizpůsobit strategie i komunikaci tak, aby s nimi efektivně rezonovaly a podporovaly obchodní úspěch.',
  cx_solution_45: 'Mystery Shopping',
  cx_solution_46:
    'Mystery Shopping je strategická služba, kterou nabízíme pro měření a monitorování interakcí mezi zákazníkem a společností během předem definovaného scénáře.',
  cx_solution_47: 'Accompany checking',
  cx_solution_48:
    'Accompany checking je specializovaná forma mystery shoppingu, při níž naši hodnotitelé doprovázejí zákazníky během celé jejich zkušenosti se službou. Poskytuje komplexní pohled na všechny fáze zákaznické cesty a umožňuje klientům lépe porozumět kvalitě poskytovaných služeb a provádět účinná zlepšení vedoucí k vyšší spokojenosti a loajalitě zákazníků.',
  cx_solution_49: 'Analýza zpětné vazby',
  cx_solution_50:
    'Analýza zpětné vazby je klíčový proces, při kterém systematicky shromažďujeme a analyzujeme zpětnou vazbu zákazníků z různých kanálů, jako jsou průzkumy, recenze a sociální sítě. Díky tomu získáváme cenné poznatky, identifikujeme trendy a poskytujeme klientům doporučení založená na datech pro zlepšení jejich produktů, služeb a celkové zákaznické zkušenosti.',
  cx_solution_51: 'Fokusní skupiny',
  cx_solution_52:
    'Fokusní skupiny jsou dynamická výzkumná setkání, která organizujeme. Sdružují různorodé účastníky k podrobné diskusi o konkrétních tématech nebo produktech, což nám umožňuje získat kvalitativní poznatky, odhalit postoje, preference a vnímání a podpořit rozhodovací procesy a tvorbu strategií našich klientů.',
  cx_solution_53: '20 let vytváření výjimečných zákaznických zkušeností',
  cx_solution_54:
    'Zajistěte, aby vaše sdělení zaujalo a oslovilo vaše publikum.',
  cx_solution_55:
    'Jsme odhodláni poskytovat výsledky, které předčí vaše očekávání.',
  cx_solution_56:
    'Objevujeme komplexní řešení, která přispívají k vašemu růstu.',
  cx_solution_57:
    'Posuňte zákaznickou zkušenost na vyšší úroveň s naší metodikou',
  cx_solution_58:
    'Customer Journey Mapping spočívá v definování cílové skupiny, pochopení jejích potřeb a prostředí a následném vytvoření plánu pro poskytování poutavé zákaznické zkušenosti.',
  cx_solution_59: 'BHT',
  cx_solution_60:
    'Výzkum Brand Health Tracking měří výkonnost vaší značky z hlediska povědomí, používání, pozice značky a jejího výkonu.',
  cx_solution_61: 'CSI',
  cx_solution_62:
    'Customer Satisfaction Index je ukazatel, který vyjadřuje míru spokojenosti vašich zákazníků s produkty nebo službami společnosti.',
  cx_solution_63:
    'Monitoring cen je proces sběru, zpracování a analýzy cen konkurence.',
  cx_solution_64: 'NPS',
  cx_solution_65:
    'Net Promoter Score je zlatým standardem metrik zákaznické zkušenosti a je založen na jediné otázce: Jak pravděpodobné je, že byste doporučili organizaci/produkt/službu?',
  cx_solution_66: 'HR výzkum',
  cx_solution_67:
    'Výzkum lidských zdrojů se používá k hodnocení HR postupů a výkonnosti a poskytuje podrobnou analýzu současného rozvoje a řízení.',
  cx_solution_68:
    'Testování použitelnosti sleduje, jak skuteční lidé pracují s webovou stránkou, aplikací nebo jiným produktem, a pozoruje jejich chování a reakce.',
  cx_solution_69: 'Ostatní',
  cx_solution_70:
    'Naši odborníci vyberou nejvhodnější metodiku pro vaše podnikání.',
  cx_solution_71: 'Začněme',
  cx_solution_72: '1 - ÚVODNÍ SCHŮZKA',
  cx_solution_73:
    'Během úvodní schůzky identifikujeme a stanovíme hlavní úkoly. Výsledek: jasné pochopení cíle, výzkumných úkolů, termínů, metod a oblastí odpovědnosti.',
  cx_solution_74: '2 - TVORBA KONCEPTU',
  cx_solution_75:
    'Analytické oddělení společnosti 4Service agreguje data a koordinuje strukturu reportu. Poté klientovi představíme výsledky doplněné o poznatky a doporučení pro implementaci.',
  cx_solution_76: '3 - TERÉNNÍ SBĚR DAT',
  cx_solution_77:
    'Pro realizaci výzkumu zajišťujeme nábor respondentů, provádíme rozhovory a další základní fáze výzkumu. Klient obdrží přepisy audio-video rozhovorů i stručná shrnutí.',
  cx_solution_78: '4 - ANALYTIKA',
  cx_solution_79:
    'Analytické oddělení společnosti 4Service agreguje data a koordinuje strukturu reportu. Poté klientovi představíme výsledky doplněné o poznatky a doporučení pro implementaci.',
  cx_solution_80: '5 - WORKSHOP',
  cx_solution_81: 'Diskuse se zákazníkem o plánu implementace.',
  cx_solution_82: 'Zjistěte více o našich osvědčených postupech.',
  cx_solution_83:
    'Customer Journey Map umožňuje rychle analyzovat všechny komunikační kanály, identifikovat možné nedostatky v klíčových kontaktních bodech a komplexně porozumět oblastem, které se mohou odchylovat od plánovaného průběhu.',
  cx_solution_84: 'Kdy ji použít?',
  cx_solution_85:
    'Vytvořte personalizovanou reklamní kampaň založenou na reálných datech o cílových skupinách.',
  cx_solution_86:
    'Zjistěte, jaké podněty ovlivňují různé segmenty cílového publika, a naplňte jejich potřeby.',
  cx_solution_87:
    'Přesně zacilte na každou skupinu a dosáhněte maximální konverze.',
  cx_solution_88:
    'Technika Accompany Checking umožňuje vyhodnotit nejlepší možnosti pro dosažení vašich cílů.',
  cx_solution_89: 'Testování nové webové stránky nebo produktu před spuštěním.',
  cx_solution_90: 'Kontrola vytvořených procesů před zavedením změn.',
  cx_solution_91: 'Hodnocení webu nebo produktu při poklesu prodejů.',
  cx_solution_92:
    'Uvedení nového produktu přizpůsobeného preferencím zákazníků.',
  cx_solution_93:
    'Studium konkurenčních společností pro získání vedoucí pozice na trhu.',
  cx_solution_94:
    'Nabízíme komplexní přístup 360° k vytváření zákaznicky orientovaného modelu služeb.',
  cx_solution_95: 'Školení a rozvoj zaměstnanců',
  cx_solution_96: 'Zlepšování standardů služeb',
  cx_solution_97: 'Zvyšování návštěvnosti zákazníků a prodeje',
  cx_solution_98: 'Nastavení KPI a motivačního systému pro zaměstnance',
  cx_solution_99: 'Objevte naše úspěšné příběhy',
  cx_solution_100: 'Automobilový průmysl',
  cx_solution_101: 'Tabákový průmysl',
  cx_solution_102: 'Maloobchod',
  cx_solution_103: 'Kvalitativní fáze',
  cx_solution_104: 'Kvantitativní fáze (segmentace)',
  cx_solution_105: 'Fokusní skupiny',
  cx_solution_106: 'Online pokrytí respondentů po celém světě',
  cx_solution_107: 'Kombinace technik během rozhovorů',
  cx_solution_108: 'Pouze otevřené otázky',
  cx_solution_109: 'Podpora respondentů 24/7',
  cx_solution_110:
    'Zachování důležitých detailů a skutečného obrazu celé cesty',
  cx_solution_111: 'Průzkum trhu',
  cx_solution_112: 'Diagnostika společnosti a konkurence',
  cx_solution_113: 'Aktualizované servisní modely a nové obchodní procesy',
  cx_solution_114: 'Podpora zákaznicky orientovaných služeb',
  cx_solution_115: 'Implementace změn a kontrola rozvoje servisních strategií',
  usage_attitude_1: 'Usage and \n Attitude (U&A)',
  usage_attitude_2:
    'Získejte komplexní přehled o tom, jak cílová skupina \n vnímá, využívá a pracuje s vaší značkou.',
  usage_attitude_3: 'Promluvte si s odborníkem',
  usage_attitude_4: 'O službě',
  usage_attitude_5:
    '<b>Prozkoumejte spotřebitelské</b> návyky a odhalte preference i jejich příčiny do hloubky',
  usage_attitude_6:
    "<b>Objevte 'proč'</b> spotřebitelských rozhodnutí díky naší podrobné analýze",
  usage_attitude_7:
    '<b>Pochopte, jak</b> zákazníci pracují s vašimi produkty, a získejte strategické poznatky',
  usage_attitude_8:
    '<b>Získejte přehled o</b> chování, návycích a preferencích spotřebitelů pro informovaná rozhodnutí',
  usage_attitude_9: 'Zkušenosti',
  usage_attitude_10:
    'Odborníci společnosti 4Service s více než 20 lety zkušeností v oblasti zákaznické zkušenosti vytvářejí jedinečná řešení, která pomáhají růstu vašeho podnikání',
  usage_attitude_11: 'Kontaktujte nás',
  usage_attitude_12: 'Pro koho',
  usage_attitude_13: 'Komu přináší výzkum Brand Usage and Attitude užitek?',
  usage_attitude_14: 'Mají o něj zájem různá odvětví a sektory služeb:',
  usage_attitude_15:
    '<b>Rozpoznání</b> požadavků zákazníků a jejich problémových míst',
  usage_attitude_16:
    '<b>Identifikace</b> příležitostí ke zvýšení spotřeby zákazníků',
  usage_attitude_17:
    '<b>Vývoj</b> nových produktových kategorií nebo marketingových strategií',
  usage_attitude_18:
    '<b>Získání</b> hlubokého porozumění konkurenčnímu prostředí',
  usage_attitude_19:
    'Metodika je vybírána individuálně podle požadavků klienta',
  usage_attitude_20:
    '<b>Kvalitativní výzkum</b> zahrnuje sběr a analýzu nečíselných dat za účelem pochopení konceptů, názorů nebo zkušeností.',
  usage_attitude_21:
    '<b>Kvantitativní výzkum</b> spočívá v objektivním měření a číselné analýze dat získaných prostřednictvím anket, dotazníků a průzkumů.',
  usage_attitude_22:
    '<b>Po shromáždění dat</b> odborníci analyzují informace a vyvozují závěry, aby vám poskytli nejlepší doporučení.',
  usage_attitude_23: 'Kdo potřebuje',
  usage_attitude_24: 'Váš příběh úspěchu začíná zde',
  usage_attitude_25:
    '<b>Získáte výzkum</b> s cennými poznatky, které podpoří strategické rozhodování založené na hlubokém porozumění chování spotřebitelů.',
  usage_attitude_26:
    '<b>Výzkum poskytuje pevný základ pro zdokonalení</b> a optimalizaci strategií značky tak, aby lépe odpovídaly preferencím a postojům spotřebitelů.',
  usage_attitude_27: 'Řešení',
  usage_attitude_28: 'Objevte široké možnosti našich řešení',
  usage_attitude_29: 'Preference produktů v rámci kategorie',
  usage_attitude_30:
    'Zjistěte hlavní preference spotřebitelů napříč různými kategoriemi, včetně potravin, nápojů, oblečení, elektroniky a dalších.',
  usage_attitude_31: 'Spotřební / uživatelské chování',
  usage_attitude_32:
    'Analyzujte četnost spotřeby nebo používání konkrétních produktů/služeb a určete situace a okamžiky spojené s jejich využíváním.',
  usage_attitude_33: 'Nákupní chování',
  usage_attitude_34:
    'Zjistěte, jaké nákupní kanály zákazníci využívají a z jakých zdrojů čerpají informace.',
  usage_attitude_35: 'Motivace a potřeby spotřebitelů',
  usage_attitude_36:
    'Analyzujte motivace a překážky ovlivňující spotřebu. Posuďte faktory, které mají vliv na nákupní rozhodování spotřebitelů. Prozkoumejte vnímání produktové kategorie a analyzujte, jak je vnímána cena.',
  usage_attitude_37: 'Náš přístup',
  usage_attitude_38: 'Studie Brand Usage and Attitude',
  usage_attitude_39: 'Informace',
  usage_attitude_40:
    'Provádění průzkumů pomocí kvantitativních i kvalitativních metod',
  usage_attitude_41: 'Zahájení',
  usage_attitude_42:
    'Stanovení cílů a určení metod na základě individuálních požadavků',
  usage_attitude_43: 'Analýza',
  usage_attitude_44: 'Pokročilé techniky využívané našimi odborníky',
  usage_attitude_45:
    'Využíváme specifickou sadu nástrojů podle vašich konkrétních požadavků',
  usage_attitude_46: 'СATI',
  usage_attitude_47:
    'Computer-Assisted Telephone Interviewing je metoda, kterou používáme k provádění telefonických průzkumů a sběru cenných dat s využitím specializovaného softwaru, jenž zefektivňuje proces a zajišťuje přesnost našeho marketingového výzkumu.',
  usage_attitude_48: 'CAWI',
  usage_attitude_49:
    'Computer-Assisted Web Interviewing je klíčovým nástrojem našeho portfolia, který nám umožňuje provádět průzkumy a sbírat data prostřednictvím online platforem s využitím specializovaného softwaru, čímž zajišťujeme efektivní a přesný sběr dat pro potřeby marketingového výzkumu našich klientů.',
  usage_attitude_50: 'CAPI',
  usage_attitude_51:
    'Computer-Assisted Personal Interviewing je metoda, kterou používáme k optimalizaci procesů sběru dat, zefektivnění osobních rozhovorů a zajištění přesných a přínosných výsledků pro potřeby vašeho podnikání.',
  usage_attitude_52: 'Fokusní skupiny',
  usage_attitude_53:
    'Fokusní skupiny jsou dynamická výzkumná setkání, která organizujeme. Spojují různorodé účastníky k podrobné diskusi o konkrétních tématech nebo produktech, což nám umožňuje získávat kvalitativní poznatky, odhalovat postoje, preference a vnímání, zkoumat nápady a koncepty a podporovat rozhodování i tvorbu strategií našich klientů.',
  usage_attitude_54: 'F2F',
  usage_attitude_55:
    'Face-to-Face je nedílnou součástí našeho přístupu. Umožňuje přímou interakci a osobní kontakt s klienty i zákazníky, podporuje důvěru, porozumění a efektivní komunikaci, které jsou klíčové pro budování dlouhodobých vztahů a obchodního úspěchu, včetně fokusních skupin.',
  usage_attitude_56: 'Etnografický výzkum',
  usage_attitude_57:
    'Studium lidí a kultur prostřednictvím ponoření se do jejich přirozeného prostředí a pozorování, které často vede k hlubokým poznatkům o chování, přesvědčeních a sociálních vztazích.',
  thank_you_page: 'Děkujeme za váš čas! Náš manažer vás bude brzy kontaktovat.',
  back_main: 'Zpět na hlavní stránku',
  opportunities_1: 'Zjistěte více o našich případových studiích',
  opportunities_2: 'Objevte',
  opportunities_3: 'pro sebe',
  opportunities_4: 'příležitosti',
  opportunities_5:
    'mezinárodního podnikání společně s výzkumným holdingem 4Service',
  opportunities_6:
    'Jakými <span>produkty</span> můžeme posílit vaše podnikání?',
  opportunities_7: 'CX',
  opportunities_8: 'Komplexní řešení na míru pro podnikání',
  opportunities_9: 'Všechny typy Mystery Shoppingu',
  opportunities_10:
    'Realizujeme mystery employee, mystery caller, luxury mystery shopper, automotive mystery shopper a další typy.',
  opportunities_11: 'IT řešení na míru pro podnikání',
  opportunities_12:
    'Vlastní IT řešení s AI, platformy pro analýzu zpětné vazby a přepis hovorů',
  opportunities_13: 'Marketingový výzkum',
  opportunities_14:
    'Pro jakékoli obchodní požadavky (Brand Health Tracking, segmentace, NPS, eNPS, CJM, testování produktů a reklamy atd.)',
  opportunities_15: 'Audity',
  opportunities_16:
    'Provádíme různé servisní audity i monitoring cen (offline, pro specifické segmenty apod.)',
  opportunities_17: 'Service Design',
  opportunities_18:
    '4Service je certifikovaným partnerem DesignThinkers Academy, poskytuje firemní školení týmům a pravidelně pořádá workshopy pro firmy',
  opportunities_19:
    'Sdílíme své zkušenosti, ale <span>respektujeme a nenarušujeme</span> vaše obchodní procesy.',
  opportunities_20:
    'Známe obtíže, se kterými se firmy během svého rozvoje setkávají, a díky mezinárodním zkušenostem víme, jak tyto překážky překonat. Získáte nejen zkušenosti, ale také zdroje.',
  opportunities_21: 'Zveme vás ke spolupráci!',
  opportunities_22:
    'Nabízíme <span>partnerský program</span> pro vaše podnikání',
  opportunities_23:
    'Pod mezinárodně uznávanou značkou 4Service můžete pozitivně ovlivnit získávání nových zákazníků.',
  opportunities_24:
    'Naši partneři získávají komplexní podporu včetně školení, marketingových materiálů a provozní pomoci.',
  opportunities_25:
    'Partnerství s námi vám umožní realizovat vaše plány bez narušení vašich současných obchodních procesů.',
  opportunities_26: 'Naše <span>kanceláře</span>',
  opportunities_27: 'Naši klienti',
  opportunities_28: 'Máme více než 20 let zkušeností v oblasti CX',
  opportunities_29: 'Pokrytých zemí',
  opportunities_30: 'tisíc',
  opportunities_31: 'Jedinečných projektů',
  opportunities_32: 'milionů',
  opportunities_33: 'Návštěvy mystery shopperů',
  opportunities_34: 'patří mezi TOP 10 evropských CX agentur',
  opportunities_35: 'Vaše příležitosti s 4Service',
  opportunities_36: 'Zvýšení zisku',
  opportunities_37: 'Získáte přístup k mezinárodním zakázkám',
  opportunities_38: 'Jedinečný přístup k CX',
  opportunities_39: 'Podpora odborníků s více než 20 lety zkušeností',
  opportunities_40: 'Podpora',
  opportunities_41: 'Náš tým vás podpoří při dosahování výsledků',
  opportunities_42: 'Prodej',
  opportunities_43: 'Pomůžeme vám nastavit efektivní prodejní systém',
  opportunities_44: 'Přístup k softwaru',
  opportunities_45: 'Získáte přístup ke všem certifikovaným IT nástrojům',
  opportunities_46: 'Školení',
  opportunities_47:
    'Nejenže vyškolíme vaše zaměstnance, ale budeme vám i nadále poskytovat konzultační služby',
  opportunities_48: 'Pro koho je partnerství vhodné?',
  opportunities_49: 'Souvisí vaše podnikání s marketingovým výzkumem?',
  opportunities_50: 'Nebo se chcete vyzkoušet v novém oboru',
  opportunities_51: 'Plánujete:',
  opportunities_52: 'Zavádět inovace',
  opportunities_53: 'Spolupracovat s mezinárodními značkami',
  opportunities_54: 'Rozšířit své produktové portfolio',
  opportunities_55: 'Posílit svou pozici na trhu?',
  opportunities_56: 'Školit své zaměstnance',
  opportunities_57: 'Rozšířit své podnikání',
  opportunities_58: 'Naše zdroje = Vaše zdroje',
  opportunities_59:
    'Díky našim rozsáhlým zkušenostem jsme připraveni se o ně s vámi podělit již v první fázi spolupráce',
  opportunities_60: 'Analýza dat:',
  opportunities_61: 'Mezinárodní analytický tým',
  opportunities_62: 'Metody zpracování dat – SPSS, Power BI',
  opportunities_63: 'Inovativní přístupy a široká škála metodologií',
  opportunities_64: 'Reporty v libovolném formátu',
  opportunities_65: 'Software:',
  opportunities_66: 'Vlastní IT řešení na míru',
  opportunities_67: 'DigSee Sure pro CAPI',
  opportunities_68: 'SurveyMonkey pro CAWI',
  opportunities_69: 'Shopmetrics',
  opportunities_70: 'VoIPTime (call centrum)',
  opportunities_71: 'Marketingová podpora:',
  opportunities_72: 'PR podpora',
  opportunities_73: 'Podpora při propagaci a tvorbě obsahu',
  opportunities_74: 'Nastavení procesů generování leadů',
  opportunities_75: 'IT podpora:',
  opportunities_76:
    'Technická podpora při instalaci, konfiguraci a používání našeho softwaru.',
  opportunities_77: 'Vzdálená podpora',
  opportunities_78: 'Kontrola zabezpečení',
  opportunities_79: 'Provozní podpora:',
  opportunities_80: 'Podpora při nastavování terénních procesů',
  opportunities_81: 'Systém proti podvodům',
  opportunities_82: 'Nábor jakékoli složitosti',
  opportunities_83: 'Operativní řízení projektového a terénního týmu',
  opportunities_84: 'Kontrola kvality náboru',
  opportunities_85: 'UpWork',
  opportunities_86: 'Jaké bonusy získáte?',
  opportunities_87: 'Rozšíření zákaznické základny',
  opportunities_88: 'Posílení image na trhu',
  opportunities_89: 'Diverzifikace rizik ztráty zákazníků',
  opportunities_90: 'Optimalizace technologických procesů',
  opportunities_91: 'Mezinárodní zkušenosti',
  opportunities_92: 'Více prodejů stávajícím zákazníkům',
  main_67:
    'Konkurenční analýza cen optimalizuje nabídku, zvyšuje zisk a posiluje podíl na trhu díky využití údajů o ochotě zákazníků zaplatit a identifikaci klíčových vlastností',
  main_68:
    'Zajišťuje, že vaše prodejní místa odpovídají standardům značky, hodnotí jejich fyzické vlastnosti i vliv na vnímání zákazníky',
  main_69: 'CX řešení',
  main_70:
    'Objevte naše jedinečné 360° CX řešení: přizpůsobujeme nástroje a služby vašim cílům, abychom podpořili rozvoj vašeho podnikání',
  main_71: 'Analýza řeči',
  main_72:
    'Náš pokročilý nástroj pro analýzu řeči převádí mluvené slovo do textu a poskytuje firmám cenné poznatky pro zlepšení zákaznické zkušenosti, sledování výkonu, zajištění souladu s předpisy a podporu růstu',
  parthership: 'Partnerství',
  banner_1: 'CX poradenství a služby – 360° pohled na vaše podnikání',
  banner_2: 'Buďte v obraze s nejnovějšími výzkumy!',
  banner_3:
    'Souhlasím se zpracováním osobních údajů podle Zásad ochrany osobních údajů',
  banner_4: '*Vyberte trh',
  banner_5: 'Děkujeme za odběr!',
  banner_6: 'Budeme vám posílat pouze ten nejzajímavější obsah!',
  banner_7: 'Odeslat',
  banner_8: 'Ukrajina',
  banner_9: 'Kazachstán',
  brand_awareness_1: 'Povědomí o značce',
  brand_awareness_2: 'a její používání',
  brand_awareness_3:
    'Odemkněte potenciál povědomí o značce a jejího používání pro úspěch vašeho podnikání',
  brand_awareness_4: 'Promluvte si s odborníkem',
  brand_awareness_5: 'O službě',
  brand_awareness_6:
    '<b>Posuďte míru</b> rozpoznatelnosti a znalosti vaší značky',
  brand_awareness_7:
    '<b>Určete úroveň povědomí</b> o značce na vašem cílovém trhu',
  brand_awareness_8: '<b>Pečlivě sledujte</b> míru retence a loajality',
  brand_awareness_9:
    '<b>Zvolte optimální strategii</b> pro zlepšení potřebných ukazatelů',
  brand_awareness_10: 'Objevte široké možnosti našich řešení',
  brand_awareness_11: 'Povědomí o značce',
  brand_awareness_12: 'Používání značky',
  brand_awareness_13:
    '<b>Zjistěte</b> úroveň rozpoznání vaší značky mezi jednotlivými segmenty spotřebitelů',
  brand_awareness_14: '<b>Sledujte</b> úroveň povědomí ve vaší cílové skupině',
  brand_awareness_15:
    '<b>Zkoumejte</b> spontánní myšlenky spotřebitelů před nákupem',
  brand_awareness_16:
    '<b>Pochopte</b> hlavní zdroje, které přispívají k povědomí o vaší značce',
  brand_awareness_17:
    '<b>Zohledněte</b> počet spotřebitelů, kteří vyzkoušeli produkty nebo služby vaší značky',
  brand_awareness_18:
    '<b>Identifikujte</b> spotřebitele, kteří po prvním vyzkoušení zůstali vaší značce věrní',
  brand_awareness_19:
    '<b>Odhalte</b> pravděpodobnost, že bude vaše značka doporučována',
  brand_awareness_20:
    '<b>Zjistěte</b> procento spotřebitelů, kteří zvažují vaši značku pro budoucí využití',
  brand_awareness_21: 'Komu přináší výzkum Brand Awareness and Usage užitek?',
  brand_awareness_22: 'Firmám uvádějícím na trh nový produkt',
  brand_awareness_23: 'Firmám oživujícím zavedenou značku',
  brand_awareness_24:
    'Jakýkoli podnik, který chce pochopit a zlepšit způsob, jakým je jeho značka spotřebiteli vnímána a využívána',
  brand_awareness_25:
    'Naše metodiky poskytují cenné poznatky pro optimalizaci povědomí o značce a jejího využívání',
  brand_awareness_26:
    'Metodika je vybírána individuálně podle požadavků klienta',
  brand_awareness_27: 'Metodika Brand Usage Funnel',
  brand_awareness_28:
    'Míra vyzkoušení (Trial Rate) vyjadřuje podíl publika, které značku zná a vyzkoušelo její produkty nebo služby.',
  brand_awareness_29:
    'Míra opakovaného nákupu (Repeat Rate) udává procento publika, které značku zná, vyzkoušelo její produkty nebo služby a během posledních 12 měsíců pokračovalo v nákupech nebo využívání nabídky.',
  brand_awareness_30:
    'Míra udržení (Retention Rate) ukazuje podíl osob, které pravidelně využívají produkty nebo služby značky, tedy procento těch, kteří je využívali během posledních 6 měsíců.',
  brand_awareness_31:
    'Míra udržení (Retention Rate) znázorňuje procento zákazníků, kteří po využití produktů nebo služeb značky během posledních 6 měsíců nadále volí tuto značku a zůstávají jí dlouhodobě věrní.',
  brand_awareness_32: 'Metodika Brand Awareness',
  brand_awareness_33:
    'Top of Mind (TOM) představuje první značku, kterou respondent spontánně uvede.',
  brand_awareness_34:
    'Celkové spontánní povědomí představuje součet všech spontánních zmínek včetně TOM.',
  brand_awareness_35:
    'Podpořené povědomí (Aided Awareness) ukazuje, jak dobře uživatelé rozpoznají vaši značku po nápovědě.',
  brand_awareness_36: 'Mapa výkonnosti atributů značky',
  brand_awareness_37:
    'Tento nástroj hodnotí a vizuálně znázorňuje význam jednotlivých atributů značky a poskytuje přehled o tom, jak každý z nich přispívá k celkové výkonnosti značky a jejímu vnímání spotřebiteli.',
  brand_awareness_38:
    'Objevte klíče ke zvýšení dopadu vaší značky díky naší komplexní analýze.',
  brand_awareness_39: 'Percepční mapa značek',
  brand_awareness_40:
    'Tento nástroj nabízí vizuální znázornění vnímání spotřebitelů v konkurenčním tržním prostředí. Tento přístup je zásadní pro jasné vymezení rozdílů mezi značkami a zdůraznění klíčových atributů trhu.',
  brand_awareness_41:
    'Usnadňuje sledování a interpretaci vztahů mezi značkami a těmito určujícími charakteristikami.',
  brand_awareness_42:
    'Blízkost konkrétní značky k určitým atributům znamená její silnou spojitost s těmito charakteristikami. Podobně blízkost dvou značek naznačuje jejich podobnost, sdílené vnímání a příslušnost ke stejnému tržnímu segmentu.',
  consumer_journey_map_1: 'Mapa zákaznické cesty',
  consumer_journey_map_2:
    'Objevte a překonejte překážky ve svém podnikání pomocí naší Mapy zákaznické cesty',
  consumer_journey_map_3: 'DŮVĚŘUJÍ NÁM',
  consumer_journey_map_4: '4Service',
  consumer_journey_map_5:
    'Využijte potenciál CJM k optimalizaci interakcí mezi vašimi zákazníky a vaší značkou',
  consumer_journey_map_6:
    'Zjistěte, jaké kroky zákazník podniká před nákupem produktu',
  consumer_journey_map_7:
    'Získejte poznatky od skutečných zákazníků, nikoli domnělých',
  consumer_journey_map_8:
    'Získejte komplexní porozumění zkušenostem svých zákazníků',
  consumer_journey_map_9:
    'Identifikujte nevyužité příležitosti a porovnejte se s konkurencí',
  consumer_journey_map_10: 'Objevte náš přístup k CJM',
  consumer_journey_map_11:
    'Vytváříme mapu interakcí zákazníka s produktem, službou, společností nebo značkou prostřednictvím různých kanálů a v určitém časovém období.',
  consumer_journey_map_12:
    'Mapujeme jednotlivé fáze, kterými zákazníci procházejí před dokončením nákupu, jejich očekávání, emoce a motivace v každé fázi.',
  consumer_journey_map_13: 'Výhody spolupráce s námi',
  consumer_journey_map_14:
    'Poskytujeme tým zkušených odborníků, kteří rozumějí složitostem úspěchu v globálním podnikání',
  consumer_journey_map_15:
    'Jsme odhodláni poskytovat výsledky, které předčí vaše očekávání',
  consumer_journey_map_16:
    'Objevujeme komplexní řešení, která přispívají k vašemu růstu',
  consumer_journey_map_17:
    'Specializujeme se na poskytování přizpůsobených řešení CJM',
  consumer_journey_map_18: 'Objednat konzultaci',
  consumer_journey_map_19: 'Rozhodování založené na datech',
  consumer_journey_map_20:
    'Zakládejte svá rozhodnutí na skutečných datech, nikoli na domněnkách',
  consumer_journey_map_21: 'Optimalizujte své CJM',
  consumer_journey_map_22:
    'Budujte silnější vztahy se zákazníky tím, že budete reagovat na jejich potřeby a očekávání v každé fázi jejich cesty',
  consumer_journey_map_23: 'Buďte o krok napřed',
  consumer_journey_map_24:
    'Porovnejte se s konkurencí a udržte si náskok na trhu',
  consumer_journey_map_25: 'Doporučení',
  consumer_journey_map_26:
    'Implementujte naše doporučení CJM, abyste dosáhli úspěchu, posílili loajalitu zákazníků, zvýšili prodeje a maximalizovali potenciál svého podnikání',
  consumer_journey_map_27:
    'Objevte skutečnou cestu zákazníka s naší Mapou zákaznické cesty',
  consumer_journey_map_28:
    'Odborníci s více než 20 lety zkušeností poskytují komplexní výzkum',
  consumer_journey_map_29:
    'Kvalitativní výzkum zahrnuje sběr a analýzu nečíselných dat za účelem pochopení konceptů, názorů nebo zkušeností.',
  consumer_journey_map_30:
    'Metody kvantitativního výzkumu spočívají v objektivním měření a numerické analýze dat získaných prostřednictvím anket, dotazníků a průzkumů.',
  consumer_journey_map_31:
    'Po shromáždění dat odborníci informace analyzují a vyvozují závěry, aby vám poskytli nejlepší doporučení.',
  boarding_1: 'Mapa zákaznické cesty',
  boarding_2:
    'Customer Journey Mapping (CJM) spočívá v definování cílové skupiny, pochopení jejích potřeb a prostředí a následném vytvoření plánu pro poskytování poutavé zákaznické zkušenosti',
  boarding_3: 'Net Promoter Score',
  boarding_4:
    'Net Promoter Score (NPS) je zlatým standardem metrik zákaznické zkušenosti založeným na jediné otázce: Jak pravděpodobně byste doporučili organizaci/produkt/službu?',
  boarding_5: 'Brand Health Tracking',
  boarding_6:
    'Výzkum Brand Health Tracking (BHT) měří výkonnost vaší značky z hlediska povědomí, používání, positioningu a celkové výkonnosti značky',
  boarding_7: 'Výzkum lidských zdrojů',
  boarding_8:
    'Výzkum lidských zdrojů slouží k hodnocení HR postupů a výkonnosti a poskytuje podrobnou analýzu současného rozvoje a řízení',
  boarding_9: 'UX testování',
  boarding_10:
    'Testování použitelnosti (UX) zkoumá, jak skuteční lidé pracují s webovou stránkou, aplikací nebo jiným produktem, a sleduje jejich chování a reakce',
  boarding_11: 'Index spokojenosti zákazníků',
  boarding_12:
    'Spokojenost zákazníků měří, do jaké míry byla naplněna očekávání zákazníků ohledně nákupu produktu nebo služby poskytované vaší společností',
  boarding_13: 'Testování reklamy',
  boarding_14:
    'Reklamní kampaň je významnou investicí. Ujistěte se, že vaše reklama je účinná a přináší maximální návratnost investic (ROI)',
  boarding_15: 'Terénní audit / Maloobchodní audit',
  boarding_16:
    'Shromažďujte podrobná data o své prodejně nebo značce, analyzujte překážky růstu a vytvářejte účinné strategie k jejich překonání',
  boarding_17: 'Play4Sales',
  boarding_18:
    'Software pro řízení výkonnosti. Gamifikovaná aplikace pro zvýšení prodeje',
  boarding_19: 'Voicer',
  boarding_20:
    'Systém pro správu zpětné vazby. Hlas vašeho zákazníka v jednom systému. Systém pro správu zákaznické zpětné vazby',
  boarding_21: 'Kvalitativní výzkum',
  boarding_22:
    'Kvalitativní výzkum spočívá ve sběru a analýze nečíselných dat za účelem pochopení konceptů, názorů nebo zkušeností',
  boarding_23: 'Kvantitativní výzkum',
  boarding_24:
    'Metody kvantitativního výzkumu představují objektivní měření a numerickou analýzu dat získaných prostřednictvím anket, dotazníků a průzkumů',
  boarding_25: 'Mystery Shopping',
  boarding_26:
    'Mystery Shopping je metoda marketingového výzkumu pro měření a sledování interakcí mezi zákazníkem a společností nebo organizací podle předem definovaného scénáře',
  boarding_27: 'Wantent',
  boarding_28:
    'Platforma pro analýzu obsahu využívající umělou inteligenci, která poskytuje poznatky od publika',
  boarding_29: 'Monitoring cen ',
  boarding_30:
    'Monitoring cen je proces sběru, zpracování a analýzy cen konkurence',
  boarding_31: 'Service Design',
  boarding_32:
    'Service Design spočívá v pochopení potřeb a přání lidí, kteří budou produkt nebo službu používat, prostřednictvím přímé interakce s nimi',
  boarding_33: 'Analýza cen v automobilovém průmyslu',
  boarding_34:
    'Konkurenční cenová analýza optimalizuje nabídku, zvyšuje ziskovost a podíl na trhu využitím dat o ochotě zákazníků platit za identifikaci klíčových vlastností',
  boarding_35: 'Facility Check Audit',
  boarding_36:
    'Zajišťuje, že vaše maloobchodní provozovny odpovídají standardům značky, hodnotí fyzické atributy a jejich vliv na vnímání zákazníky',
  boarding_37: 'CX řešení',
  boarding_38:
    'Objevte naše jedinečné 360° CX řešení: přizpůsobujeme nástroje a služby vašim cílům, abychom podpořili růst vašeho podnikání',
  boarding_39: 'Analýza řeči',
  boarding_40:
    'Náš pokročilý nástroj pro analýzu řeči převádí mluvené slovo na text a poskytuje firmám cenné poznatky pro zlepšení zákaznické zkušenosti, sledování výkonnosti, zajištění souladu s předpisy a podporu růstu',
  boarding_41: 'Usage and Attitude',
  boarding_42:
    'Usage and Attitude je náš přístup k pochopení toho, jak cílové skupiny interagují s vaší značkou prostřednictvím analýzy skutečných vzorců používání a psychologických postojů, což umožňuje vytvářet marketingové a produktové strategie na míru',
  boarding_43: 'Povědomí o značce a její používání',
  boarding_44:
    'Povědomí o značce a její používání zahrnuje hodnocení rozpoznatelnosti, znalosti, četnosti interakcí a loajality na vašem cílovém trhu s cílem zvýšit viditelnost a zapojení zákazníků',
  boarding_45: 'Identita a pozicování značky',
  boarding_46:
    'Identita a pozicování značky představují komplexní analýzu odhalující vnímání značky spotřebiteli, názory různých cílových skupin a poznatky o tom, jak je vaše značka vnímána',
  boarding_47: 'Profilování a segmentace zákazníků',
  boarding_48:
    'Profilování a segmentace zákazníků spočívají v rozdělení cílového trhu do samostatných skupin na základě společných charakteristik, což umožňuje vytvářet personalizované strategie odpovídající konkrétním segmentům publika',
  boarding_49: 'Mapa zákaznické cesty',
  boarding_50:
    'Mapa zákaznické cesty je vizuální znázornění jednotlivých fází, kontaktních bodů, emocí a motivací, které zákazník prožívá během interakce s vaším produktem nebo značkou',
  boarding_51:
    'Seznamte se s inovativními metodami, které jsou základem našeho závazku poskytovat prakticky využitelné poznatky a dosahovat významných výsledků pro vaše podnikání',
  boarding_52:
    'Prozkoumejte naši nabídku produktů s bohatými datově podloženými poznatky přizpůsobenými vašemu odvětví, které vám pomohou činit informovaná rozhodnutí a udržet si náskok před konkurencí',
  boarding_53:
    'Ponořte se do tržních trendů, chování spotřebitelů a konkurenčního prostředí s našimi komplexními řešeními průzkumu trhu',
  boarding_54: 'Ad Hoc výzkum',
  boarding_55:
    'Ad Hoc výzkum je přizpůsobený přístup navržený k řešení konkrétního problému s využitím kombinace stávajících metodik nebo nového přístupu pro vytvoření řešení na míru.',
  boarding_56: 'Sociologický výzkum',
  boarding_57:
    'Sociologický výzkum odhaluje vzorce lidského chování a sociálních interakcí a poskytuje cenné poznatky pro tvorbu inovativních strategií a budování smysluplných vztahů s cílovými skupinami.',
  not_found_1: 'Jejda! Tuto stránku se nám nepodařilo najít.',
  not_found_2: 'Proč si neprohlédnout naše produkty?',
  not_found_3: 'Rezervovat konzultaci',
  customer_profiling_segmentation_1: 'Profilování a segmentace zákazníků',
  customer_profiling_segmentation_2:
    'Pomůžeme vám přesně určit cílovou skupinu, aby byla vaše strategie efektivnější',
  customer_profiling_segmentation_3:
    'Využijte sílu segmentace trhu, aby vaše sdělení vždy efektivně oslovila cílové skupiny zákazníků',
  customer_profiling_segmentation_4: 'Poznejte spotřebitele do hloubky',
  customer_profiling_segmentation_5:
    'Najděte nejlepší cílovou skupinu pro svůj produkt',
  customer_profiling_segmentation_6:
    'Objevte nové segmenty, které můžete oslovit',
  customer_profiling_segmentation_7: 'Odhalte překážky při nákupu',
  customer_profiling_segmentation_8:
    'Specializujeme se na poskytování segmentačních řešení na míru',
  customer_profiling_segmentation_9: 'Jedinečný přístup',
  customer_profiling_segmentation_10:
    'Vyzkoušejte jedinečné segmentační řešení vytvořené přesně podle vašich potřeb',
  customer_profiling_segmentation_11: 'Cílové persony',
  customer_profiling_segmentation_12:
    'Vytváříme cílové persony na základě hloubkové analýzy trhu a komplexního výzkumu',
  customer_profiling_segmentation_13: 'Nové segmenty',
  customer_profiling_segmentation_14:
    'Identifikujte nejcennější segmenty svého publika a využijte výhod cíleného oslovení',
  customer_profiling_segmentation_15: 'Doporučení',
  customer_profiling_segmentation_16:
    'Implementujte naše doporučení a dosáhněte úspěchu, posilte loajalitu zákazníků, zvýšte prodeje a maximalizujte potenciál svého podnikání',
  customer_profiling_segmentation_17:
    'Experti s více než 20 lety zkušeností poskytují komplexní výzkum',
  customer_profiling_segmentation_18:
    'Kvalitativní výzkum zahrnuje sběr a analýzu nečíselných dat za účelem pochopení konceptů, názorů nebo zkušeností.',
  customer_profiling_segmentation_19:
    'Metody kvantitativního výzkumu zahrnují objektivní měření a numerickou analýzu dat získaných prostřednictvím anket, dotazníků a průzkumů.',
  customer_profiling_segmentation_20:
    'Po shromáždění dat naši odborníci informace analyzují a vyvodí závěry, aby vám poskytli nejlepší doporučení.',
  customer_profiling_segmentation_21:
    'Neděláme jen měření, ale poskytujeme vám také akční plán s jasnými kroky krok za krokem',
  customer_profiling_segmentation_22: 'Naše metodologie',
  customer_profiling_segmentation_23: 'Jaccardův index',
  customer_profiling_segmentation_24:
    'Když jsou respondenti dotazováni přímo, jejich odpovědi o preferencích společností nemusí odpovídat jejich skutečnému chování. Místo přímého dotazování využíváme statistickou Jaccardovu analýzu k pochopení vztahu mezi atributy společnosti a volbou spotřebitele.',
  customer_profiling_segmentation_25: 'Klíčové faktory',
  customer_profiling_segmentation_26:
    'Identifikujeme klíčové faktory (vlivy ovlivňující určitý výsledek) a podle jejich významu je rozdělujeme na hlavní, středně významné a méně významné.',
  customer_profiling_segmentation_27: 'Segmentace',
  customer_profiling_segmentation_28:
    'Získáte segmentaci s jasně definovanými charakteristikami zákaznických preferencí.',
  customer_profiling_segmentation_29: 'Náš přístup k segmentaci',
  customer_profiling_segmentation_30: 'Demografická',
  customer_profiling_segmentation_31: 'věk',
  customer_profiling_segmentation_32: 'pohlaví',
  customer_profiling_segmentation_33: 'příjem',
  customer_profiling_segmentation_34:
    'Pomáhá přizpůsobit produkty, služby a marketing konkrétním skupinám, čímž zvyšuje jejich relevanci a efektivitu',
  customer_profiling_segmentation_35: 'Psychografická',
  customer_profiling_segmentation_36: 'životní styl',
  customer_profiling_segmentation_37: 'hodnoty',
  customer_profiling_segmentation_38: 'chování',
  customer_profiling_segmentation_39:
    'Umožňuje personalizovaný marketing, hlubší vztahy se zákazníky a vyšší loajalitu i prodeje společnosti',
  customer_profiling_segmentation_40: 'Behaviorální',
  customer_profiling_segmentation_41: 'jednání',
  customer_profiling_segmentation_42: 'motivace',
  customer_profiling_segmentation_43: 'frekvence nákupů',
  customer_profiling_segmentation_44:
    'Umožňuje cílený marketing, vyšší spokojenost zákazníků, lepší retenci a vyšší ziskovost společnosti',
  customer_profiling_segmentation_45: 'Geografická',
  customer_profiling_segmentation_46: 'lokalita',
  customer_profiling_segmentation_47:
    ' Umožňuje cílený marketing, produkty na míru, efektivní distribuci a vyšší penetraci trhu pro společnost.',
  brands_identity_1: 'Identita a pozicování značky',
  brands_identity_2:
    'Proměňte svou značku pomocí naší hloubkové analýzy, která odhaluje poznatky o vnímání spotřebitelů a pomáhá zdokonalit vaši strategii pro dosažení úspěchu',
  brands_identity_3: 'Promluvte si s odborníkem',
  brands_identity_4: '<b>Objevte komplexní</b> analýzu identity značky',
  brands_identity_5:
    '<b>Prozkoumejte poznatky</b> získané o vnímání spotřebitelů',
  brands_identity_6: '<b>Pochopte různorodé</b> pohledy cílového publika',
  brands_identity_7:
    '<b>Získejte poznatky o</b> chování, zvyklostech a preferencích spotřebitelů pro informovaná rozhodnutí',
  brands_identity_8:
    'Odborníci 4Service s více než 20 lety zkušeností v oblasti zákaznické zkušenosti vytvářejí jedinečná řešení, která pomáhají rozvíjet vaše podnikání',
  brands_identity_9:
    '<b>Získáte přístup k výzkumnému balíčku vybavenému všemi potřebnými daty.</b> Slouží jako diagnostický nástroj, který upozorňuje na silné stránky i oblasti vyžadující pozornost',
  brands_identity_10:
    '<b>Naše služby poskytují firmám potřebné nástroje</b> pro informované rozhodování, zdokonalování strategií a dosažení úspěchu ve svém odvětví.',
  brands_identity_11: 'Pro posílení postavení vaší značky na konkurenčním trhu',
  brands_identity_12: 'Firmy usilující o posílení své pozice na trhu',
  brands_identity_13: 'Firmy, které chtějí zdokonalit svou strategii',
  brands_identity_14: 'Identita značky',
  brands_identity_15: 'Pozicování značky',
  brands_identity_16:
    '<b>Odhalte, jak je vaše značka</b> vnímána v různých segmentech spotřebitelů.',
  brands_identity_17:
    '<b>Identifikujte vlastnosti připisované</b> vaší značce i konkurentům.',
  brands_identity_18:
    '<b>Vyhodnoťte silné</b> a slabé stránky pro strategické zlepšení.',
  brands_identity_19:
    '<b>Posuďte soulad</b> image vaší značky s propagovanými hodnotami.',
  brands_identity_20: '<b>Vyhodnoťte vnímanou</b> důvěryhodnost vaší značky.',
  brands_identity_21:
    '<b>Prozkoumejte archetypální</b> a symbolické vnímání vaší značky.',
  brands_identity_22:
    '<b>Identifikujte jedinečné</b> prodejní výhody a odlišující prvky vaší značky ve srovnání s konkurencí.',
  brands_identity_23:
    '<b>Určete klíčové atributy ovlivňující</b> pravděpodobnost nákupu vašich produktů/služeb spotřebiteli.',
  brands_identity_24:
    '<b>Zjistěte, jak je vaše značka aktuálně vnímána</b> v myslích spotřebitelů, a určete aspekty, které je třeba komunikovat pro oslovení požadovaných segmentů trhu.',
  brands_identity_25:
    'Metodologie je individuálně vybírána podle požadavků klienta',
  brands_identity_26: 'Povědomí o značce a její používání',
  brands_identity_27:
    'Hodnocení úrovně značky zahrnuje měření povědomí a míry využívání, které tvoří základní součást celkového hodnocení.',
  brands_identity_28: 'Plnění hodnot značky a důvěra',
  brands_identity_29:
    'Tato metrika měří ochotu klientů doporučovat značku a její schopnost dlouhodobě plnit své sliby, vytvářet pozitivní zákaznickou zkušenost a budovat důvěru.',
  brands_identity_30: 'Výkonnost image značky',
  brands_identity_31:
    'Hodnocení výkonnosti značky zahrnuje posouzení jejího spojení se šesti klíčovými hodnotami (3 racionálními a 3 emocionálními), její odlišnosti v rámci kategorie a schopnosti vzbuzovat u spotřebitelů pocit hrdosti.',
  brands_identity_32: 'Skóre zdraví značky',
  brands_identity_33:
    'Skóre zdraví značky poskytuje komplexní přehled o tom, jak si vaše značka vede v konkurenčním prostředí.',
  sociological_research_1: 'Sociologický výzkum',
  sociological_research_2:
    'Provádíme hloubkovou analýzu sociálních jevů a procesů, která pomáhá přijímat informovaná rozhodnutí díky jedinečným analytickým závěrům a doporučením.',
  sociological_research_3: 'Kontaktujte nás',
  sociological_research_4: 'Naši klienti',
  sociological_research_5: 'CAWI',
  sociological_research_6:
    'CATI je metoda sběru dat, při níž se k telefonickému dotazování používá počítač. Software CATI umožňuje automatizovat procesy sběru dat, zadávání odpovědí a správu průzkumů. Použití CATI usnadňuje kontrolu průzkumu, umožňuje rychlou analýzu a zpracování dat a zajišťuje vysokou úroveň standardizace výzkumu.',
  sociological_research_7: 'CATI',
  sociological_research_8:
    'CAWI je metoda sběru dat, při níž respondenti vyplňují dotazníky nebo odpovídají na otázky prostřednictvím webového rozhraní a data jsou automaticky shromažďována a zpracovávána pomocí specializovaného softwaru. Metoda CAWI umožňuje realizovat rozsáhlé průzkumy a rychle sbírat i analyzovat data.',
  sociological_research_9: 'CAPI',
  sociological_research_10:
    'CAPI je metoda sběru dat při osobních rozhovorech, při níž výzkumník používá tablet nebo mobilní telefon k zaznamenávání odpovědí respondentů, což umožňuje automatizovaný sběr dat, snižuje počet chyb při zadávání a zjednodušuje analýzu výsledků.',
  sociological_research_11: 'Naši odborníci používají širokou škálu nástrojů',
  sociological_research_12: 'Výběrový soubor',
  sociological_research_13:
    'Počítáme a aplikujeme výběrové soubory jakékoli složitosti',
  sociological_research_14:
    'Ve své práci používáme jednoduché, systematické, stratifikované a shlukové výběry',
  sociological_research_15:
    'Pro celostátně reprezentativní osobní průzkumy používáme stratifikované vícestupňové výběrové postupy',
  sociological_research_16:
    'Výběr sídel podle regionů se provádí podle velikosti a typu sídla, jejich počet je stanoven úměrně jejich zastoupení v jednotlivých regionech',
  sociological_research_17: 'Provádíme',
  sociological_research_18: 'Výzkumy veřejného mínění',
  sociological_research_19: 'Socioekonomické výzkumy',
  sociological_research_20: 'Desk research',
  sociological_research_21: 'Hodnocení kvality sociálních služeb',
  sociological_research_22: 'Případové studie',
  sociological_research_23: 'Personální výzkumy',
  sociological_research_24:
    'Výzkum specifických cílových skupin (zranitelné skupiny, včetně vnitřně vysídlených osob, vojáků, mládeže atd.)',
  sociological_research_25: 'Ke každému klientovi přistupujeme individuálně',
  sociological_research_26: 'Naši klienti:',
  sociological_research_27: 'Charitativní nadace',
  sociological_research_28: 'Veřejné organizace a sdružení',
  sociological_research_29: 'Státní instituce',
  sociological_research_30: 'Náš přístup k práci',
  sociological_research_31:
    'Ve své práci využíváme vědecký přístup, hluboké porozumění současné realitě a různé výzkumné metody pro sběr dat.',
  sociological_research_32:
    'Do řešení konkrétních požadavků zapojujeme vysoce specializované odborníky s potřebnými zkušenostmi a disponujeme týmem expertů z různých oblastí.',
  sociological_research_33:
    'Naše interní analytické oddělení analyzuje shromážděná data pomocí jedinečné sady nástrojů podle specifik daného úkolu.',
  sociological_research_34:
    'Připravujeme zprávy s podrobnými závěry a doporučeními s ohledem na potřeby a očekávání vaší cílové skupiny.',
  sociological_research_35:
    'Poskytujeme poradenství a podporu při zavádění doporučení a pomáháme vám dosahovat pozitivních změn.',
  sociological_research_36: 'Naše výzkumy v televizi',
  sociological_research_37: 'Prohlédněte si naše zprávy',
  sociological_research_38:
    'Náš vědecký přístup zaručuje zákazníkům přesná a spolehlivá sociologická data z celé Ukrajiny i Evropy s minimální mírou odchylky.',
  sociological_research_39:
    'Pracujeme v souladu se všemi etickými principy, standardy a pravidly pro provádění sociologických výzkumů.',
  sociological_research_40:
    'Dodržujeme Kodex profesní etiky sociologů Sociologické asociace Ukrajiny a Helsinskou deklaraci etických principů výzkumu. Jsme členy ESOMAR, Ukrajinské marketingové asociace a Celoukrajinské asociace kontaktních center Ukrajiny.',
  sociological_research_41: 'Terén',
  sociological_research_42: 'online panel',
  sociological_research_43: 'stálí tazatelé',
  sociological_research_44: 'supervizoři',
  sociological_research_45: 'Kontrola kvality terénního sběru dat',
  sociological_research_46: '100% zaznamenávání GPS souřadnic (CAPI)',
  sociological_research_47: 'Validace dotazníků (CAWI, CAPI, CATI, PAPI)',
  sociological_research_48: '100% nahrávání rozhovorů (CAPI, CATI)',
  sociological_research_49: 'Používáme licencovaný software:',
  sociological_research_50:
    'SPSS pro analýzu statistických dat a zpracování datových souborů',
  sociological_research_51:
    'DigSee Sure pro CAPI: logika dotazníků, geolokace, zvukové nahrávky rozhovorů, prezentace video materiálů',
  sociological_research_52:
    'SurveyMonkey pro CAWI: logika dotazníků, pohodlný formát, vizualizace',
  sociological_research_53:
    'VoIPTime (kontaktní centrum): programování dotazníků libovolné složitosti, předávání zvukových nahrávek zákazníkovi',
  sociological_research_54: 'Výběrový soubor',
  sociological_research_55:
    'Počítáme a aplikujeme výběrové soubory jakékoli složitosti',
  sociological_research_56:
    'Ve své práci používáme jednoduché, systematické, stratifikované a shlukové výběry',
  sociological_research_57:
    'Pro celostátně reprezentativní osobní průzkumy používáme stratifikované vícestupňové výběrové postupy',
  sociological_research_58:
    'Výběr sídel podle regionů se provádí podle velikosti a typu sídla, jejich počet je stanoven úměrně jejich zastoupení v jednotlivých regionech',
  sociological_research_59: 'Tým',
  sociological_research_60:
    'Naši sociologové jsou členy Sociologické asociace Ukrajiny',
  sociological_research_61:
    'Máme 12 interních analytiků se zkušenostmi s kvantitativními i kvalitativními projekty v různých odvětvích.',
  sociological_research_62:
    'Máme silný analytický tým profesionálů s více než 10 lety zkušeností ve výzkumu. V našem týmu působí vědci, držitelé titulů Ph.D. i MBI.',
  sociological_research_63: 'Iryna Maksymiuk',
  sociological_research_64:
    'Vedoucí výzkumného oddělení. Více než 15 let zkušeností v marketingovém výzkumu, řízení výzkumných projektů ve všech fázích, přípravě analytických zpráv a prezentací.',
  sociological_research_65: 'Andriy Biloskursky',
  sociological_research_66:
    'Vedoucí oddělení programování a zpracování dat. 20 let zkušeností v marketingovém, sociologickém a tržním výzkumu.',
  sociological_research_67: 'Olena Somova',
  sociological_research_68:
    'Specialistka na programování. Doktorandka sociologie na DonSUU. 5 let zkušeností v marketingovém výzkumu. Členka správní rady Demokratické aliance žen, vedoucí fundraisingu.',
  sociological_research_69: 'Anna Padalka',
  sociological_research_70:
    'Vedoucí oddělení sociologického výzkumu výzkumného oddělení. Má 13 let zkušeností se sociologickými a sociálními projekty na mezinárodní i národní úrovni. Ph.D. v sociologii, vedoucí Výzkumného výboru Ukrajinské asociace kontaktních center.',
  ad_hoc_1: 'Ad Hoc',
  ad_hoc_2: 'Objevte náš alternativní výzkum pro jedinečné případy',
  ad_hoc_3: 'Kontaktujte nás',
  ad_hoc_4: 'Náš přístup',
  ad_hoc_5:
    'Náš tým odborníků pečlivě analyzuje shromážděná data a poskytuje vám komplexní řešení, která podporují růst vašeho podnikání.',
  ad_hoc_6:
    'Navrhujeme jedinečný výzkum přizpůsobený vašim konkrétním požadavkům s využitím široké škály metodik, včetně průzkumů, rozhovorů, fokusních skupin, analýzy dat a dalších.',
  ad_hoc_7: 'Proč si vybrat Ad Hoc Research?',
  ad_hoc_8: 'Flexibilita',
  ad_hoc_9:
    'Žádné dva výzkumné projekty nejsou stejné. Díky Ad Hoc Research máme flexibilitu přizpůsobit a rozvíjet jedinečný přístup podle potřeby, aby vaše poznatky zůstaly relevantní a využitelné.',
  ad_hoc_10: 'Přesnost',
  ad_hoc_11:
    'Přizpůsobením našich metodik vašim jedinečným požadavkům poskytujeme přesné a cílené výsledky s vysokou informační hodnotou.',
  ad_hoc_12: 'Inovace',
  ad_hoc_13:
    'Ve výzkumném procesu podporujeme inovace a kreativitu, zkoumáme nové techniky a přístupy k odhalování skrytých příležitostí i výzev.',
  ad_hoc_14: 'Včasnost',
  ad_hoc_15:
    'Ad Hoc Research umožňuje rychlou realizaci, díky které získáte důležité poznatky včas a udržíte si náskok ve svém odvětví.',
  ad_hoc_16: 'Naše odborné znalosti',
  ad_hoc_17:
    'Odborníci 4Service s více než 20 lety zkušeností v oblasti marketingového výzkumu a zákaznické zkušenosti vytvářejí jedinečná řešení, která pomáhají rozvíjet vaše podnikání',
  ad_hoc_18:
    'Používáme jedinečnou sadu nástrojů podle vašich konkrétních požadavků',
  ad_hoc_19: 'Nevyhovuje vám žádná z metodik?',
  ad_hoc_20: 'Objednejte si Ad Hoc Research',
  ad_hoc_21: 'Přizpůsobeno konkrétnímu problému',
  ad_hoc_22:
    'Používáme jak kombinaci různých částí existujících metodik, tak i zcela nový přístup',
  ad_hoc_23: 'Individuální přístup',
  ad_hoc_24: 'Pečlivě přizpůsobujeme řešení přímo vašemu konkrétnímu problému',
  ad_hoc_25: 'Jděte nad rámec očekávání',
  ad_hoc_26:
    'Poskytujeme akční plán s doporučeními, který pomůže vašemu podnikání dosáhnout stanovených cílů',
  ad_hoc_27: 'Máte nestandardní problém',
  ad_hoc_28: 'Žádná z metodik neodpovídá vašemu problému',
  ad_hoc_29: 'Chcete využít několik různých metodik nebo jejich částí současně',
  ad_hoc_30: 'Kdo může těžit z Ad Hoc výzkumu?',
  service_design_1: 'Někteří z našich klientů',
  service_design_2: 'Service Design',
  service_design_3:
    'Proměňte své podnikání z orientace na produkt a prodej na orientaci na služby a člověka',
  service_design_4: 'Promluvte si s odborníkem',
  service_design_5: 'Učte se zdarma!',
  service_design_6:
    'Shromáždili jsme praktické a užitečné informace v naší knihovně Service Design',
  service_design_7:
    'Knihovna obsahuje podrobné popisy jednotlivých kroků, relevantní nástroje a techniky, tipy na důležité detaily i videoukázky.',
  service_design_8: 'Přejít do knihovny',
  service_design_9: 'Využijte výhody Service Designu!',
  service_design_10:
    'Service Design se zaměřuje na tvorbu a zlepšování služeb prostřednictvím celého ekosystému služeb – lidí, procesů a kontaktních bodů – s cílem zvýšit spokojenost uživatelů i provozní efektivitu',
  service_design_11:
    'Service Design není jen důvod, proč dáváte přednost jedné kavárně před druhou. Je to také důvod, proč se na toto místo znovu a znovu vracíte a doporučujete ho všem svým přátelům.',
  service_design_12: 'Jak může podnikání těžit ze Service Designu',
  service_design_13: 'Spokojenost uživatelů',
  service_design_14:
    'Vytvářejte plynulé a personalizované zážitky, které nadchnou vaše uživatele.',
  service_design_15: 'Provozní efektivita',
  service_design_16:
    'Zefektivněte procesy, snižte náklady a zlepšete poskytování služeb.',
  service_design_17: 'Konzistence značky',
  service_design_18:
    'Zajistěte, aby všechny kontaktní body odpovídaly hodnotám vaší značky.',
  service_design_19: 'Přizpůsobivost změnám',
  service_design_20:
    'Navrhujte služby, které mohou růst a vyvíjet se spolu s měnícími se potřebami.',
  service_design_21: 'Zvyšování loajality',
  service_design_22:
    'Budujte silnější vztahy se zákazníky a posilujte jejich loajalitu prostřednictvím výjimečných zážitků ze služeb.',
  service_design_23: 'Konkurenční výhoda',
  service_design_24:
    'Odlište se na trhu jedinečnými a zapamatovatelnými zážitky ze služeb.',
  service_design_25: 'Proč',
  service_design_26: 'Proč si vybrat Service Design?',
  service_design_27:
    'Je to kultura, metodologie a způsob myšlení, který pomáhá společnostem po celém světě přejít od orientace na produkty a prodej k zaměření na potřeby a problémy lidí.',
  service_design_28: 'Naše služby',
  service_design_29: 'Customer Service Design',
  service_design_30:
    'Vyvíjíme a implementujeme projekty zaměřené na zákazníky s cílem vytvářet nové produkty nebo zlepšovat stávající. Zároveň poskytujeme školení pro budoucí samostatnou práci s těmito změnami.',
  service_design_31: 'Employee Service Design',
  service_design_32:
    'Praktický kurz zaměřený na vývoj a implementaci procesů, struktur a změn orientovaných na zaměstnance ve společnosti.',
  service_design_33: 'Future Design Thinking',
  service_design_34:
    'Vývoj konceptů budoucnosti a strategie společnosti s ohledem na různé scénáře a možné inovace.',
  service_design_35: 'Kreativita v podnikání',
  service_design_36:
    'Praktické školení, které účastníkům pomáhá využívat kreativitu při řešení konkrétních problémů a vytváření jedinečných řešení pro trh.',
  service_design_37: 'Naše workshopy',
  service_design_38:
    'Pořádáme praktické workshopy s mezinárodně uznávanou certifikací pro účastníky',
  service_design_39:
    'Vytvářejte produkty, služby a prostředí, které překonávají očekávání',
  service_design_40: 'Zavádějte efektivní obchodní procesy',
  service_design_41:
    'Harmonizujte vztahy mezi zaměstnanci společnosti a zákazníky',
  service_design_42: 'Kalendář',
  service_design_43: 'Již brzy',
  service_design_44: 'Zjistěte více o našich předchozích akcích',
  service_design_45: 'Základy Service Designu',
  service_design_46:
    'Vytvářejte produkty, služby a prostředí, které překonávají očekávání',
  service_design_47: 'EX Service Design',
  service_design_48:
    'Vytvářejte produkty, služby a prostředí, které překonávají očekávání',
  service_design_49: 'Více',
  service_design_50: 'Náš přístup',
  service_design_51:
    '4Service je pevným základem pro vaše služby zaměřené na člověka!',
  service_design_52:
    'Pomáháme společnostem rozvíjet potřebné myšlení a vytvářet interní prostředí orientované na člověka.',
  service_design_53: 'Nástroje',
  service_design_54:
    'Používáme jedinečný soubor technik a nástrojů podle vašich konkrétních požadavků',
  service_design_55: 'Výzkum uživatelů',
  service_design_56:
    'Rozhovory, průzkumy, F2F a etnografické studie pro pochopení potřeb a chování uživatelů',
  service_design_57: 'Persony',
  service_design_58:
    'Fiktivní postavy představující různé typy uživatelů, které pomáhají při rozhodování o návrhu',
  service_design_59: 'Mapy zákaznické cesty',
  service_design_60:
    'Vizuální znázornění zkušeností uživatele se službou, identifikující klíčové kontaktní body a problematická místa',
  service_design_61: 'Brainstormingové sezení',
  service_design_62:
    'Společná setkání se zainteresovanými stranami za účelem vytváření nápadů a řešení.',
  service_design_63: 'Prototypování',
  service_design_64:
    'Vytváření prvních verzí služby za účelem testování a zdokonalování konceptů',
  service_design_65: 'Service Blueprints',
  service_design_66:
    'Podrobné diagramy znázorňující vztahy mezi jednotlivými součástmi služeb a procesy',
  service_design_67: 'Partner',
  service_design_68: '4Service & DTA',
  service_design_69:
    '4Service je oficiálním výhradním zástupcem Design Thinking Academy',
  service_design_70: 'V rámci našeho partnerství:',
  service_design_71:
    '<b>poskytujeme praktická školení</b> využívající metodu Service Design pod vedením předních odborníků;',
  service_design_72:
    '<b>školíme certifikované</b> specialisty na Design Thinking;',
  service_design_73:
    '<b>realizujeme projekty Service Designu</b> s mezinárodními facilitátory pro mnoho společností.',
  service_design_74: 'Založili jsme Centra excelence Service Design v:',
  service_design_75: 'Ukrajina',
  service_design_76: 'Kazachstán',
  service_design_77: 'Turecko',
  service_design_78: 'Gruzie',
  service_design_79: 'Ázerbájdžán',
  service_design_80: 'Zjistěte více o našich případových studiích',
  service_design_81: 'Přejít do knihovny',
  service_design_82: 'Vítejte ve světě Service Designu!',
  four_opinion_1: 'Průzkumy od 4Service',
  four_opinion_2:
    'Vyplňujte online průzkumy za odměnu a vydělávejte z pohodlí domova',
  four_opinion_3: 'Začít',
  four_opinion_4: 'Naše výhody',
  four_opinion_5: 'Důvěřují nám',
  four_opinion_6:
    'Naše komunita zahrnuje více než 90 000 spotřebitelů na Ukrajině a 100 000 v Kazachstánu',
  four_opinion_7: 'Spravedlivě si vážíme vašeho času',
  four_opinion_8:
    'Vážíme si vašeho času, proto za účast v průzkumech máte možnost získat dárek nebo finanční odměnu',
  four_opinion_9: 'Váš názor má významný dopad',
  four_opinion_10:
    'Každý váš komentář pomáhá značkám lépe porozumět potřebám jejich zákazníků',
  four_opinion_11:
    'Vyplňujte průzkumy na 4Opinion od 4Service a vydělávejte online nebo vyhrajte cenu',
  four_opinion_12: 'Připojte se k 4Opinion',
  four_opinion_13: 'Ještě více zajímavých příběhů na našem kanálu',
  four_opinion_14: 'Více informací pro Ukrajinu',
  four_opinion_15: 'Více informací pro Kazachstán',
  four_opinion_16: 'Proč si vybrat právě nás?',
  four_opinion_17:
    '4Service je mezinárodní výzkumný holding specializující se na řízení zákaznické zkušenosti',
  four_opinion_18:
    'Patříme mezi 10 nejlepších evropských agentur v oblasti řízení zákaznické zkušenosti',
  four_opinion_19:
    'Naším posláním je zlepšovat zákaznický servis po celém světě!',
  four_opinion_20: 'Jak začít vydělávat na online průzkumech?',
  four_opinion_21: 'Zaregistrujte se na webu',
  four_opinion_22: 'Dostávejte oznámení o dostupných průzkumech',
  four_opinion_23: 'Vyplňujte průzkumy a vydělávejte',
  four_opinion_24: 'Skutečné recenze našich respondentů',
  four_opinion_25: 'Vitaliy Kokhan',
  four_opinion_26:
    '„Vyplnil jsem průzkum a úplně jsem na něj zapomněl. Po nějaké době mi zavolala paní Nataliya a oznámila mi, že jsem vyhrál cenu. A tady je – můj Samsung Galaxy M52 5G. Moc děkuji😁“',
  four_opinion_27: 'Viktoriya Popovska',
  four_opinion_28:
    '„Obdržela jsem reproduktor, moc děkuji za poctivou, férovou a skvělou soutěž.“',
  four_opinion_29: 'Yuliya Oleksandrivna',
  four_opinion_30:
    '„Tohle je asi ta nejúžasnější věc, která se mi v poslední době stala💕 Nejenže jsem vyhrála, ale dostala jsem i něco opravdu skvělého. Čekala jsem cokoliv, ale ani ve snu mě nenapadlo, že to bude tak úžasné. Ještě jednou obrovské díky!“',
  four_opinion_31:
    'Jen u nás máte možnost vydělat skutečné peníze nebo vyhrát hodnotnou cenu',
  four_opinion_32: 'Sledujte dostupné průzkumy na našem kanálu',
  four_opinion_33: 'Přejít na kanál',
  career_1: 'Staňte se součástí',
  career_2: '4Service',
  career_3:
    'Těšíme se na vás v týmu s neomezenými možnostmi neustálého profesního růstu!',
  career_4: 'Volná pracovní místa',
  career_5: 'Nenašli jste vhodnou pozici?',
  career_6: 'Pošlete nám svůj životopis a my se vám ozveme!',
  career_7: 'Odeslat životopis',
  career_8: 'Registrační formulář',
  career_9: '*Jméno',
  career_10: '*Příjmení',
  career_11: '*E-mail',
  career_12: '*Telefonní číslo',
  career_13: 'Nahrát životopis',
  career_14: 'Odeslat',
  career_15: 'Začněte svou kariéru ve 4Service',
  career_16: 'Hlavní úkoly:',
  career_17: 'Požadavky:',
  career_18: 'Nabízíme:',
  career_19: 'Přihlásit se',
  career_20: '4Service je mezinárodní výzkumný holding',
  career_21: 'Působíme od roku 2001',
  career_22: 'O nás',
  career_23: 'Rozvíjíme firemní kulturu',
  career_24: 'Naše iniciativy',
  career_25: 'Zlepšujeme zákaznický servis po celém světě',
  career_26: 'Volná místa ve 4Service',
  career_27: 'Vaše příležitosti s 4Service',
  career_28:
    'Podpora duševního zdraví prostřednictvím týdenních setkání „Morning Coffee“, teambuildingů a společenských iniciativ',
  career_29:
    'Zajímavé pracovní zkušenosti s nejznámějšími světovými značkami, jako jsou: <span>Mercedes, Huawei, Philip Morris</span>',
  career_30:
    'Nepřetržitý profesní rozvoj prostřednictvím seminářů, školení a workshopů',
  career_31: 'Role mystery shoppera a možnost ovlivnit rozvoj známých značek',
  career_32:
    'Spolupráce odkudkoliv na světě a možnost pracovat na dálku nebo v kanceláři v: <span>Ukrajině, Kazachstánu, Rumunsku, Rakousku, Ázerbájdžánu a Gruzii</span>',
  career_33:
    'Rozvoj vlastní značky prostřednictvím účasti na akcích, webinářích a networkingových setkáních',
  career: 'Kariéra',
  footer_btn_1: 'Staňte se Mystery Shopperem',
  footer_btn_2: 'Účastněte se placených průzkumů',
  diary_study_1: 'Diary',
  diary_study_2: 'Study',
  diary_study_3:
    'Sledujte a shromažďujte poznatky o tom, jak se v průběhu času mění uživatelské zkušenosti a životní styl',
  diary_study_4: 'Promluvte si s odborníkem',
  diary_study_5: 'Kontaktujte nás',
  diary_study_6: 'Začněte',
  diary_study_7:
    'Objednejte si Diary Study a získejte komplexní přístup ke kvalitativním i kvantitativním datům, která přinášejí cenné poznatky o chování spotřebitelů, trendech na trhu a výkonnosti značky',
  diary_study_8:
    'Studium životního stylu a uživatelské zkušenosti v průběhu času',
  diary_study_9:
    'Diary Study poskytuje hloubkové kontextové poznatky o interakcích uživatelů a pomáhá odhalit vzorce a změny, které by jiné metody nemusely zachytit.',
  diary_study_10:
    'Tato metoda umožňuje sběr dat v reálném čase v přirozeném prostředí, čímž výrazně zvyšuje jejich spolehlivost a relevanci',
  diary_study_11: 'Poskytujeme',
  diary_study_12: 'Poskytujeme individuálně přizpůsobené Diary Studies',
  diary_study_13: 'Zapojení spotřebitelů',
  diary_study_14:
    'Vytváříme online komunity, ve kterých účastníci průběžně zaznamenávají své chování, aktivity a zkušenosti ve svém každodenním prostředí.',
  diary_study_15: 'Průzkum trhu',
  diary_study_16:
    'Náš přístup zahrnuje hloubkový průzkum trhu, který poskytuje relevantní a hodnotná data odpovídající konkrétním potřebám našich klientů.',
  diary_study_17: 'Poznatky o značce',
  diary_study_18:
    'Podrobně analyzujeme vnímání a chování spotřebitelů, abychom odhalili cenné poznatky, které pomáhají formovat strategie značky.',
  diary_study_19: 'Odborníci',
  diary_study_20:
    'Odborníci 4Service s více než 20 lety zkušeností v oblasti zákaznické zkušenosti vytvářejí jedinečná řešení, která pomáhají rozvíjet vaše podnikání',
  diary_study_21: 'Řízení projektů',
  diary_study_22:
    'Náš tým poskytuje komplexní podporu projektového řízení a zajišťuje pečlivé plánování i bezproblémovou realizaci všech etap projektu.',
  diary_study_23: 'Poradenství',
  diary_study_24:
    'Poskytujeme odborné poradenství v každé fázi projektu, pomáháme řešit výzvy a optimalizovat výsledky.',
  diary_study_25: 'Zajištění kvality',
  diary_study_26:
    'Dodržujeme přísné standardy kvality v každé fázi projektu, abychom zajistili výsledky, které splní i překonají očekávání.',
  diary_study_27: 'Výhody',
  diary_study_28: 'Výhody spolupráce s námi',
  diary_study_29: '<b>Neomezený zdroj</b> poznatků v průběhu času',
  diary_study_30: '<b>Odborné vedení</b> v každé fázi procesu',
  diary_study_31: '<b>Propojujeme firmy</b> se spotřebiteli po celém světě',
  diary_study_32:
    '<b>Pohodlný sběr dat</b> díky podrobné zpětné vazbě a odpovědím',
  diary_study_33: '<b>Dostupná data</b> v každé fázi projektu',
  diary_study_34: '<b>Komplexní řešení</b>, která přispívají k vašemu růstu',
  diary_study_35: 'Výzkum',
  diary_study_36:
    'Získejte individuálně přizpůsobený kvantitativní výzkum s jedinečnými poznatky',
  shoppers_1: 'Platforma',
  shoppers_2: 'Mystery Shopperů',
  shoppers_3: 'Připojit se',
  shoppers_4: 'Hodnoťte služby a vydělávejte s 4Service',
  shoppers_5: 'Začněte svou kariéru ve 4Service',
  shoppers_6: 'Čeká na vás práce na zajímavých projektech',
  shoppers_7: 'Připojit se',
  shoppers_8: 'Připojte se k našemu týmu',
  shoppers_9: 'Zjistit více ›',
  shoppers_10: 'Supervizor',
  shoppers_11:
    'Vedoucí, který řídí práci týmu, odpovídá za plánování, koordinaci práce, kontrolu kvality a řešení organizačních záležitostí a zajišťuje plnění stanovených úkolů.',
  shoppers_12: 'Mystery Shopper',
  shoppers_13:
    'Specialista, který navštěvuje obchody, restaurace nebo jiná zařízení podle předem stanoveného scénáře a následně podává zprávu o svých dojmech.',
  shoppers_14: 'Merchandiser',
  shoppers_15:
    'Specialista, který zajišťuje vystavení zboží v obchodech v souladu se standardy značky nebo společnosti.',
  shoppers_16: 'Auditor',
  shoppers_17:
    'Specialista, který kontroluje činnost z hlediska dodržování stanovených standardů a požadavků.',
  shoppers_18: 'Tester',
  shoppers_19:
    'Specialista, který hodnotí kvalitu služeb, produktů nebo procesů z pohledu zákazníka, posuzuje jejich soulad s očekáváními spotřebitelů a odhaluje možné problémy.',
  shoppers_20: 'Mystery uchazeč',
  shoppers_21:
    'Specialista, který analyzuje proces zákaznické obsluhy, hodnotí kvalitu komunikace, rychlost reakce, pohodlí postupů a celkový dojem z interakce.',
  shoppers_22: 'Promotér',
  shoppers_23:
    'Specialista, který propaguje produkty prostřednictvím jejich prezentace, distribuce reklamních materiálů, organizace promoakcí a odpovídání na dotazy zákazníků.',
  shoppers_24: 'Účastník rozhovoru',
  shoppers_25:
    'Účastník hloubkového rozhovoru se zapojuje do podrobného výzkumu zaměřeného na odhalení jeho názorů, emocí, motivací nebo zkušeností týkajících se určitého tématu, produktu či služby.',
  shoppers_26: 'Staňte se součástí 4Service',
  shoppers_27: 'Působíme <b>po celém světě</b>',
  shoppers_28: 'Náš tým tvoří <b>více než 1000 profesionálů</b>',
  shoppers_29: 'Máme <b>více než 20 let úspěšných zkušeností</b> na trhu',
  shoppers_30: 'Pokyny',
  shoppers_31: 'Jak pořídit zvukový záznam návštěvy',
  shoppers_32: 'Jak pořídit zvukový záznam hovoru',
  shoppers_33: 'Nedaří se připojit zvukový soubor k dotazníku?',
  shoppers_34: 'Kodex profesních standardů a etiky MSPA pro mystery shoppery',
  shoppers_35: 'F.A.Q.',
  shoppers_36: 'Často kladené otázky',
  shoppers_37: 'Kolik lze vydělat za měsíc?',
  shoppers_38: 'Jak často mohu plnit úkoly ve svém městě?',
  shoppers_39:
    'Co dělat, pokud je provozovna zavřená, a jaká je odměna za takovou návštěvu?',
  shoppers_40: 'Jak probíhá vyplacení odměny?',
  shoppers_41: 'Jaké jsou termíny vyplacení odměny?',
  shoppers_42: 'Na koho se obrátit s dotazy ohledně vyplacení odměny?',
  shoppers_43:
    'Výše vaší měsíční odměny závisí na intenzitě, s jakou plníte úkoly.',
  shoppers_44:
    'Odměna za splnění jednoho úkolu se může pohybovat od 40 UAH za jednoduché návštěvy a hovory až po 1200 UAH za komplexní a prémiové návštěvy. Záleží na složitosti a specifikách projektu.',
  shoppers_45:
    'Plnění úkolů se pro vás může stát příjemným koníčkem, který můžete spojit se svými každodenními nákupy nebo návštěvami kaváren, pizzerií a restaurací s přáteli.',
  shoppers_46: 'počtu provozoven a rozsahu projektů;',
  shoppers_47:
    'rotace (návštěva stejné provozovny nejvýše jednou za tři měsíce / čtvrtletí);',
  shoppers_48: 'míry souladu vašeho profilu / dovedností s požadavky projektu;',
  shoppers_49: 'rychlosti podání přihlášky.',
  shoppers_50: 'Pokud je provozovna, kterou kontrolujete:',
  shoppers_51:
    'Zavřená – vyfoťte vstupní dveře, oznámení o důvodu uzavření (pokud je k dispozici), provozní dobu a průčelí provozovny s adresou.',
  shoppers_52:
    'Na uvedené adrese se nenachází – pořiďte VIDEOZÁZNAM okolí a fotografii průčelí sousední budovy s uvedenou adresou. Poté kontaktujte svého koordinátora.',
  shoppers_53:
    'Odměna je vyplácena na kartu banky PrivatBank určenou pro fyzické osoby.',
  shoppers_54:
    'S termíny vyplacení odměny se můžete seznámit ve svém osobním účtu.',
  shoppers_55:
    'Můžete se také obrátit na svého koordinátora nebo kontaktovat podporu Mystery Shopperů na adrese: ua@4service.support. Do předmětu e-mailu uveďte název projektu, kterého se váš dotaz týká.',
  shoppers_56:
    'Obecné termíny vyplacení odměny jsou uvedeny ve vašem osobním účtu na stránce „Hlavní stránka“.',
  shoppers_57:
    'Pokud jste odměnu neobdrželi a termín již uplynul, proveďte ve svém osobním účtu následující kroky:',
  shoppers_58:
    '1. Zkontrolujte, zda jsou všechny vaše osobní údaje vyplněny a žádné pole nezůstalo prázdné;',
  shoppers_59:
    '2. Ověřte, že údaje o vaší platební kartě jsou správné a platnost karty nevypršela;',
  shoppers_60:
    '3. Ujistěte se, že je uvedena bankovní karta určená pro fyzické osoby;',
  shoppers_61:
    '4. Vaše celé jméno v systému odpovídá jménu uvedenému na vaší kartě (bez chyb).',
  shoppers_62:
    'Pokud jste vše zkontrolovali a údaje jsou správné, obraťte se na podporu Mystery Shopperů na adrese: ua@4service.support. Do předmětu e-mailu uveďte název projektu, kterého se váš dotaz týká.',
  shoppers_63: 'Aplikace pro <br /> mystery shoppery',
  shoppers_64: 'Stáhněte si aplikaci 4Soppers:',
  shoppers_65: 'nebo',
  shoppers_66: 'Kontaktujte nás',
  shoppers_67: 'Chat s podporou',
  shoppers_68: 'Telefon:',
  shoppers_69: 'E-mail:',
  shoppers_70: 'Máte ještě otázky?',
  shoppers_71: 'Podpora <br /> terénních pracovníků',
  shoppers_72: 'Kontaktovat',
  shoppers_73: 'Podpora terénních pracovníků',
  shoppers_74:
    'Dotazy týkající se návštěv, plateb a dalších aspektů práce mystery shoppera',
  shoppers_75: 'Souhlasím se zpracováním osobních údajů v souladu s',
  shoppers_76: 'Vaše celé jméno',
  shoppers_77: 'Popis problému',
  shoppers_78: 'Vaše přihlašovací jméno',
  shoppers_79: 'Kontaktní telefon',
  shoppers_80: 'Termíny plateb',
  shoppers_81: 'Jiné',
  shoppers_82: 'Kontaktujte nás',
  employee_experience_1: 'Employee Experience',
  employee_experience_2: 'Úspěch vašeho podnikání začíná Employee Experience',
  employee_experience_3: 'Kontaktujte nás',
  employee_experience_4: 'Váš příběh úspěchu začíná zde',
  employee_experience_5:
    'Odborníci 4Service s více než 20 lety zkušeností v oblasti průzkumu trhu a zákaznické zkušenosti vytvářejí jedinečná řešení, která pomáhají rozvíjet vaše podnikání.',
  employee_experience_6:
    'Naše služby poskytují firmám potřebné nástroje pro informované rozhodování, zdokonalování strategií a dosažení úspěchu ve svém oboru.',
  employee_experience_7:
    'Vybereme ideální metodologii pro vaše konkrétní potřeby',
  employee_experience_8: 'Employee Journey Map',
  employee_experience_9:
    'Mapujeme celý životní cyklus zaměstnance – od náboru až po odchod – a identifikujeme klíčové kontaktní body, které ovlivňují jeho zkušenost. To pomáhá odhalit oblasti ke zlepšení a příležitosti ke zvýšení spokojenosti a angažovanosti v každé fázi.',
  employee_experience_10: 'Employee Journey Map s benchmarkingem',
  employee_experience_11:
    'Mapování cesty zaměstnance posouváme o krok dál porovnáním zkušeností vašich zaměstnanců s oborovými standardy. Pomůže vám identifikovat způsoby zjednodušení interních procesů, zvýšení loajality zaměstnanců a zavedení osvědčených postupů.',
  employee_experience_12: 'Průzkum zdraví značky zaměstnavatele',
  employee_experience_13:
    'Posuzujeme, jak vaši zaměstnanci vnímají značku vaší společnosti zevnitř. Silná interní značka vede k motivovanějším a loajálnějším zaměstnancům, což se promítá do lepší interakce se zákazníky a lepší externí reputace.',
  employee_experience_14: 'Employee Net Promoter Score (eNPS)',
  employee_experience_15:
    'Pomocí eNPS měříme, s jakou pravděpodobností by vaši zaměstnanci doporučili vaši společnost jako skvělé místo pro práci. Tento jednoduchý, ale účinný ukazatel poskytuje přehled o celkové spokojenosti a loajalitě zaměstnanců.',
  employee_experience_16:
    'Index angažovanosti a spokojenosti zaměstnanců (ECSI)',
  employee_experience_17:
    'Naše metodologie ECSI hodnotí, jak jsou vaši zaměstnanci angažovaní a spokojení se svou prací i společností. Pomáhá určit úroveň jejich zapojení a oblasti, kde lze zvýšit retenci.',
  employee_experience_18:
    'Hloubkové rozhovory se současnými i bývalými zaměstnanci',
  employee_experience_19:
    'Vedeme rozhovory s bývalými zaměstnanci, abychom zjistili důvody jejich odchodu a možnosti zvýšení retence. Rozhovory se současnými zaměstnanci odhalují způsoby, jak zlepšit zákaznický servis, zvýšit angažovanost a odstranit překážky při dosahování KPI.',
  employee_experience_20: 'Analýza UGC',
  employee_experience_21:
    'Analýza uživatelsky vytvářeného obsahu (UGC) probíhá sběrem recenzí ze specializovaných webů, sociálních sítí, fór a video platforem. Tato analýza vám pomůže porozumět skutečným očekáváním a problémům zákazníků, identifikovat trendy a změny ve spotřebitelských preferencích a určit silné i slabé stránky vaší značky ve srovnání s konkurencí.',
  employee_experience_22: 'Mystery Employee',
  employee_experience_23:
    'Mystery Employee je hodnocení společnosti z pohledu potenciálního zaměstnance. Posuzuje, jak dobře jsou organizovány interní procesy, jak stávající zaměstnanci komunikují s uchazeči a jak důsledně společnost dodržuje své standardy služeb a komunikace.',
  employee_experience_24: 'Motivační návštěvy',
  employee_experience_25:
    'Motivační návštěvy odměňují zaměstnance, kteří splňují standardy služeb, například vynikající komunikaci se zákazníky nebo úspěšný upselling. Mystery Shoppeři identifikují nejlepší pracovníky, čímž podporují jejich motivaci a inspirují ostatní k dosažení ocenění a odměn.',
  employee_experience_26: 'Service Design',
  employee_experience_27:
    'Pomocí Service Design identifikujeme obchodní výzvy a odhalujeme inovativní řešení, vytváříme strategie, které zlepšují poskytování služeb a reagují na potřeby zákazníků i zaměstnanců.',
  employee_experience_28: 'HR výzkum',
  employee_experience_29:
    'HR výzkum pomáhá měřit, jak dobře jsou zaměstnanci v souladu s posláním a hodnotami společnosti a jak efektivně je komunikují zákazníkům.',
  employee_experience_30: 'Spoluvytváření se zaměstnanci (fokusní skupiny)',
  employee_experience_31:
    'Zapojením zaměstnanců přímo organizujeme spoluvytvářecí fokusní skupiny za účelem získání zpětné vazby a cenných poznatků. Tento společný proces umožňuje zaměstnancům podílet se na utváření svého pracovního prostředí a posiluje pocit odpovědnosti i angažovanosti.',
  employee_experience_32: 'Proč investovat do Employee Experience?',
  employee_experience_33: 'Snižte fluktuaci zaměstnanců',
  employee_experience_34:
    'Udržte si své nejlepší talenty vytvořením pracovního prostředí, ve kterém chtějí zaměstnanci zůstat a rozvíjet se.',
  employee_experience_35: 'Zvyšte loajalitu zaměstnanců',
  employee_experience_36:
    'Budujte dlouhodobý závazek a oddanost svých zaměstnanců, čímž snížíte náklady na opakovaný nábor.',
  employee_experience_37: 'Plynulé přizpůsobení změnám',
  employee_experience_38:
    'Snižte odpor vůči novým pravidlům a iniciativám a zajistěte hladší průběh změn ve vaší společnosti.',
  employee_experience_39: 'Zvyšte produktivitu',
  employee_experience_40:
    'Pomozte svému týmu přijmout nové procesy a dosahovat lepších výsledků ve svých rolích.',
  employee_experience_41: 'Snižte náklady na podnikání',
  employee_experience_42:
    'Optimalizujte procesy, což povede ke snížení nákladů a zvýšení příjmů.',
  employee_experience_43: 'Skvělá EX podporuje růst podnikání',
  employee_experience_44:
    'Employee Experience (EX) zahrnuje vše, s čím se zaměstnanci během své cesty ve společnosti setkávají a co při tom prožívají.',
  employee_experience_45:
    'Pozitivní EX podporuje sladění se cíli společnosti, zvyšuje motivaci a posiluje angažovanost.',
  employee_experience_46:
    'Spokojení a angažovaní zaměstnanci poskytují výjimečné služby, což vede ke spokojeným zákazníkům a udržitelnému růstu.',
  employee_experience_47:
    'Investice do EX vytváří pozitivní řetězový efekt – lepší retenci zaměstnanců, vyšší produktivitu a silnější obchodní výsledky.',
  employee_experience_48: 'Vaše EX + CX přímo ovlivňují vaše podnikání',
  employee_experience_49:
    'Employee Experience (EX) a Customer Experience (CX) jdou ruku v ruce. Spokojený tým s větší pravděpodobností poskytuje vynikající služby, což vede k vyšší spokojenosti zákazníků. Díky našemu integrovanému přístupu k EX a CX můžete sladit interní firemní kulturu s excelentní zákaznickou zkušeností.',
  employee_experience_50:
    'Propojením poznatků o zkušenostech zaměstnanců a zákazníků poskytujeme komplexní přístup ke zlepšení obou oblastí. Výsledkem je silnější a soudržnější firemní kultura, která podporuje obchodní úspěch.',
  employee_experience_51: 'Spokojený zaměstnavatel',
  employee_experience_52: 'Vynikající služby',
  employee_experience_53: 'Spokojený zákazník',
  cati_1: 'CATI',
  cati_2: 'Efektivní telefonické průzkumy s podporou počítače',
  cati_3: 'Kontaktujte nás',
  cati_4: 'Důvěřují nám',
  cati_5:
    '<b>CATI (Computer Assisted Telephone Interviewing)</b> je metoda sběru dat prostřednictvím telefonických průzkumů, při níž operátoři pracují se specializovaným softwarem pro zaznamenávání odpovědí, zajištění logiky dotazníku a analýzu výsledků.',
  cati_6: 'Hlavní výhody CATI od 4Service:',
  cati_7: '<b>Rychlost</b> realizace průzkumů',
  cati_8: '<b>Vysoká kvalita dat</b>',
  cati_9: '<b>Flexibilita</b> při přizpůsobení dotazníku',
  cati_10: '<b>Automatizace</b> procesu',
  cati_11: 'Široká <b>škála nástrojů</b> pro kontrolu kvality',
  cati_12: 'Možnost dotazovat <b>obtížně dostupné skupiny</b> respondentů',
  cati_13: '<b>Nahrávání</b> všech <b>hovorů</b> pro následnou kontrolu',
  cati_14: 'Možnost rychle <b>oslovit rozsáhlou cílovou skupinu</b>',
  cati_15:
    '<b>Nákladově efektivnější</b> metoda ve srovnání s jinými způsoby sběru dat',
  cati_16: 'Řeší',
  cati_17: 'Jaké úkoly lze řešit pomocí telefonických průzkumů:',
  cati_18:
    '<span>Výzkum segmentace trhu.</span> Identifikace různých skupin spotřebitelů pro přesné cílení a efektivní marketingové strategie.',
  cati_19:
    '<span>Hodnocení spokojenosti zákazníků.</span> Měření loajality zákazníků k produktům a službám pomocí ukazatelů SCI a NPS.',
  cati_20:
    '<span>Řízení NPS a implementace akčního plánu.</span> Využití telefonických průzkumů k aktivnímu zlepšování zákaznické zkušenosti prostřednictvím kontaktního centra.',
  cati_21:
    '<span>Analýza poptávky a tržních trendů.</span> Zkoumání oblíbenosti produktů a služeb, identifikace perspektivních regionů a směrů růstu.',
  cati_22:
    '<span>Analýza konkurenčního prostředí.</span> Hodnocení postavení značky na trhu, porovnání s konkurencí a identifikace příležitostí k růstu.',
  cati_23: 'Pro koho',
  cati_24: 'CATI je ideální pro:',
  cati_25: 'Společnosti uvádějící nový produkt na trh',
  cati_26:
    'Pro získávání aktuálních tržních dat, analýzu konkurenčního prostředí a zkoumání spotřebitelských preferencí.',
  cati_27: 'Značky a společnosti pracující se zákazníky',
  cati_28:
    'Pro hodnocení úrovně spokojenosti zákazníků (Customer Satisfaction, NPS), analýzu potřeb a získávání zpětné vazby.',
  cati_29: 'Maloobchod a e-commerce',
  cati_30:
    'Pro pochopení spotřebitelského chování, testování nových produktů a identifikaci faktorů ovlivňujících nákupní rozhodnutí.',
  cati_31: 'Banky a finanční instituce',
  cati_32:
    'Pro hodnocení kvality služeb, měření důvěry ve společnost a získávání zpětné vazby ke službám.',
  cati_33: 'Společenské organizace',
  cati_34: 'Pro realizaci sociologických výzkumů a analýzu veřejného mínění.',
  cati_35: 'Státní instituce a nevládní organizace',
  cati_36:
    'Pro sběr statistických dat, zkoumání společenských problémů a realizaci výzkumných programů.',
  cati_37: 'Kvalita',
  cati_38: 'Kritéria hodnocení kvality hovorů',
  cati_39: 'Základní komunikační dovednosti',
  cati_40:
    'Dodržování standardů pozdravu a ukončení hovoru, stejně jako přechod na jazyk, který respondentovi vyhovuje.',
  cati_41: 'Styl komunikace',
  cati_42:
    'Přesnost projevu, zdvořilost, přátelský tón a schopnost navázat důvěryhodný vztah s respondentem.',
  cati_43: 'Vedení rozhovoru',
  cati_44:
    'Používání technik aktivního naslouchání, udržení zájmu respondenta a efektivní vedení dialogu.',
  cati_45: 'Znalost tématu',
  cati_46:
    'Hloubkové porozumění tématu průzkumu a schopnost správně odpovídat na doplňující otázky respondentů.',
  cati_47: 'Přesnost vyplnění dotazníku',
  cati_48:
    'Přesné zaznamenávání odpovědí bez zkreslení, dodržování pokynů a předcházení chybám při vyplňování dotazníku.',
  cati_49: 'Proč 4Service',
  cati_50: 'Proč si vybrat CATI od 4Service?',
  cati_51:
    'CATI je vhodné pro společnosti, které chtějí získat přesná a strukturovaná data prostřednictvím telefonických průzkumů.',
  cati_52: 'Vlastní kontaktní centrum',
  cati_53:
    'Realizovali jsme více než 70 000 úspěšných hovorů se 100% splněním požadavků klientů.',
  cati_54: 'Záruka kvality',
  cati_55: '100% validace každého hovoru – zajištění přesnosti dat.',
  cati_56: 'Individuální přístup',
  cati_57:
    'Vývoj jedinečných dotazníků přizpůsobených konkrétním potřebám klienta.',
  cati_58: 'Pokročilý software',
  cati_59: 'VoIPTime pro realizaci CATI jakékoli složitosti.',
  cati_60: 'Zkušenosti s B2B',
  cati_61:
    'Spolupracujeme s právnickými osobami a dotazujeme přední odborníky z různých oblastí podnikání a průmyslu.',
  cati_62: 'Zašlete nám svou žádost a my pro vás najdeme nejlepší řešení!',
  cati_63: 'Technologie',
  cati_64:
    'Používáme moderní technologie pro analýzu výsledků a rozvoj vašeho podnikání.',
  cati_65: 'Možnosti:',
  cati_66: '<span>VolPtime</span> – profesionální software',
  cati_67: 'Organizace příchozích (hotline) / odchozích automatizovaných linek',
  cati_68:
    'Statistiky podle operátorů, jednotlivých typů dotazů a délky konzultací',
  cati_69: 'Online monitoring provozu kontaktního centra',
  cati_70: 'Nahrávání všech telefonických konzultací',
  cati_71: 'Vzdálená a snadná konfigurace softwaru',
  cati_72:
    '<span>Survey Monkey</span> – profesionální služba pro programování dotazníků',
  cati_73: 'programování dotazníků různé úrovně složitosti',
  cati_74: 's ohledem na všechny potřeby výzkumu',
  cati_75: 'jednoduchost, přehlednost a pohodlí pro respondenty',
  cati_76: 'Kvalita',
  cati_77: 'Hodnocení kvality dialogu se zákazníky',
  cati_78: 'Systém hodnocení založený na kontrolním seznamu',
  cati_79:
    'Kvalita služeb se měří pomocí speciálního kontrolního seznamu, kde pracovníci odpovědní za hodnocení kvality přidělují průměrné skóre za celé sledované období',
  cati_80: 'Ukazatele souladu s cílovými standardy',
  cati_81:
    'Dodržování standardů se hodnotí na základě stanovených úrovní, které nesmí být nižší než 90 %. Tyto ukazatele mohou být upraveny v závislosti na zkušenostech zaměstnance',
  cati_82: 'Monitoring hovorů ze záznamů i v reálném čase',
  cati_83:
    'Přibližně 40 % hovorů je kontrolováno ze záznamů a 20 % v reálném čase, což umožňuje rychle reagovat na případná porušení standardů',
  cati_84: 'Odborníci',
  cati_85: 'Máme vlastní kontaktní centrum',
  cati_86: 'Manažer kontaktního centra',
  cati_87: 'Manažeři náboru',
  cati_88: 'Vzdálené pracoviště na Ukrajině',
  cati_89: 'Vzdálené pracoviště v Kazachstánu',
  cati_90: 'Technický koordinátor',
  cati_91: 'Projektoví manažeři',
  cati_92: 'Projektoví manažeři',
  cati_93: 'Oddělení školení a kontroly kvality',
  cati_94: 'Operátoři – 60 osob (20 % plynně hovoří anglicky)',
  cati_95: 'Operátoři – 20 osob',
  cati_96: 'Vedoucí oddělení kontroly kvality',
  cati_97: 'Specialisté kontroly kvality',
  cati_98: 'Školitelé',
};
